<template>
  <div class="receptionOverflow">
    <div class="billTop">
      <div v-if="searchStatus == 1" class="search">
        <div class="srcoll">
          <el-autocomplete v-show="inputShow == 1" v-model.trim="form.phone" style="width: 260px;" :fetch-suggestions="querySearchAsync" placeholder="请输入手机号码/名称/会员卡号" :clearable="false" popper-class="customerPopper" @keyup.enter.native="memberSearch">
            <i slot="suffix" class="el-icon-search phone_book" @click="memberSearch"></i>
            <template slot-scope="item">
              <div v-if="item.item.list.length > 0">
                <div v-for="(v,n) in item.item.list" :key="n" class="customerList" @click="checkMember(v)">
                  <p>
                    <span>{{ v.customerName || '新增顾客' }}</span>
                    <samp>{{ Lib.starPhone(v.value) }}</samp>
                  </p>
                  <h1>{{ v.cardNo ? ('会员卡号：'+v.cardNo) : '非会员' }}</h1>
                </div>
              </div>
              <div v-else class="noCustomer" @click="showCustomerDialog">
                <p>没有找到顾客信息，点击新增顾客</p>
              </div>
            </template>
          </el-autocomplete>
          <i class="iconfont phone_book new_phone_style" @click="onCheckPhoneBook">&#xe646;</i>
        </div>
      </div>
      <gt-customerInfo v-if="searchStatus == 2 || searchStatus == 3" :member-info="MemberInfo" :search-val="form.phone" :reset-info="resetInfo" :edit="edit" :refresh-data="refreshData"></gt-customerInfo>
      <el-button class="writeOff" plain @click="writeOff">核销</el-button>
      <el-badge :hidden="orderCount ? false : true" :max="999" :value="orderCount" class="torder item">
        <el-button plain @click="takeOrder">取单</el-button>
      </el-badge>
    </div>

    <el-dialog class="takeOrderCss" width="360px" title="核销" :visible.sync="writeOffDia" :append-to-body="true">
      <div class="writeOffDia">
        <img src="static/images/writeOff.png" />
        <p style="text-align: center;color: #999;position: relative;top: -19px;">支持核销电子票码，套餐码</p>
        <el-input ref="refsqp" v-model="paymentCode" v-focus placeholder="使用扫码枪扫码或输入核销码" class="input-with-select scanInput" style="width: 240px !important;float: left;" @keyup.enter.native="paymentCode ? writeOffSubmit() : ''">
        </el-input>
        <el-button type="primary" style="float: left;color: #fff;margin-left: 10px;" :disabled="!paymentCode" @click="paymentCode ? writeOffSubmit() : ''">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog class="takeOrderCss" width="1000px" title="取单" :visible.sync="takeOrderDia" :append-to-body="true">
      <div v-loading="loading">
        <div v-if="toList.length > 0" class="takeOrderList">
          <div v-for="(v,n) in toList" :key="n" class="tolLi">
            <h1>{{ v.customerName || '新增顾客' }}</h1>
            <h2>{{ v.phone ? Lib.starPhone(v.phone) : '--' }}<span>￥{{ (v.orderAmount*1).toFixed(2) || '0.00' }}</span></h2>
            <h3>
              <span>消费项目：</span>
              <el-tooltip effect="light" placement="top" :disabled="tooltipStatus">
                <div slot="content">
                  <samp v-for="(b,m) in v.orderContent" :key="m">{{ b.name }}{{ v.orderType == 5 ? '(' : ' *' }}{{ b.count }}{{ v.orderType == 5 ? ')' : '' }}{{ v.orderContent ? v.orderContent.length == (m+1) ? '' : ',' : '' }}</samp>
                </div>
                <div style="width: 201px;float: right;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;" @mouseover="tooltipStatus = Lib.textShow($event)">
                  <samp v-for="(b,m) in v.orderContent" :key="m">{{ b.name }}{{ v.orderType == 5 ? '(' : ' *' }}{{ b.count }}{{ v.orderType == 5 ? ')' : '' }}{{ v.orderContent ? v.orderContent.length == (m+1) ? '' : ',' : '' }}</samp>
                </div>
              </el-tooltip>
              <samp v-show="v.orderContent ? v.orderContent.length == 0 ? true : false : false">--</samp>
            </h3>
            <h4><span>开单时间：</span>{{ v.createTime || '--' }}</h4>
            <h5 v-if="v.orderType != 6">
              <el-button v-if="(v.orderStatus == 1 && v.orderType != 5) || (v.orderStatus == 1 && v.orderType == 7 && !v.bookAmount)" size="medium" @click="delOrder(v.orderId,v.orderType)">删除</el-button>
              <el-button v-if="v.orderStatus == 1 && v.orderType != 5" size="medium" plain @click="editOrder(v.orderId)">修改</el-button>
              <el-button v-if="v.orderStatus == 1 && v.orderType != 5" size="medium" plain @click="settlementOrder(v.orderId)">结算</el-button>
              <el-button v-if="v.orderStatus == 1 && v.orderType == 5" size="medium" plain @click="onCheckOutOrder(v)">{{ getRoomType==1?'退房':'退位' }}</el-button>
            </h5>
            <h5 v-else>
              <el-button v-if="v.bookStatus== 4" size="medium" plain @click="isConfirm(v.orderId,1)">确认</el-button>
              <el-button v-if="v.bookStatus== 4" size="medium" plain @click="isConfirm(v.orderId,0)">拒绝</el-button>
              <el-button v-if="v.bookStatus== 0 || v.bookStatus== 3" size="medium" plain @click="openBill(v.orderId)">开单</el-button>
              <el-button v-if="v.bookStatus== 0 || v.bookStatus== 3" size="medium" plain @click="cancelBespeak(v.orderId,v.buySource,2)">取消</el-button>
              <el-button v-if="v.bookStatus== 2" size="medium" plain @click="editOrder(v.orderId)">修改</el-button>
              <el-button v-if="v.bookStatus== 2" size="medium" plain @click="settlementOrder(v.orderId)">结算</el-button>
            </h5>
            <h6 v-if="v.orderType == 6">预约</h6>
          </div>
        </div>
        <gt-noneData v-else :title="'暂无订单数据'"></gt-noneData>
      </div>
      <div v-if="toList.length > 0" style="display: table;float: right;">
        <el-pagination background :current-page.sync="toPageNum" :page-size="toPageSize" layout="total, prev, pager, next, jumper" :total="toRowCount" @size-change="toSizeChange" @current-change="toCurrentChange">
        </el-pagination>
      </div>
    </el-dialog>

    <gt-delDig :key="codeNum" @delData="getDelData"></gt-delDig>

    <!--预约取消 /拒绝弹窗-->
    <el-dialog title="提示" :visible.sync="dialogVisible" width="560px" :append-to-body="true">
      <span v-show="diaStatus === 2">确定要取消这条预约吗？</span>
      <span v-show="diaStatus === 0">确认要拒绝这条预约订单吗？</span>
      <p v-if="cancelStatus == 0">已超过预约可退定金时间，若顾客已支付定金/使用了划扣次数，取消订单后，定金/划扣次数将<samp class="themeFC">不会</samp>退回顾客</p>
      <p v-if="cancelStatus == 1">若顾客已支付定金/使用了划扣次数，{{ diaStatus == 2 ? '取消' : '拒绝' }}订单后，定金/划扣次数将退回顾客</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="comfirmCancelBespeak">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 选择权益 -->
    <drawer title="选择优惠权益" status="service" :display.sync="allDisplay">
      <div class="discountRI">
        <h1>{{ chooseInfoRI.listStatus == 1 ? chooseInfoRI.itemName : chooseInfoRI.listStatus == 2 ? chooseInfoRI.productName : chooseInfoRI.vipCardName }}</h1>
        <h2 v-if="chooseInfoRI.listStatus != 3">{{ chooseInfoRI.typeName }}</h2>
        <h2 style="margin-bottom: 10px;">单价：￥{{ chooseInfoRI.price }}</h2>
        <el-tabs v-if="chooseInfoRI.listStatus == 1" v-model="pjdActiveName" type="card">
          <el-tab-pane label="优惠权益" name="first">
            <el-radio v-for="(v,n) in chooseInfoRI.qyList" :key="n" v-model="projectRI" :disabled="checkPqyDisabled(v)" :label="v.type" border @change="qyChange(n,2,1)">
              <h3>{{ v.title }}</h3>
              <h4 v-if="v.title !== '使用改价优惠'">{{ v.info }}</h4>
              <div v-else class="editPriceRI">
                <p><span>项目单价</span><i style="height: 12px;line-height: 12px;"></i><samp>折扣比例</samp></p>
                <p>
                  <span>
                    <el-input v-model="v.rightsPrice" oninput="this.value = this.value.replace(/[^\d\.]|(?<=\d?\.\d?)\.|(?<=\d+\.\d{2})[\d+\.]/g, '')" size="medium" @change="changePrice(1,v)">
                      <template slot="append">元</template>
                    </el-input>
                  </span>
                  <i class="el-icon-sort"></i>
                  <samp>
                    <el-input v-model="v.percentage" oninput="this.value = this.value.replace(/[^\d\.]|(?<=\d?\.\d?)\.|(?<=\d+\.\d{2})[\d+\.]/g, '')" size="medium" @change="changePrice(2,v)">
                      <template slot="append">%</template>
                    </el-input>
                  </samp>
                </p>
              </div>
            </el-radio>
          </el-tab-pane>
          <el-tab-pane :label="chooseInfoRI.bookAmount ? '有定金不可划扣' : '使用划扣'" name="second" :disabled="chooseInfoRI.bookAmount ? true : false">
            <el-radio v-for="(i,j) in chooseInfoRI.package" :key="j" v-model="projectRI" :label="i.clientVipCardId || i.giftId || i.eitemId" border :disabled="checkXmDisabled(i)" @change="qyChange(j,2,2)">
              <h3>{{ i.name }}</h3>
              <h4><span v-for="(a,b) in i.canDeductItemDetailList" v-show="a.dictItemId == chooseInfoRI.dictItemId" :key="b">{{ i.countLimitType == 2 ? '剩余无限' : i.countLimitType == 3 ? ('剩余通用'+i.remaining) : ('剩余'+a.remaining) }}次</span><samp>到期时间：{{ i.expireTime }}</samp></h4>
            </el-radio>
            <gt-noneData v-if="chooseInfoRI.package.length == 0" :title="'暂无可划扣数据'"></gt-noneData>
          </el-tab-pane>
        </el-tabs>
        <el-tabs v-if="chooseInfoRI.listStatus == 2" v-model="pjdActiveName" type="card">
          <el-tab-pane label="优惠权益" name="first">
            <el-checkbox-group v-model="productRI" size="small">
              <div v-for="(v,n) in chooseInfoRI.qyList" :key="n">
                <el-input-number v-model="v.qyCount" size="mini" oninput="this.value = this.value.replace(/[^\d\.]|(?<=\d?\.\d?)\.|(?<=\d+\.\d{0})[\d+\.]/g, '')" :disabled="v.type == 1 || v.type == 2 || checkDisabledCpqy(v)" :min="1" :max="9999" step-strictly @keyup.enter.native="Lib.keyboardBlur" @change="qyChange(n,1,1,v)"></el-input-number>
                <el-checkbox :label="v.type" border :disabled="checkDisabledCpqy(v)" @change="qyChange(n,2,1,v)">
                  <h3>{{ v.title }}</h3>
                  <h4 v-if="v.title !== '使用改价优惠'">{{ v.info }}</h4>
                  <div v-else class="editPriceRI">
                    <p><span>产品单价</span><i style="height: 12px;line-height: 12px;"></i><samp>折扣比例</samp></p>
                    <p>
                      <span>
                        <el-input v-model="v.rightsPrice" oninput="this.value = this.value.replace(/[^\d\.]|(?<=\d?\.\d?)\.|(?<=\d+\.\d{2})[\d+\.]/g, '')" size="medium" @change="changePrice(1,v)">
                          <template slot="append">元</template>
                        </el-input>
                      </span>
                      <i class="el-icon-sort"></i>
                      <samp>
                        <el-input v-model="v.percentage" oninput="this.value = this.value.replace(/[^\d\.]|(?<=\d?\.\d?)\.|(?<=\d+\.\d{2})[\d+\.]/g, '')" size="medium" @change="changePrice(2,v)">
                          <template slot="append">%</template>
                        </el-input>
                      </samp>
                    </p>
                  </div>
                </el-checkbox>
              </div>
            </el-checkbox-group>
          </el-tab-pane>
          <el-tab-pane :label="chooseInfoRI.bookAmount ? '有定金不可划扣' : '使用划扣'" name="second" :disabled="chooseInfoRI.bookAmount ? true : false">
            <el-checkbox-group v-model="productRI" size="small">
              <div v-for="(i,j) in chooseInfoRI.package" :key="j">
                <el-input-number v-model="i.qyCount" size="mini" oninput="this.value = this.value.replace(/[^\d\.]|(?<=\d?\.\d?)\.|(?<=\d+\.\d{0})[\d+\.]/g, '')" :disabled="checkDisabledCphk(i)" :min="1" :max="9999" step-strictly @keyup.enter.native="Lib.keyboardBlur" @change="qyChange(j,1,2)"></el-input-number>
                <el-checkbox :label="i.clientVipCardId || i.giftId || i.eitemId" border :disabled="checkDisabledCphk(i)" @change="qyChange(j,2,2)">
                  <h3>{{ i.name }}</h3>
                  <h4><span v-for="(a,b) in i.canDeductProductDetailList" v-show="a.productId == chooseInfoRI.productId" :key="b">{{ i.countLimitType == 2 ? '剩余无限' : i.countLimitType == 3 ? ('剩余通用'+i.remaining) : ('剩余'+a.remaining) }}次</span><samp>到期时间：{{ i.expireTime }}</samp></h4>
                </el-checkbox>
              </div>
            </el-checkbox-group>
            <gt-noneData v-if="chooseInfoRI.package.length == 0" :title="'暂无可划扣数据'"></gt-noneData>
          </el-tab-pane>
        </el-tabs>
        <el-checkbox-group v-if="chooseInfoRI.listStatus == 3" v-model="packageRI" size="small">
          <div v-for="(v,n) in chooseInfoRI.qyList" :key="n">
            <el-input-number v-model="v.qyCount" size="mini" oninput="this.value = this.value.replace(/[^\d\.]|(?<=\d?\.\d?)\.|(?<=\d+\.\d{0})[\d+\.]/g, '')" :disabled="v.type == 1 || v.type == 2 || checkDisabledTc(v)" :min="1" :max="9999" step-strictly @keyup.enter.native="Lib.keyboardBlur" @change="qyChange(n,1,1,v)"></el-input-number>
            <el-checkbox :label="v.type" border :disabled="checkDisabledTc(v)" @change="qyChange(n,2,1,v)">
              <h3>{{ v.title }}</h3>
              <h4 v-if="v.title !== '使用改价优惠'">{{ v.info }}</h4>
              <div v-else class="editPriceRI">
                <p><span>套餐单价</span><i style="height: 12px;line-height: 12px;"></i><samp>折扣比例</samp></p>
                <p>
                  <span>
                    <el-input v-model="v.rightsPrice" oninput="this.value = this.value.replace(/[^\d\.]|(?<=\d?\.\d?)\.|(?<=\d+\.\d{2})[\d+\.]/g, '')" size="medium" @change="changePrice(1,v)">
                      <template slot="append">元</template>
                    </el-input>
                  </span>
                  <i class="el-icon-sort"></i>
                  <samp>
                    <el-input v-model="v.percentage" oninput="this.value = this.value.replace(/[^\d\.]|(?<=\d?\.\d?)\.|(?<=\d+\.\d{2})[\d+\.]/g, '')" size="medium" @change="changePrice(2,v)">
                      <template slot="append">%</template>
                    </el-input>
                  </samp>
                </p>
              </div>
            </el-checkbox>
          </div>
        </el-checkbox-group>
      </div>
      <div class="footRI">
        <div class="frBtr">
          <el-tooltip effect="light" placement="top" :disabled="tooltipStatus">
            <div slot="content">
              <p style="width: 350px;">{{ getChooseQyinfo(chooseInfoRI) }}</p>
            </div>
            <p @mouseover="tooltipStatus = Lib.textShow($event)">已使用优惠权益：{{ getChooseQyinfo(chooseInfoRI) }}</p>
          </el-tooltip>
          <h6 @click="determineUse(qyIndex)">确定使用</h6>
        </div>
      </div>
    </drawer>

    <div class="billBottom">
      <div class="billBottomLeft">
        <el-radio-group v-model="radioLeft" class="elRg">
          <el-radio-button label="1"><samp>开单</samp></el-radio-button>
          <el-radio-button label="2"><samp>划扣/充值</samp></el-radio-button>
          <el-radio-button label="3"><samp>开卡</samp></el-radio-button>
        </el-radio-group>
        <el-autocomplete v-if="radioLeft == 1" v-model="state" class="sInput" popper-class="my-autocomplete" :fetch-suggestions="querySearch" placeholder="项目/商品/编码/条形码查询" clearable size="small" @select="handleSelect">
          <template slot-scope="item">
            <div v-if="item.item.itemList.length" class="allListClass">
              <h1>项目</h1>
              <p v-for="(v,n) in item.item.itemList" :key="n" @click="addListData(v,1)"><span>{{ v.itemName }}</span><samp>￥{{ v.price }}</samp></p>
            </div>
            <div v-if="item.item.productList.length" class="allListClass">
              <h1>产品</h1>
              <div v-for="(v,n) in item.item.productList" :key="n" class="alcInfo" @click="addListData(v,2)">
                <h5><span>{{ v.productName }}</span><samp>￥{{ v.price }}</samp></h5>
                <h6>属性/规格：{{ v.specification || '--' }}/{{ v.model || '--' }}</h6>
                <h6>编码/条形码：{{ v.productCode }}/{{ v.barCode }}</h6>
              </div>
            </div>
            <div v-if="item.item.packageList.length" class="allListClass">
              <h1>套餐</h1>
              <p v-for="(v,n) in item.item.packageList" :key="n" @click="addListData(v,3)"><span>{{ v.vipCardName }}</span><samp>￥{{ v.price }}</samp></p>
            </div>
            <div v-if="!item.item.itemList.length && !item.item.productList.length && !item.item.packageList.length" class="allListClass">
              <p @click="addListData('',4)">没有找到您要的结果~</p>
            </div>
          </template>
        </el-autocomplete>
        <el-tabs v-if="radioLeft == 1" v-model="activeIndex" class="billTab" @tab-click="handleClick">
          <el-tab-pane label="项目" name="项目">
            <div class="tabContent">
              <div class="tabLeft">
                <div v-for="(item,index) in itemTypeList" :key="index" :class="chooseItemTypeId == item.id ? 'ttChoose themeFC' : 'tlType'" @click="changeProjectType(item.id)">{{ item.name }}</div>
              </div>
              <!-- 需要做加载可以在下面加上v-loading="loading1" -->
              <div v-loading="loadS1" class="tabRight" :class="(serviceList.length == 0 && chooseItemTypeId != 2) ? 'flexMiddle' : ''" @scroll="listenScrollOne">
                <div v-if="chooseItemTypeId == 2" class="acssType">
                  <el-button size="mini" round :plain="actServiceType == '' ? false : true" type="primary" @click="changeAst('')">全部活动</el-button>
                  <el-button size="mini" round :plain="actServiceType == 1 ? false : true" type="primary" @click="changeAst(1)">特价促销</el-button>
                  <el-button size="mini" round :plain="actServiceType == 2 ? false : true" type="primary" @click="changeAst(2)">定时打折</el-button>
                  <el-button size="mini" round :plain="actServiceType == 3 ? false : true" type="primary" @click="changeAst(3)">买赠活动</el-button>
                  <el-button size="mini" round :plain="actServiceType == 4 ? false : true" type="primary" @click="changeAst(4)">满赠活动</el-button>
                </div>
                <div v-for="(v,n) in serviceList" :key="n" class="trProject" @click="addListData(v,1)">
                  <h4>{{ v.itemName }}</h4>
                  <h5 class="themeFC">
                    <b v-if="v.activityInfo" :class="'tipCss tip'+(v.activityInfo ? v.activityInfo.activityType : '')">{{ Lib.getActivity(v.activityInfo.activityType,3) }}</b>
                    ￥{{ v.price }}<el-popover v-show="v.gradeList.length > 0 || v.activityInfo" placement="right" :trigger="uaValue === 'pc' ? 'hover' : 'click'" width="400px">
                      <div v-if="v.activityInfo" class="memberPriceDetails">
                        <h1><span>{{ v.activityInfo.activityName }}</span><positive-time :end-time="v.activityInfo.endDate"></positive-time></h1>
                        <div class="MH">
                          <h5><span>活动类型：</span><samp :style="Lib.getActivity(v.activityInfo.activityType,1)">{{ Lib.getActivity(v.activityInfo.activityType,2) }}</samp></h5>
                          <h5><span>参与人员：</span><samp class="themeFC">{{ v.activityInfo.participationType == 1 ? '全部通用' : '会员参与' }}</samp></h5>
                          <h5 v-if="v.activityInfo.activityType == 1">特价促销<samp class="themeFC">￥{{ v.activityInfo.activityPrice }}</samp><label v-if="v.activityInfo.promotionSaleCount*1 > 9999">，不限购</label><label v-else>，限购<samp class="themeFC">{{ v.activityInfo.promotionSaleCount }}</samp>件</label></h5>
                          <h5 v-else-if="v.activityInfo.activityType == 2"><span>活动周期：</span><samp>{{ getCycle(v.activityInfo.activityDays,v.activityInfo.cycleType) }}</samp></h5>
                          <h6 v-if="v.activityInfo.activityType == 2">
                            <span>优惠时间：</span>
                            <div class="sampLi">
                              <samp v-for="(a,b) in v.activityInfo.lookActivityDiscountTimeList" :key="b">{{ a.startTime }}~{{ a.endTime }}，打<b class="themeFC">{{ a.discount }}</b>折</samp>
                            </div>
                          </h6>
                          <div v-else-if="v.activityInfo.activityType == 3">
                            <h5 v-for="(c,d) in v.activityInfo.lookActivityGivenList" :key="d">{{ c.givenType == 1 ? '买满' : '每买满' }}<span class="themeFC">{{ c.buyNumber }}</span>件送<samp v-for="(x,y) in c.lookActivityGivenConditionList" :key="y">{{ x.activityGiftName }}*{{ x.giftCount }}{{ c.lookActivityGivenConditionList.length == (y+1) ? '' : '，' }}</samp></h5>
                          </div>
                          <div v-else-if="v.activityInfo.activityType == 4">
                            <h5 v-for="(c,d) in v.activityInfo.lookActivityGivenList" :key="d">购买指定商品满<span class="themeFC">{{ c.satisfyPrice }}</span>元送<samp v-for="(x,y) in c.lookActivityGivenConditionList" :key="y">{{ x.activityGiftName }}*{{ x.giftCount }}{{ c.lookActivityGivenConditionList.length == (y+1) ? '' : '，' }}</samp></h5>
                          </div>
                        </div>
                      </div>
                      <div v-show="v.gradeList.length > 0" class="memberPriceDetails">
                        <h1>会员价格</h1>
                        <div class="MH">
                          <p v-for="(a,b) in v.gradeList" :key="b">
                            <label>￥<samp>{{ Lib.getValue(1,(a.discountType == 1 ? a.number : (a.number*v.price/10).toFixed(2))) }}</samp>{{ Lib.getValue(2,(a.discountType == 1 ? a.number : (a.number*v.price/10).toFixed(2))) }}</label>
                            <span><i class="iconfont">&#xe612;</i>{{ a.gradeName }}</span>
                          </p>
                        </div>
                      </div>
                      <i slot="reference" class="iconfont">&#xe71a;</i>
                    </el-popover>
                  </h5>
                </div>
                <div v-if="serviceList.length == 0 && loading1 == false" :style="(serviceList.length == 0 && chooseItemTypeId == 2) ? 'height: calc(100vh - 352px);' : ''" :class="(serviceList.length == 0 && chooseItemTypeId == 2) ? 'flexMiddle' : ''">
                  <div>
                    <i class="el-icon-warning noData"></i>
                    <p>暂无数据</p>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="产品" name="产品">
            <div class="tabContent">
              <div class="tabLeft">
                <div v-for="(item,index) in productTypeList" :key="index" :class="chooseProductTypeId == item.productId ? 'ttChoose themeFC' : 'tlType'" @click="changeProductType(item.productId)">{{ item.productName }}</div>
              </div>
              <div v-loading="loadS2" class="tabRight" :class="productList.length == 0 ? 'flexMiddle' : ''" @scroll="listenScrollTwo">
                <div v-if="chooseProductTypeId == 2" class="acssType">
                  <el-button size="mini" round :plain="actProductType == '' ? false : true" type="primary" @click="changeApt('')">全部活动</el-button>
                  <el-button size="mini" round :plain="actProductType == 1 ? false : true" type="primary" @click="changeApt(1)">特价促销</el-button>
                  <el-button size="mini" round :plain="actProductType == 2 ? false : true" type="primary" @click="changeApt(2)">定时打折</el-button>
                  <el-button size="mini" round :plain="actProductType == 3 ? false : true" type="primary" @click="changeApt(3)">买赠活动</el-button>
                  <el-button size="mini" round :plain="actProductType == 4 ? false : true" type="primary" @click="changeApt(4)">满赠活动</el-button>
                </div>
                <!-- <div v-for="(v,n) in productList" :key="n" class="trProject" @click="addListData(v,2)">
                  <h4>
                    <el-popover v-show="v.isStock == 1 ? v.isWarning == 1 ? true : false : false" placement="bottom" :trigger="uaValue === 'pc' ? 'hover' : 'click'">
                      <div style="padding: 10px;">该产品库存预警</div>
                      <b slot="reference" class="bone"><i class="iconfont">&#xe628;</i></b>
                    </el-popover>
                    <el-popover v-show="v.isStock == 1 ? false : true" placement="bottom" :trigger="uaValue === 'pc' ? 'hover' : 'click'">
                      <div style="padding: 10px;">该产品无库存</div>
                      <b slot="reference" class="btwo">无</b>
                    </el-popover>{{ v.productName }}
                  </h4>
                  <h6>属性/规格：{{ v.specification || '--' }}</h6>
                  <h5 class="themeFC">
                    <b v-if="v.activityInfo" :class="'tipCss tip'+(v.activityInfo ? v.activityInfo.activityType : '')">{{ Lib.getActivity(v.activityInfo.activityType,3) }}</b>
                    ￥{{ v.price }}<el-popover v-show="v.gradeList.length > 0 || v.activityInfo" placement="right" :trigger="uaValue === 'pc' ? 'hover' : 'click'" width="400px">
                      <div v-if="v.activityInfo" class="memberPriceDetails">
                        <h1><span>{{ v.activityInfo.activityName }}</span><positive-time :end-time="v.activityInfo.endDate"></positive-time></h1>
                        <div class="MH">
                          <h5><span>活动类型：</span><samp :style="Lib.getActivity(v.activityInfo.activityType,1)">{{ Lib.getActivity(v.activityInfo.activityType,2) }}</samp></h5>
                          <h5><span>参与人员：</span><samp class="themeFC">{{ v.activityInfo.participationType == 1 ? '全部通用' : '会员参与' }}</samp></h5>
                          <h5 v-if="v.activityInfo.activityType == 1">特价促销<samp class="themeFC">￥{{ v.activityInfo.activityPrice }}</samp><label v-if="v.activityInfo.promotionSaleCount*1 > 9999">，不限购</label><label v-else>，限购<samp class="themeFC">{{ v.activityInfo.promotionSaleCount }}</samp>件</label></h5>
                          <h5 v-else-if="v.activityInfo.activityType == 2"><span>活动周期：</span><samp>{{ getCycle(v.activityInfo.activityDays,v.activityInfo.cycleType) }}</samp></h5>
                          <h6 v-if="v.activityInfo.activityType == 2">
                            <span>优惠时间：</span>
                            <div class="sampLi">
                              <samp v-for="(a,b) in v.activityInfo.lookActivityDiscountTimeList" :key="b">{{ a.startTime }}~{{ a.endTime }}，打<b class="themeFC">{{ a.discount }}</b>折</samp>
                            </div>
                          </h6>
                          <div v-else-if="v.activityInfo.activityType == 3">
                            <h5 v-for="(c,d) in v.activityInfo.lookActivityGivenList" :key="d">{{ c.givenType == 1 ? '买满' : '每买满' }}<span class="themeFC">{{ c.buyNumber }}</span>件送<samp v-for="(x,y) in c.lookActivityGivenConditionList" :key="y">{{ x.activityGiftName }}*{{ x.giftCount }}{{ c.lookActivityGivenConditionList.length == (y+1) ? '' : '，' }}</samp></h5>
                          </div>
                          <div v-else-if="v.activityInfo.activityType == 4">
                            <h5 v-for="(c,d) in v.activityInfo.lookActivityGivenList" :key="d">购买指定商品满<span class="themeFC">{{ c.satisfyPrice }}</span>元送<samp v-for="(x,y) in c.lookActivityGivenConditionList" :key="y">{{ x.activityGiftName }}*{{ x.giftCount }}{{ c.lookActivityGivenConditionList.length == (y+1) ? '' : '，' }}</samp></h5>
                          </div>
                        </div>
                      </div>
                      <div v-if="v.gradeList.length > 0" class="memberPriceDetails">
                        <h1>会员价格</h1>
                        <div class="MH">
                          <p v-for="(a,b) in v.gradeList" :key="b">
                            <label>￥<samp>{{ Lib.getValue(1,(a.discountType == 1 ? a.number : (a.number*v.price/10).toFixed(2))) }}</samp>{{ Lib.getValue(2,(a.discountType == 1 ? a.number : (a.number*v.price/10).toFixed(2))) }}</label>
                            <span><i class="iconfont">&#xe612;</i>{{ a.gradeName }}</span>
                          </p>
                        </div>
                      </div>
                      <i slot="reference" class="iconfont">&#xe71a;</i>
                    </el-popover>
                  </h5>
                </div> -->
                <div v-for="(v,n) in productList" :key="n" class="trProduct" @click="addListData(v,2)">
                  <img class="tpLeft" :src="v.imgUrl || 'static/images/default/newProduct.png'" />
                  <div class="tpRight">
                    <h5><span class="trrLeft">{{ v.productName }}</span><span class="trrRight">￥{{ v.originPrice }}</span></h5>
                    <p>属性/规格：{{ v.specification || '--' }}/{{ v.model || '--' }}</p>
                    <p>编码/条形码：{{ v.productCode }}/{{ v.barCode }}</p>
                    <p>商品库存：{{ v.amount }}</p>
                  </div>
                </div>
                <div v-if="productList.length == 0 && loading2 == false">
                  <i class="el-icon-warning noData"></i>
                  <p>暂无数据</p>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
        <el-tabs v-if="radioLeft == 2" v-model="activeIndex" class="billTab" @tab-click="buckleTab">
          <el-tab-pane label="套餐" name="套餐">
            <div v-if="searchStatus != 1" v-loading="loadStatus == 1 ? true : false" class="tabCttwo" :class="giftPackageList.length == 0 ? 'flexMiddleTwo' : ''">
              <div v-for="(item,index) in giftPackageList" :key="index" class="tcLi">
                <h1>
                  <b>{{ item.name }}</b>
                  <span>套餐类型：{{ item.countLimitType == 1 ? '有限次数' : item.countLimitType == 2 ? '无限次数' : '通用次数' }}{{ item.countLimitType == 3 ? ('（剩余'+item.remaining+'），共'+item.count+'次') : '' }}</span>
                  <samp>到期时间：{{ item.countLimitType == 2 ? '永久有效' : item.expireTime }}</samp>
                </h1>
                <div class="tlInfo">
                  <p v-if="item.canDeductItemDetailList ? item.canDeductItemDetailList.length > 0 ? true : false : false">项目</p>
                  <div v-for="(v,n) in item.canDeductItemDetailList" :key="n" class="tiPackage" @click="addListData(v,1,item)">
                    <h4>
                      <el-popover v-show="v.itemStatus == -2 ? true : false" placement="bottom" :trigger="uaValue === 'pc' ? 'hover' : 'click'">
                        <div style="padding: 10px;">该项目已下架</div>
                        <b slot="reference" class="bthree">下</b>
                      </el-popover>{{ v.name }}
                    </h4>
                    <h5>
                      <b class="themeFC">￥{{ v.price }}</b>
                      <label v-show="item.countLimitType == 1" class="themeFC">{{ v.remaining }}<span v-show="item.countLimitType == 1">/{{ v.count }}</span></label>
                    </h5>
                  </div>
                </div>
                <div class="tlInfo">
                  <p v-if="item.canDeductProductDetailList ? item.canDeductProductDetailList.length > 0 ? true : false : false">产品</p>
                  <div v-for="(v,n) in item.canDeductProductDetailList" :key="n" class="tiPackage" @click="addListData(v,2,item)">
                    <h4>
                      <el-popover v-show="v.isStock == 1 ? v.isWarning == 1 ? true : false : false" placement="bottom" :trigger="uaValue === 'pc' ? 'hover' : 'click'">
                        <div style="padding: 10px;">该产品库存预警</div>
                        <b slot="reference" class="bone"><i class="iconfont">&#xe628;</i></b>
                      </el-popover>
                      <el-popover v-show="v.isStock == 1 ? false : true" placement="bottom" :trigger="uaValue === 'pc' ? 'hover' : 'click'">
                        <div style="padding: 10px;">该产品无库存</div>
                        <b slot="reference" class="btwo">无</b>
                      </el-popover>{{ v.name }}
                    </h4>
                    <h6>属性/规格：{{ v.specification || '--' }}/{{ v.model || '--' }}</h6>
                    <h5>
                      <b class="themeFC">￥{{ v.price }}</b>
                      <label v-show="item.countLimitType == 1" class="themeFC">{{ v.remaining }}<span v-show="item.countLimitType == 1">/{{ v.count }}</span></label>
                    </h5>
                  </div>
                </div>
              </div>
              <div v-if="giftPackageList.length == 0 && loadStatus == 2">
                <i class="el-icon-warning noData"></i>
                <p>暂无可划扣套餐</p>
              </div>
            </div>
            <div v-else class="tabCttwo flexMiddleTwo">
              <div>
                <i class="el-icon-warning noData"></i>
                <p>请输入顾客信息</p>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="赠送" name="赠送">
            <div v-loading="loadStatus == 1 ? true : false" class="tabCttwo" :class="(giftProjectList.length == 0 && giftProductList.length == 0) ? 'flexMiddleTwo' : ''">
              <div v-if="giftProjectList.length > 0 ? true : false" class="tcOl">
                <p>项目</p>
                <div v-for="(v,n) in giftProjectList" :key="n" class="tcPi" @click="addListData(v,1,v)">
                  <h4>
                    <el-popover v-show="v.itemStatus == -2 ? true : false" placement="bottom" :trigger="uaValue === 'pc' ? 'hover' : 'click'">
                      <div style="padding: 10px;">该项目已下架</div>
                      <b slot="reference" class="bthree">下</b>
                    </el-popover>{{ v.name }}
                  </h4>
                  <h5>
                    <b class="themeFC">￥{{ v.price }}</b>
                  </h5>
                  <h5>
                    <b>到期时间：{{ v.expireTime || '--' }}</b>
                    <label class="themeFC">{{ v.remaining }}<span>/{{ v.count }}</span></label>
                  </h5>
                </div>
              </div>
              <div v-if="giftProductList.length > 0 ? true : false" class="tcOl">
                <p>产品</p>
                <div v-for="(v,n) in giftProductList" :key="n" class="tcPi" @click="addListData(v,2,v)">
                  <h4>
                    <el-popover v-show="v.isStock == 1 ? v.isWarning == 1 ? true : false : false" placement="bottom" :trigger="uaValue === 'pc' ? 'hover' : 'click'">
                      <div style="padding: 10px;">该产品库存预警</div>
                      <b slot="reference" class="bone"><i class="iconfont">&#xe628;</i></b>
                    </el-popover>
                    <el-popover v-show="v.isStock == 1 ? false : true" placement="bottom" :trigger="uaValue === 'pc' ? 'hover' : 'click'">
                      <div style="padding: 10px;">该产品无库存</div>
                      <b slot="reference" class="btwo">无</b>
                    </el-popover>{{ v.name }}
                  </h4>
                  <h6>属性/规格：{{ v.specification || '--' }}/{{ v.model || '--' }}</h6>
                  <h5>
                    <b class="themeFC">￥{{ v.price }}</b>
                  </h5>
                  <h5>
                    <b>到期时间：{{ v.expireTime || '--' }}</b>
                    <label class="themeFC">{{ v.remaining }}<span>/{{ v.count }}</span></label>
                  </h5>
                </div>
              </div>
              <div v-if="giftProjectList.length == 0 && giftProductList.length == 0 && loadStatus == 2">
                <i class="el-icon-warning noData"></i>
                <p>{{ searchStatus == 1 ? '请输入顾客信息' : '暂无可划扣赠品' }}</p>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="电子票" name="电子票">
            <div v-loading="loadStatus == 1 ? true : false" class="tabCttwo" :class="ticketProjectList.length == 0 && ticketList.length == 0 ? 'flexMiddleTwo' : ''">
              <div v-if="ticketProjectList.length > 0 ? true : false" class="tcOl">
                <p>项目</p>
                <div v-for="(v,n) in ticketProjectList" :key="n" class="tcPi" @click="addListData(v,1,v)">
                  <h4>
                    <el-popover v-show="v.itemStatus == -2 ? true : false" placement="bottom" :trigger="uaValue === 'pc' ? 'hover' : 'click'">
                      <div style="padding: 10px;">该项目已下架</div>
                      <b slot="reference" class="bthree">下</b>
                    </el-popover>{{ v.name }}
                  </h4>
                  <h5>
                    <b class="themeFC">￥{{ v.price }}</b>
                  </h5>
                  <h5>
                    <b>到期时间：{{ v.expireTime || '--' }}</b>
                    <label class="themeFC">{{ v.remaining }}<span>/{{ v.count }}</span></label>
                  </h5>
                </div>
              </div>
              <div v-for="(item,index) in ticketList" :key="index" class="tcLi">
                <h1>
                  <b>{{ item.name }}</b>
                  <span>套餐类型：{{ item.countLimitType == 1 ? '有限次数' : item.countLimitType == 2 ? '无限次数' : '通用次数' }}{{ item.countLimitType == 3 ? ('（剩余'+item.remaining+'），共'+item.count+'次') : '' }}</span>
                  <samp>到期时间：{{ item.expireTime || '--' }}</samp>
                </h1>
                <div class="tlInfo">
                  <p v-if="item.canDeductItemDetailList ? item.canDeductItemDetailList.length > 0 ? true : false : false">项目</p>
                  <div v-for="(v,n) in item.canDeductItemDetailList" :key="n" class="tiPackage" @click="addListData(v,1,item)">
                    <h4>
                      <el-popover v-show="v.itemStatus == -2 ? true : false" placement="bottom" :trigger="uaValue === 'pc' ? 'hover' : 'click'">
                        <div style="padding: 10px;">该项目已下架</div>
                        <b slot="reference" class="bthree">下</b>
                      </el-popover>{{ v.name }}
                    </h4>
                    <h5>
                      <b class="themeFC">￥{{ v.price }}</b>
                      <label v-show="item.countLimitType == 1" class="themeFC">{{ v.remaining }}<span v-show="item.countLimitType == 1">/{{ v.count }}</span></label>
                    </h5>
                  </div>
                </div>
                <div class="tlInfo">
                  <p v-if="item.canDeductProductDetailList ? item.canDeductProductDetailList.length > 0 ? true : false : false">产品</p>
                  <div v-for="(v,n) in item.canDeductProductDetailList" :key="n" class="tiPackage" @click="addListData(v,2,item)">
                    <h4>
                      <el-popover v-show="v.isStock == 1 ? v.isWarning == 1 ? true : false : false" placement="bottom" :trigger="uaValue === 'pc' ? 'hover' : 'click'">
                        <div style="padding: 10px;">该产品库存预警</div>
                        <b slot="reference" class="bone"><i class="iconfont">&#xe628;</i></b>
                      </el-popover>
                      <el-popover v-show="v.isStock == 1 ? false : true" placement="bottom" :trigger="uaValue === 'pc' ? 'hover' : 'click'">
                        <div style="padding: 10px;">该产品无库存</div>
                        <b slot="reference" class="btwo">无</b>
                      </el-popover>{{ v.name }}
                    </h4>
                    <h6>属性/规格：{{ v.specification || '--' }}/{{ v.model || '--' }}</h6>
                    <h5>
                      <b class="themeFC">￥{{ v.price }}</b>
                      <label v-show="item.countLimitType == 1" class="themeFC">{{ v.remaining }}<span v-show="item.countLimitType == 1">/{{ v.count }}</span></label>
                    </h5>
                  </div>
                </div>
              </div>
              <div v-if="ticketList.length == 0 && ticketProjectList.length == 0 && loadStatus == 2">
                <i class="el-icon-warning noData"></i>
                <p>{{ searchStatus == 1 ? '请输入顾客信息' : '暂无可划扣电子票' }}</p>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="充值" name="充值">
            <div class="tabCttwo" :class="searchStatus == 3 ? '' : 'flexMiddleTwo'">
              <div v-if="searchStatus == 3" class="tcLi" style="margin-top: 10px;">
                <div class="tlInfo">
                  <div class="tiPackage" @click="newGetMemberUrl(1,MemberInfo.phone)">
                    <h4>会员卡余额</h4>
                    <h5>
                      <b class="themeFC">￥{{ MemberInfo.money || 0.00 }}</b>
                      <label class="themeFC">去充值</label>
                    </h5>
                  </div>
                </div>
              </div>
              <div v-else-if="searchStatus == 1">
                <i class="el-icon-warning noData"></i>
                <p>请输入顾客信息</p>
              </div>
              <div v-else>
                <i class="el-icon-warning noData"></i>
                <p>该顾客还不是会员，请<span class="themeFC" style="cursor: pointer;" @click="newGetMemberUrl(0,form.phone)">新增会员</span></p>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
        <div v-if="radioLeft == 3">
          <div class="tabCtthree" @scroll="listenScrollThree">
            <div class="tcInfo">套餐购买需要顾客信息后才可购买</div>
            <div class="acssType">
              <el-button size="mini" round :plain="apackageType == '' ? false : true" type="primary" @click="changeMeal('')">全部套餐</el-button>
              <el-button size="mini" round :plain="apackageType == 1 ? false : true" type="primary" @click="changeMeal(1)">有限次数套餐</el-button>
              <el-button size="mini" round :plain="apackageType == 2 ? false : true" type="primary" @click="changeMeal(2)">无限次数套餐</el-button>
              <el-button size="mini" round :plain="apackageType == 3 ? false : true" type="primary" @click="changeMeal(3)">通用次数套餐</el-button>
              <el-button size="mini" round :plain="apackageType == 4 ? false : true" type="primary" @click="changeMeal(4)">活动套餐</el-button>
              <el-button size="mini" round :plain="apackageType == 5 ? false : true" type="primary" @click="changeMeal(5)">特价促销套餐</el-button>
              <el-button size="mini" round :plain="apackageType == 6 ? false : true" type="primary" @click="changeMeal(6)">定时打折套餐</el-button>
              <el-button size="mini" round :plain="apackageType == 7 ? false : true" type="primary" @click="changeMeal(7)">买赠活动套餐</el-button>
              <el-button size="mini" round :plain="apackageType == 8 ? false : true" type="primary" @click="changeMeal(8)">满赠活动套餐</el-button>
            </div>
            <div v-loading="loadStatus == 1 ? loading3 ? true : false : false" :style="mealList.length == 0 ? '' : 'clear: both;display: block;width: 100%;height: 100%;'">
              <div v-for="(item,index) in mealList" :key="index" class="tiPackage" @click="addListData(item,3)">
                <h4>{{ item.vipCardName }}</h4>
                <h5>
                  <b v-if="item.activityInfo" :class="'tipCss tip'+(item.activityInfo ? item.activityInfo.activityType : '')">{{ Lib.getActivity(item.activityInfo.activityType,3) }}</b>
                  <b class="themeFC">￥{{ item.price }}</b>
                  <el-popover placement="right" :trigger="uaValue === 'pc' ? 'hover' : 'click'">
                    <el-tabs v-if="item.activityInfo || item.gradeList.length > 0" style="padding: 20px;height: 440px;" value="1" type="card">
                      <el-tab-pane label="优惠信息" name="1">
                        <div class="memberDetails">
                          <div v-if="item.activityInfo" class="memberPriceDetails">
                            <h1><span>{{ item.activityInfo.activityName }}</span><positive-time :end-time="item.activityInfo.endDate"></positive-time></h1>
                            <div class="MH">
                              <h5><span>活动类型：</span><samp :style="Lib.getActivity(item.activityInfo.activityType,1)">{{ Lib.getActivity(item.activityInfo.activityType,2) }}</samp></h5>
                              <h5><span>参与人员：</span><samp class="themeFC">{{ item.activityInfo.participationType == 1 ? '全部通用' : '会员参与' }}</samp></h5>
                              <h5 v-if="item.activityInfo.activityType == 1">特价促销<samp class="themeFC">￥{{ item.activityInfo.activityPrice }}</samp><label v-if="item.activityInfo.promotionSaleCount*1 > 9999">，不限购</label><label v-else>，限购<samp class="themeFC">{{ item.activityInfo.promotionSaleCount }}</samp>件</label></h5>
                              <h5 v-else-if="item.activityInfo.activityType == 2"><span>活动周期：</span><samp>{{ getCycle(item.activityInfo.activityDays,item.activityInfo.cycleType) }}</samp></h5>
                              <h6 v-if="item.activityInfo.activityType == 2">
                                <span>优惠时间：</span>
                                <div class="sampLi">
                                  <samp v-for="(a,b) in item.activityInfo.lookActivityDiscountTimeList" :key="b">{{ a.startTime }}~{{ a.endTime }}，打<b class="themeFC">{{ a.discount }}</b>折</samp>
                                </div>
                              </h6>
                              <div v-else-if="item.activityInfo.activityType == 3">
                                <h5 v-for="(c,d) in item.activityInfo.lookActivityGivenList" :key="d">{{ c.givenType == 1 ? '买满' : '每买满' }}<span class="themeFC">{{ c.buyNumber }}</span>件送<samp v-for="(x,y) in c.lookActivityGivenConditionList" :key="y">{{ x.activityGiftName }}*{{ x.giftCount }}{{ c.lookActivityGivenConditionList.length == (y+1) ? '' : '，' }}</samp></h5>
                              </div>
                              <div v-else-if="item.activityInfo.activityType == 4">
                                <h5 v-for="(c,d) in item.activityInfo.lookActivityGivenList" :key="d">购买指定商品满<span class="themeFC">{{ c.satisfyPrice }}</span>元送<samp v-for="(x,y) in c.lookActivityGivenConditionList" :key="y">{{ x.activityGiftName }}*{{ x.giftCount }}{{ c.lookActivityGivenConditionList.length == (y+1) ? '' : '，' }}</samp></h5>
                              </div>
                            </div>
                          </div>
                          <div v-if="item.gradeList.length > 0" class="memberPriceDetails">
                            <h1>会员价格</h1>
                            <div class="MH">
                              <p v-for="(a,b) in item.gradeList" :key="b">
                                <label>￥<samp>{{ Lib.getValue(1,(a.discountType == 1 ? a.number : (a.number*item.price/10).toFixed(2))) }}</samp>{{ Lib.getValue(2,(a.discountType == 1 ? a.number : (a.number*item.price/10).toFixed(2))) }}</label>
                                <span><i class="iconfont">&#xe612;</i>{{ a.gradeName }}</span>
                              </p>
                            </div>
                          </div>
                        </div>
                      </el-tab-pane>
                      <el-tab-pane label="套餐详情" name="2">
                        <div class="buyDetails">
                          <h1>套餐信息</h1>
                          <div class="info">
                            <p>
                              <label>套餐名称：</label>{{ item.vipCardName }}
                            </p>
                            <p>
                              <label>套餐类型：</label>{{ item.countLimitType == 1 ? '有限次数' : item.countLimitType == 2 ? '无限次数' : '通用次数' }}{{ item.countLimitType == 3 ? '（' : '' }}<span class="themeFC">{{ item.countLimitType == 3 ? item.beUsedCount : '' }}</span>{{ item.countLimitType == 3 ? '次）' : '' }}
                            </p>
                            <div v-if="item.gradeList.length > 0" class="mp">
                              <div class="mpl">会员价格：</div>
                              <div v-show="item.gradeList.length == 1" class="mpr">
                                <b class="themeFC">￥</b><samp class="themeFC">{{ Lib.getValue(1,(item.gradeList[0].discountType == 1 ? item.gradeList[0].number : (item.gradeList[0].number*item.price/10).toFixed(2))) }}</samp><b class="themeFC">{{ Lib.getValue(2,(item.gradeList[0].discountType == 1 ? item.gradeList[0].number : (item.gradeList[0].number*item.price/10).toFixed(2))) }}</b>
                                <span class="spanIcon"><i class="iconfont">&#xe612;</i>{{ item.gradeList[0].gradeName }}</span>
                              </div>
                              <div v-show="item.gradeList.length > 1" class="mpr">
                                <b class="themeFC">￥</b><samp class="themeFC">{{ Lib.getValue(1,(item.gradeList[0].discountType == 1 ? Lib.getMinVal(item.gradeList,'number') : (Lib.getMinVal(item.gradeList,'number')*item.price/10).toFixed(2))) }}</samp><b class="themeFC">{{ Lib.getValue(2,(item.gradeList[0].discountType == 1 ? Lib.getMinVal(item.gradeList,'number') : (Lib.getMinVal(item.gradeList,'number')*item.price/10).toFixed(2))) }}</b>起
                                <el-popover placement="right" :trigger="uaValue === 'pc' ? 'hover' : 'click'">
                                  <div class="memberPriceDetails">
                                    <h1>会员价格</h1>
                                    <div class="MH">
                                      <p v-for="(v,n) in item.gradeList" :key="n">
                                        <label>￥<samp>{{ Lib.getValue(1,(v.discountType == 1 ? v.number : (v.number*item.price/10).toFixed(2))) }}</samp>{{ Lib.getValue(2,(v.discountType == 1 ? v.number : (v.number*item.price/10).toFixed(2))) }}</label>
                                        <span><i class="iconfont">&#xe612;</i>{{ v.gradeName }}</span>
                                      </p>
                                    </div>
                                  </div>
                                  <label slot="reference" class="themeFC">（查看详情）</label>
                                </el-popover>
                              </div>
                            </div>
                            <p>
                              <label>{{ item.validType == 1 ? '有效时间：' : item.validType == 2 ? '有效期限：' : '有效天数：' }}</label>{{ item.validType == 1 ? (item.startTime+'至'+ item.endTime) : item.validType == 2 ? '永久有效' : ((item.validTime ? item.validTime : '0')+'天') }}
                            </p>
                            <p>
                              <label>可用门店：</label>
                              <samp>
                                <span v-for="(list,num) in item.useStoreList" :key="num">{{ list.name }}{{ item.useStoreList.length == (num+1) ? '' : '、' }}</span>
                              </samp>
                            </p>
                          </div>
                          <h1 v-if="item.vipCardItemInfoDto.length>0">套餐包含项目</h1>
                          <div v-if="item.vipCardItemInfoDto.length>0" class="info">
                            <p v-for="(list,num) in item.vipCardItemInfoDto" :key="num">
                              <span>{{ list.dictItemName }}</span>
                              <span v-if="item.countLimitType == 1">（次数：</span>
                              <span v-if="item.countLimitType == 1" class="themeFC">{{ list.count }}</span>
                              <span v-if="item.countLimitType == 1">次）</span>
                            </p>
                          </div>
                          <h1 v-if="item.basePackageProductList">套餐包含产品</h1>
                          <div v-if="item.basePackageProductList" class="info">
                            <p v-for="(list,num) in item.basePackageProductList" :key="num">
                              <span>{{ list.productName }}</span>
                              <span v-if="item.countLimitType == 1">（次数：</span>
                              <span v-if="item.countLimitType == 1" class="themeFC">{{ list.productCount }}</span>
                              <span v-if="item.countLimitType == 1">次）</span>
                            </p>
                          </div>
                        </div>
                      </el-tab-pane>
                    </el-tabs>
                    <div v-if="!item.activityInfo && item.gradeList.length == 0" class="buyDetails">
                      <h1>套餐信息</h1>
                      <div class="info">
                        <p>
                          <label>套餐名称：</label>{{ item.vipCardName }}
                        </p>
                        <p>
                          <label>套餐类型：</label>{{ item.countLimitType == 1 ? '有限次数' : item.countLimitType == 2 ? '无限次数' : '通用次数' }}{{ item.countLimitType == 3 ? '（' : '' }}<span class="themeFC">{{ item.countLimitType == 3 ? item.beUsedCount : '' }}</span>{{ item.countLimitType == 3 ? '次）' : '' }}
                        </p>
                        <div v-if="item.gradeList.length > 0" class="mp">
                          <div class="mpl">会员价格：</div>
                          <div v-show="item.gradeList.length == 1" class="mpr">
                            <b class="themeFC">￥</b><samp class="themeFC">{{ Lib.getValue(1,(item.gradeList[0].discountType == 1 ? item.gradeList[0].number : (item.gradeList[0].number*item.price/10).toFixed(2))) }}</samp><b class="themeFC">{{ Lib.getValue(2,(item.gradeList[0].discountType == 1 ? item.gradeList[0].number : (item.gradeList[0].number*item.price/10).toFixed(2))) }}</b>
                            <span class="spanIcon"><i class="iconfont">&#xe612;</i>{{ item.gradeList[0].gradeName }}</span>
                          </div>
                          <div v-show="item.gradeList.length > 1" class="mpr">
                            <b class="themeFC">￥</b><samp class="themeFC">{{ Lib.getValue(1,(item.gradeList[0].discountType == 1 ? Lib.getMinVal(item.gradeList,'number') : (Lib.getMinVal(item.gradeList,'number')*item.price/10).toFixed(2))) }}</samp><b class="themeFC">{{ Lib.getValue(2,(item.gradeList[0].discountType == 1 ? Lib.getMinVal(item.gradeList,'number') : (Lib.getMinVal(item.gradeList,'number')*item.price/10).toFixed(2))) }}</b>起
                            <el-popover placement="right" :trigger="uaValue === 'pc' ? 'hover' : 'click'">
                              <div class="memberPriceDetails">
                                <h1>会员价格</h1>
                                <div class="MH">
                                  <p v-for="(v,n) in item.gradeList" :key="n">
                                    <label>￥<samp>{{ Lib.getValue(1,(v.discountType == 1 ? v.number : (v.number*item.price/10).toFixed(2))) }}</samp>{{ Lib.getValue(2,(v.discountType == 1 ? v.number : (v.number*item.price/10).toFixed(2))) }}</label>
                                    <span><i class="iconfont">&#xe612;</i>{{ v.gradeName }}</span>
                                  </p>
                                </div>
                              </div>
                              <label slot="reference" class="themeFC">（查看详情）</label>
                            </el-popover>
                          </div>
                        </div>
                        <p>
                          <label>{{ item.validType == 1 ? '有效时间：' : item.validType == 2 ? '有效期限：' : '有效天数：' }}</label>{{ item.validType == 1 ? (item.startTime+'至'+ item.endTime) : item.validType == 2 ? '永久有效' : ((item.validTime ? item.validTime : '0')+'天') }}
                        </p>
                        <p>
                          <label>可用门店：</label>
                          <samp>
                            <span v-for="(list,num) in item.useStoreList" :key="num">{{ list.name }}{{ item.useStoreList.length == (num+1) ? '' : '、' }}</span>
                          </samp>
                        </p>
                      </div>
                      <h1 v-if="item.vipCardItemInfoDto.length>0">套餐包含项目</h1>
                      <div v-if="item.vipCardItemInfoDto.length>0" class="info">
                        <p v-for="(list,num) in item.vipCardItemInfoDto" :key="num">
                          <span>{{ list.dictItemName }}</span>
                          <span v-if="item.countLimitType == 1">（次数：</span>
                          <span v-if="item.countLimitType == 1" class="themeFC">{{ list.count }}</span>
                          <span v-if="item.countLimitType == 1">次）</span>
                        </p>
                      </div>
                      <h1 v-if="item.basePackageProductList">套餐包含产品</h1>
                      <div v-if="item.basePackageProductList" class="info">
                        <p v-for="(list,num) in item.basePackageProductList" :key="num">
                          <span>{{ list.productName }}</span>
                          <span v-if="item.countLimitType == 1">（次数：</span>
                          <span v-if="item.countLimitType == 1" class="themeFC">{{ list.productCount }}</span>
                          <span v-if="item.countLimitType == 1">次）</span>
                        </p>
                      </div>
                    </div>
                    <i slot="reference" class="iconfont">&#xe71a;</i>
                  </el-popover>
                </h5>
              </div>
            </div>
            <div v-if="(mealList ? mealList.length == 0 ? true : false : true) && loadStatus == 2" class="ttNo">
              <div>
                <i class="el-icon-warning noData"></i>
                <p>暂无数据</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="billBottomRight">
        <h3>
          <span>消费明细（{{ form.tableData.length }}）</span>
        </h3>
        <div class="btrUl" :style="(customerSwitch == 0 || handSwitch == 0) ? 'height: calc(100vh - 425px) !important;' : 'height: calc(100vh - 383px) !important;'">
          <div v-for="(v,n) in form.tableData" :key="n" class="btrLi">
            <i class="el-icon-close delList" @click="delListData(n,v.bookAmount,v.deductType)"></i>
            <div class="bltop">
              <p>{{ v.listStatus == 1 ? v.itemName : v.listStatus == 2 ? v.productName : v.vipCardName }}<br /><span>{{ v.serviceTime ? (v.serviceTime+'分钟') : '' }}<i v-if="v.listStatus == 1 && !v.id && !form.bookOrderId" style="font-size: 14px;padding: 0 5px;cursor: pointer;color: #ccc;" class="el-icon-edit" @click="setTime(n)"></i></span></p>
              <h2>
                <i v-if="v.listStatus == 1" style="font-size: 16px;padding: 0 5px;cursor: pointer;color: #ccc;" class="el-icon-remove" @click="tipInfo()"></i>
                <span v-if="v.listStatus == 1">{{ v.count }}</span>
                <i v-if="v.listStatus == 1" style="font-size: 16px;padding: 0 5px;cursor: pointer;" class="el-icon-circle-plus themeFC" @click="addListData(v,1)"></i>
                <!-- <el-input-number v-if="v.listStatus != 1" v-model.trim="v.count" style="width: 100px;" oninput="this.value = this.value.replace(/[^\d\.]|(?<=\d?\.\d?)\.|(?<=\d+\.\d{0})[\d+\.]/g, '')" size="mini" :min="1" :max="v.count == Number(v.alreadyPurchase?v.limitPurchase * 1 - v.alreadyPurchase * 1:v.limitPurchase * 1 ) ? Number(v.alreadyPurchase?v.limitPurchase * 1 - v.alreadyPurchase * 1:v.limitPurchase * 1 ):Number(v.alreadyPurchase?v.limitPurchase * 1 - v.alreadyPurchase * 1:v.limitPurchase * 1 )==0 ?v.count:9999" @keyup.enter.native="Lib.keyboardBlur" @change="formChange(n,v)"></el-input-number> -->
                <el-input-number v-if="v.listStatus != 1" v-model="v.count" style="width: 100px;" oninput="this.value = this.value.replace(/[^\d\.]|(?<=\d?\.\d?)\.|(?<=\d+\.\d{0})[\d+\.]/g, '')" size="mini" :min="1" :max="v.limitPurchase!=0&&Number(v.limitPurchase * 1 - v.alreadyPurchase * 1) <= v.count?Number(v.limitPurchase * 1 - v.alreadyPurchase * 1):999" @keyup.enter.native="Lib.keyboardBlur" @change="formChange(n,v)"></el-input-number>
              </h2>
              <h4>
                <b>
                  <span style="float: left;">折后价：￥{{ calculationDiscountMoney(v,n) }}</span>
                  <!-- <el-popover v-if="v.isWholesale == 1 && MemberInfo.wholesaleInfo" placement="right" trigger="hover">
                    <div style="padding: 10px;font-size: 12px;">{{ MemberInfo.wholesaleInfo ? MemberInfo.wholesaleInfo.gradeName : '' }}</div>
                    <img slot="reference" class="ticket" src="@/assets/images/goods.png" />
                  </el-popover> -->
                </b>
                <samp>原价：￥{{ showOriginalPrice(v) }}
                  <el-popover v-if="editOldPriceStatus == 0 && v.isWholesale != 1" placement="bottom-start" trigger="click">
                    <div class="editOldPrice">
                      <samp>改原价：</samp>
                      <el-input v-model="v.editPrice" oninput="this.value = this.value.replace(/[^\d\.]|(?<=\d?\.\d?)\.|(?<=\d+\.\d{2})[\d+\.]/g, '')" style="width: 100px;margin: 0 15px;" :maxlength="10" @input="forceUpdate"></el-input>
                      <el-button type="primary" @click="comfirmEditOldPrice(n,v.discountType)">确定</el-button>
                    </div>
                    <i slot="reference" class="iconfont" style="cursor: pointer;">&#xe625;</i>
                  </el-popover>
                </samp>
                <label>优惠：{{ (showOriginalPrice(v)*v.count - calculationPreferential(v)*1) > 0 ? ('-￥'+(v.price*v.count - calculationPreferential(v)*1).toFixed(2)) : '--' }}</label>
              </h4>
              <h5>
                <b>
                  <span>小计：￥{{ calculationPreferential(v) }}</span>
                </b>
                <samp v-show="v.bookAmount" style="color: #999;">预约定金：￥{{ v.bookAmount }}</samp>
                <samp v-show="v.deductType == 1" style="color: #999;">已提前划扣</samp>
              </h5>
            </div>
            <div class="blBottom">
              <div v-if="v.listStatus == 1">
                <activity v-if="v.hasActivity == 1" :type="v.activityInfo ? v.activityInfo.activityType : ''"></activity>
                <div v-if="v.percentage4ServeList.length > 0 && !v.status">
                  <el-tooltip class="item" effect="light" placement="bottom">
                    <div slot="content" style="display: flex;">
                      <p>{{ Lib.collectively() }}：</p>
                      <div style="flex: 1;">
                        <p v-for="(item,index) in v.percentage4ServeList" :key="index" style="padding: 0 10px 0 0;">
                          <span>{{ item.isGuest == 1 ?'点客':'非点客' }}-{{ item.technicianName }}<br></span>
                        </p>
                      </div>
                    </div>
                    <el-button class="textSbt" type="text" @click="chooseStaff(n,v)">
                      <samp>{{ Lib.collectively() }}：</samp>
                      <span v-for="(item,index) in v.percentage4ServeList" :key="index">{{ item.isGuest == 1 ?'点客':'非点客' }}-{{ item.technicianName }}{{ v.percentage4ServeList.length == (index+1) ? '' : ',' }}</span>
                    </el-button>
                  </el-tooltip>
                </div>
                <el-tooltip v-else-if="v.status == -1" class="item" effect="light" :content="'该项目暂无关联'+Lib.collectively()" placement="bottom">
                  <el-button class="mr_10" size="mini" type="text">+选择{{ Lib.collectively() }}</el-button>
                </el-tooltip>
                <el-button v-else class="mr_10" size="mini" type="text" @click="chooseStaff(n,v)">+选择{{ Lib.collectively() }}</el-button>

                <span v-if="salesEquity(v)">
                  <div v-if="v.percentageSellServeList.length > 0">
                    <el-tooltip class="item" effect="light" placement="bottom">
                      <div slot="content" style="display: flex;">
                        <p>销售：</p>
                        <div style="flex: 1;">
                          <p v-for="(item,index) in v.percentageSellServeList" :key="index" style="padding: 0 10px 0 0;">
                            <span>{{ item.technicianName }}<br></span>
                          </p>
                        </div>
                      </div>
                      <el-button class="textSbt" type="text" @click="chooseSale(n,v.itemId)">
                        <samp>销售：</samp>
                        <span v-for="(item,index) in v.percentageSellServeList" :key="index">{{ item.technicianName }}{{ v.percentageSellServeList.length == (index+1) ? '' : ',' }}</span>
                      </el-button>
                    </el-tooltip>
                  </div>
                  <el-button v-else class="mr_10" size="mini" type="text" @click="chooseSale(n,v.itemId)">+选择销售</el-button>
                </span>
              </div>
              <div v-else-if="v.listStatus == 2 && salesEquity(v)">
                <activity v-if="v.hasActivity == 1" :type="v.activityInfo ? v.activityInfo.activityType : ''"></activity>
                <div v-if="v.percentage4ProductList.length > 0">
                  <el-tooltip class="item" effect="light" placement="bottom">
                    <div slot="content" style="display: flex;">
                      <p>销售：</p>
                      <div style="flex: 1;">
                        <p v-for="(item,index) in v.percentage4ProductList" :key="index" style="padding: 0 10px 0 0;">
                          <span>{{ item.technicianName }}<br></span>
                        </p>
                      </div>
                    </div>
                    <el-button class="textSbt" type="text" @click="chooseProductStaff(n,v.productId)">
                      <samp>销售：</samp>
                      <span v-for="(item,index) in v.percentage4ProductList" :key="index">{{ item.technicianName }}{{ v.percentage4ProductList.length == (index+1) ? '' : ',' }}</span>
                    </el-button>
                  </el-tooltip>
                </div>
                <el-button v-else class="mr_10" size="mini" type="text" @click="chooseProductStaff(n,v.productId)">+选择销售</el-button>
              </div>
              <div v-else-if="v.listStatus == 3">
                <activity v-if="v.hasActivity == 1" :type="v.activityInfo ? v.activityInfo.activityType : ''"></activity>
                <div v-if="v.percentage4PackageList.length > 0">
                  <el-tooltip class="item" effect="light" placement="bottom">
                    <div slot="content" style="display: flex;">
                      <p>销售：</p>
                      <div style="flex: 1;">
                        <p v-for="(item,index) in v.percentage4PackageList" :key="index" style="padding: 0 10px 0 0;">
                          <span>{{ item.technicianName }}<br></span>
                        </p>
                      </div>
                    </div>
                    <el-button class="textSbt" type="text" @click="choosePackage(n,v.vipCardId)">
                      <samp>销售：</samp>
                      <span v-for="(item,index) in v.percentage4PackageList" :key="index">{{ item.technicianName }}{{ v.percentage4PackageList.length == (index+1) ? '' : ',' }}</span>
                    </el-button>
                  </el-tooltip>
                </div>
                <el-button v-else class="mr_10" size="mini" type="text" @click="choosePackage(n,v.vipCardId)">+选择销售</el-button>
              </div>
              <el-button class="qychoose" type="text" @click="chooseRI(v,n)">{{ getChooseQyinfo(v,1) }}<i class="el-icon-arrow-right"></i></el-button>
            </div>
          </div>
          <div v-if="giftSvList.length > 0 || giftPdList.length > 0 || giftPkList.length > 0 || buyGiftList.length > 0 || fullGiftList.length > 0" class="bgTitle">赠品</div>
          <div v-if="giftSvList.length > 0 || giftPdList.length > 0 || giftPkList.length > 0 || buyGiftList.length > 0 || fullGiftList.length > 0" class="buGift">
            <div>
              <div v-for="(v,n) in giftSvList" :key="n" class="btLi">
                <p style="width: 205px;">{{ v.itemName }}</p>
                <h2><el-input-number v-model="v.givingQuantity" style="width: 100px;" oninput="this.value = this.value.replace(/[^\d\.]|(?<=\d?\.\d?)\.|(?<=\d+\.\d{0})[\d+\.]/g, '')" size="mini" :min="1" :max="9999"></el-input-number></h2>
                <h4>
                  到期时间：<el-date-picker v-model="v.expireTime" style="width: 150px;" size="mini" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions"></el-date-picker>
                </h4>
                <h5><span @click="delGift(n,1)">删除</span></h5>
              </div>
            </div>
            <div>
              <div v-for="(v,n) in giftPdList" :key="n" class="btLi">
                <p style="width: 205px;">{{ v.productName }}</p>
                <h2><el-input-number v-model="v.givingQuantity" style="width: 100px;" oninput="this.value = this.value.replace(/[^\d\.]|(?<=\d?\.\d?)\.|(?<=\d+\.\d{0})[\d+\.]/g, '')" size="mini" :min="1" :max="9999"></el-input-number></h2>
                <h4>
                  到期时间：<el-date-picker v-model="v.expireTime" style="width: 150px;" size="mini" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions"></el-date-picker>
                </h4>
                <h5><span @click="delGift(n,2)">删除</span></h5>
              </div>
            </div>
            <div>
              <div v-for="(v,n) in giftPkList" :key="n" class="btLi">
                <p style="width: 205px;">{{ v.vipCardName }}</p>
                <h2><el-input-number v-model="v.givingQuantity" style="width: 100px;" oninput="this.value = this.value.replace(/[^\d\.]|(?<=\d?\.\d?)\.|(?<=\d+\.\d{0})[\d+\.]/g, '')" size="mini" :min="1" :max="9999"></el-input-number></h2>
                <h4>
                  到期时间：<el-date-picker v-model="v.expireTime" style="width: 150px;" size="mini" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions"></el-date-picker>
                </h4>
                <h5><span @click="delGift(n,3)">删除</span></h5>
              </div>
            </div>
            <div v-if="buyGiftList.length > 0">
              <div v-for="(v,n) in buyGiftList" :key="n" class="btLi">
                <ActivityTwo :type="3"></ActivityTwo>
                <p>{{ v.activityGiftName }}</p>
                <h2>{{ v.buyGiftCount }}</h2>
                <h4>到期时间：永久有效</h4>
              </div>
            </div>
            <div v-if="fullGiftList.length > 0">
              <div v-for="(v,n) in fullGiftList" :key="n" class="btLi">
                <ActivityTwo :type="4"></ActivityTwo>
                <p>{{ v.activityGiftName }}</p>
                <h2>{{ v.buyGiftCount }}</h2>
                <h4>到期时间：永久有效</h4>
              </div>
            </div>
          </div>
        </div>
        <div class="addGift">
          <el-popover placement="right" trigger="click" :disabled="searchStatus == 1">
            <div class="giftPop">
              <p @click="addGift(1)">赠项目</p>
              <p @click="addGift(2)">赠产品</p>
              <p @click="addGift(3)">赠套餐</p>
            </div>
            <samp slot="reference" :class="searchStatus != 1 ? 'themeFC' : 'noDrop'">+添加赠品</samp>
          </el-popover>
          <samp :class="batchAddSalesIsshow() == 1 ? 'themeFC' : 'noDrop'" type="text" @click="batchAddSalesIsshow() == 1 ? batchAdd() : ''">+批量添加销售</samp>
          <b class="themeFC" @click="clearData">清空</b>
        </div>
        <div class="btrFoot" :style="(customerSwitch == 0 || handSwitch == 0) ? 'height: 172px;' : 'height: 130px;'">
          <div v-if="customerSwitch == 0 || handSwitch == 0" class="rfTop">
            <div v-if="customerSwitch == 0" class="f_cusomer">
              <label>顾客：</label>
              <samp>男客</samp>
              <el-input-number v-model="handCustomer.manNumber" class="f_input" :min="0" :max="99" size="mini"></el-input-number>
              <el-tooltip v-if="MemberInfo.sex=='男'" effect="light" placement="top">
                <div slot="content">
                  <p class="tooltip-p">该顾客的性别信息为男，如需修改，请点击上方</p>
                  <p class="tooltip-p">的顾客信息区域的编辑按键</p>
                </div>
                <i class="iconfont iconCdTwo">&#xe71a;</i>
              </el-tooltip>
              <samp>女客</samp>
              <el-input-number v-model="handCustomer.womanNumber" class="f_input" :min="0" :max="99" size="mini"></el-input-number>
              <el-tooltip v-if="MemberInfo.sex=='女'" effect="light" placement="top">
                <div slot="content">
                  <p class="tooltip-p">该顾客的性别信息为女，如需修改，请点击上方</p>
                  <p class="tooltip-p">的顾客信息区域的编辑按键</p>
                </div>
                <i class="iconfont iconCdTwo">&#xe71a;</i>
              </el-tooltip>
              <samp>未知性别客</samp>
              <el-input-number v-model="handCustomer.midNumber" class="f_input" :min="0" :max="99" size="mini"></el-input-number>
              <el-tooltip v-if="MemberInfo.sex=='未知性别'" effect="light" placement="top">
                <div slot="content">
                  <p class="tooltip-p">该顾客的性别信息为未知性别，如需修改，请点击</p>
                  <p class="tooltip-p">上方的顾客信息区域的编辑按键</p>
                </div>
                <i class="iconfont iconCdTwo">&#xe71a;</i>
              </el-tooltip>
              <el-tooltip v-if="searchStatus == 1" effect="light" placement="top">
                <div slot="content">
                  <p class="tooltip-p">无手机号码的顾客，如不填写性别信息，开单后将默认</p>
                  <p class="tooltip-p">统计为未知性别客</p>
                </div>
                <i class="iconfont iconCdTwo">&#xe71a;</i>
              </el-tooltip>
            </div>
            <div v-if="handSwitch == 0" class="f_hand">
              <label>手牌：</label>
              <el-input v-for="(v,n) in handList" :key="n" v-model="v.handCardNumber" :class="v.inputStatus == 1 ? 'f_input' : 'f_input errorInput'" size="mini" type="text" :maxlength="4" oninput="this.value = this.value.replace(/[^\d\.]|(?<=\d?\.\d?)\.|(?<=\d+\.\d{})[\d+\.]/g, '').replace('.','')">
                <i slot="suffix" class="el-input__icon el-icon-circle-close" @click="delHand(n)"></i>
              </el-input>
              <i v-if="handList.length >= 4 ? false : true" class="iconfont" @click="addHand">&#xe622;</i>
            </div>
          </div>
          <div class="f_remark" :style="(customerSwitch == 0 || handSwitch == 0) ? '' : 'padding: 10px;'">
            <span class="span">备注：</span>
            <el-input v-model="textareaVal" class="resizeNone" type="textarea" :rows="2" placeholder="请输入内容" :maxlength="100" show-word-limit></el-input>
          </div>
          <div class="f_total">
            <div class="ft_left">
              <label>待收款：</label>
              <b class="themeFC">￥{{ listTotal }}</b>
            </div>
            <div class="ft_right">
              <el-popover placement="top-start" trigger="hover">
                <p v-for="(item,index) in check_in_data.roomInfosList" :key="index" class="check_in_list">{{ titleStatus == 1 ? item.roomName : (item.roomName+'/'+item.bedName) }}</p>
                <el-button v-show="check_in_data.roomInfosList[0].roomId" slot="reference" type="text" style="margin-right:21px" @click="checkRoomBtn(check_in_data)">{{ check_in_data.roomInfosList[0].roomName }}{{ check_in_data.roomInfosList.length>1?'...':'' }}</el-button>
              </el-popover>
              <el-button v-if="!check_in_data.roomInfosList[0].roomId && roomBtnStatus == 2 && menusList.find(data => data.iDenTi === 'beauty-1-ft')" size="medium" plain :loading="check_in_loading" @click="check_in_visible = true">{{ titleStatus == 1 ? '开房' : '开位' }}</el-button>
              <el-button size="medium" plain :disabled="submitBtnStatus" @click="submitBtnStatus ? '' : submitOrder()">挂单</el-button>
              <el-button size="medium" type="primary" :disabled="submitBtnStatus" @click="submitBtnStatus ? '' : submitOrder('99')">收款</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog class="merchandiserDialog chooseServiceCss" width="740px" title="批量选择销售" :visible.sync="batchAddDia" :append-to-body="true">
      <div class="el-message-box__content" style="height: 606px;padding: 0;">
        <div class="dialog_header">
          <el-input v-model="batchAddVal" class="width_282" size="medium" placeholder="请输入员工姓名/工号" style="float:left;" @keyup.enter.native="getBatchData">
            <i slot="suffix" class="el-input__icon el-icon-search" style="cursor: pointer;" @click="getBatchData"></i>
          </el-input>
        </div>

        <div class="commonTable tablePointer" style="height: 528px;border: 1px solid #eee;width: 340px;float: left;overflow: hidden;">
          <el-tabs v-if="brandInfo.cardOpen == 1" v-model="activeName" class="brandList" style="width: 340px;" @tab-click="getBatchData">
            <el-tab-pane v-for="(v,n) in brandInfo.cards" :key="n" :label="v.cardName" :name="v.id+''">
              <span v-if="v.cardName == '未分配'" slot="label">{{ v.cardName }}
                <el-tooltip class="item" effect="light" content="展示后台未分配轮牌的销售" placement="right">
                  <i class="el-icon-warning"></i>
                </el-tooltip>
              </span>
            </el-tab-pane>
          </el-tabs>
          <el-table ref="batchTable" v-loading="loading" tooltip-effect="light" :data="searchSaleList" class="newSelect" height="530" @select="selectBatch" @row-click="rowClickBatch">
            <el-table-column :class-name="'ht_23'" type="selection" width="45" :selectable="checkSelectable"></el-table-column>
            <el-table-column label="员工工号">
              <template slot-scope="scope">
                <el-popover v-if="menusList.find(data => data.iDenTi === 'beauty-1-lp')" placement="right" trigger="hover">
                  <p style="padding: 10px;">{{ scope.row.message || '空闲中' }}</p>
                  <label slot="reference" :class="'stafIcon ' + (scope.row.state == 1 ? 'sifour' : scope.row.state == 2 ? 'sitwo' : scope.row.state == 3 ? 'sithree' : scope.row.state == 4 ? 'sifive' : scope.row.state == 5 ? 'sifive' : scope.row.state == 6 ? 'sifive' : 'sione')"></label>
                </el-popover>
                <el-tooltip effect="light" placement="top" :disabled="tooltipStatus">
                  <div slot="content">
                    <p>{{ scope.row.jobNumber }}</p>
                  </div>
                  <span class="commonTableShow" style="width: 60px;padding-left: 5px;" @mouseover="tooltipStatus = Lib.textShow($event)">{{ scope.row.jobNumber || '--' }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column prop="technicianName" label="员工姓名" :show-overflow-tooltip="true"></el-table-column>
          </el-table>
        </div>
        <div class="commonTable" style="height: 528px;border: 1px solid #eee;width: 310px;float: right;">
          <el-table tooltip-effect="light" class="merchandiserTable" :data="chooseSaleList" height="530">
            <el-table-column label="员工姓名" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <span>{{ scope.row.technicianName }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="80">
              <template slot-scope="scope">
                <yz-btn type="delete" @click="delChooseBatch(scope.row.technicianId)">删除</yz-btn>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="newFootCss">
        <div class="newFootBtn">
          <el-button type="primary" @click="comfirmAddBatch">确 定</el-button>
          <el-button @click="batchAddDia = false">取 消</el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog class="chooseServiceCss" width="1000px" :title="'选择赠品'+getGiftVal()" :visible.sync="addGiftDia" :append-to-body="true">
      <el-select v-if="giftStatus != 3" v-model="giftTypeId" placeholder="请选择" @change="giftTypeChange">
        <el-option label="全部" value=""></el-option>
        <el-option v-for="(item,index) in giftTypeList" :key="index" :label="giftStatus == 1 ? item.name : item.productName" :value="giftStatus == 1 ? item.id : item.productId"></el-option>
      </el-select>
      <el-input v-model="giftSearchVal" :style="giftStatus != 3 ? 'width: 220px;float: right;' : 'width: 220px;'" :placeholder="'请输入'+ getGiftVal() + '名称'+(getGiftVal() == '套餐' ? '' : getGiftVal() == '产品' ? '/产品编码' : '/分类')" @keyup.enter.native="giftTypeChange">
        <i slot="suffix" class="el-input__icon el-icon-search" style="cursor: pointer;" @click="giftTypeChange"></i>
      </el-input>
      <div class="giftChoose">
        <el-table ref="multipleTable" v-loading="giftLoad" style="flex:2;margin-right:20px;border:0" :data="addGiftList" tooltip-effect="light" @select-all="selectAll" @row-click="(row, event, column)=>handleSelectionChange(row,event,column,'select')" @select="(selection, row)=>handleSelectionChange(row)">
          <el-table-column type="selection" width="50"></el-table-column>
          <el-table-column v-if="giftStatus == 3" label="套餐名称" prop="vipCardName" show-overflow-tooltip></el-table-column>
          <el-table-column v-if="giftStatus == 2" label="产品编码" prop="productCode" show-overflow-tooltip></el-table-column>
          <el-table-column v-if="giftStatus == 2" label="产品名称" prop="productName" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-popover v-show="scope.row.isWarning == 1" placement="bottom" :trigger="uaValue === 'pc' ? 'hover' : 'click'">
                <div style="padding: 10px;">该产品库存预警</div>
                <b slot="reference" class="bone" style="margin: -6px;"><i class="iconfont">&#xe628;</i></b>
              </el-popover>
              <span>{{ scope.row.productName }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="giftStatus == 2" label="规格" prop="specification" show-overflow-tooltip></el-table-column>
          <el-table-column v-if="giftStatus == 1" label="分类" prop="typeName" show-overflow-tooltip></el-table-column>
          <el-table-column v-if="giftStatus == 1" label="项目名称" prop="name" show-overflow-tooltip></el-table-column>
          <el-table-column label="单价（元）" prop="price">
            <template slot-scope="scope">
              <span style="line-height: 23px;">{{ scope.row.price }}</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="alreadyChoose_div">
          <samp>
            已选择:（{{ chooseGiftList.length }}）
          </samp>
          <ul>
            <p v-if="chooseGiftList.length == 0">请选择{{ getGiftVal() }}赠品</p>
            <li v-for="(item, index) in chooseGiftList" :key="index">
              <el-tooltip effect="light" :content="item.name || item.vipCardName" placement="top" :disabled="tooltipStatus">
                <span class="single_row" style="width:120px" @mouseover="tooltipStatus = Lib.textShow($event)">{{ item.name || item.vipCardName }}</span>
              </el-tooltip>
              <el-button type="text" @click="delChooseGift(item,index)">
                删除
              </el-button>
            </li>
          </ul>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <div style="float: left;height: 41px;margin-top: -8px;">
          <el-pagination :hide-on-single-page="true" :current-page.sync="giftPageNum" :page-size="10" layout="prev, pager, next, jumper" :total="giftTotalCount" @size-change="handleSizeChange" @current-change="handleCurrentChange">
          </el-pagination>
        </div>
        <div style="float: right;">
          <el-button @click="addGiftDia = false">
            取 消
          </el-button>
          <el-button type="primary" @click="comfirmAddGift">
            确 定
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog class="merchandiserDialog chooseServiceCss" width="1000px" :title="Lib.collectively()+'列表'" :visible.sync="MerchandiserDialog" :append-to-body="true">
      <div class="el-message-box__content" style="height: 586px;padding: 0;">
        <div class="dialog_header">
          <el-input v-model="searchMerchandiserVal" class="width_282" placeholder="请输入员工姓名/工号" style="float:left;" @keyup.enter.native="commonSearch(1,'11')">
            <i slot="suffix" class="el-input__icon el-icon-search" style="cursor: pointer;" @click="commonSearch(1,'11')"></i>
          </el-input>
          <el-tooltip effect="light" :content="dialogServiceName" placement="top" :disabled="tooltipStatus">
            <p @mouseover="tooltipStatus = Lib.textShow($event)">项目名称：{{ dialogServiceName }}</p>
          </el-tooltip>
          <h6>
            <span>合计：</span>
            <label>￥{{ dialogServiceTotal }}</label>
            <samp>￥{{ dialogServicePreTotal }}</samp>
          <!-- <el-tooltip effect="light" content="小计=原价/折后价×项目次数" placement="bottom">
                            <i class="iconfont iconCdTwo">&#xe71a;</i>
                        </el-tooltip> -->
          </h6>
        </div>
        <div class="commonTable tablePointer" style="height: 528px;border: 1px solid #eee;width: 280px;float: left;overflow: hidden;">
          <el-tabs v-if="brandInfo.cardOpen == 1" v-model="activeName" class="brandList" @tab-click="getStaffData">
            <el-tab-pane v-for="(v,n) in brandInfo.cards" :key="n" :label="v.cardName" :name="v.id+''">
              <span v-if="v.cardName == '未分配'" slot="label">{{ v.cardName }}
                <el-tooltip class="item" effect="light" :content="'展示后台未分配轮牌的'+Lib.collectively()" placement="right">
                  <i class="el-icon-warning"></i>
                </el-tooltip>
              </span>
            </el-tab-pane>
          </el-tabs>
          <el-table ref="searchMerchandiserTable" v-loading="loading" tooltip-effect="light" :data="searchMerchandiserList" class="newSelect" height="530" @select="selectMerchandiser" @row-click="rowClickMerchandiser">
            <el-table-column :class-name="'ht_23'" type="selection" width="45" :selectable="checkSelectable"></el-table-column>
            <el-table-column label="工号" width="100">
              <template slot-scope="scope">
                <el-popover v-if="menusList.find(data => data.iDenTi === 'beauty-1-lp')" placement="right" trigger="hover" :disabled="!scope.row.message">
                  <p style="padding: 10px;">{{ scope.row.message || '空闲中' }}</p>
                  <label slot="reference" :class="'stafIcon ' + (scope.row.state == 1 ? 'sifour' : scope.row.state == 2 ? 'sitwo' : scope.row.state == 3 ? 'sithree' : scope.row.state == 4 ? 'sifive' : scope.row.state == 5 ? 'sifive' : scope.row.state == 6 ? 'sifive' : 'sione')"></label>
                </el-popover>
                <el-tooltip effect="light" placement="top" :disabled="tooltipStatus">
                  <div slot="content">
                    <p>{{ scope.row.number }}</p>
                  </div>
                  <span class="commonTableShow" style="width: 60px;padding-left: 5px;" @mouseover="tooltipStatus = Lib.textShow($event)">{{ scope.row.number || '--' }}</span>
                </el-tooltip>
              </template>
            <!-- <template slot-scope="scope">
                                <span>{{scope.row.number || '--'}}</span>
                            </template> -->
            </el-table-column>
            <el-table-column prop="technicianName" label="姓名" :show-overflow-tooltip="true"></el-table-column>
          </el-table>
        </div>
        <div class="commonTable" style="height: 528px;border: 1px solid #eee;width: 630px;float: right;">
          <el-table tooltip-effect="light" class="merchandiserTable" :data="chooseMerchandiserList" height="530">
            <el-table-column label="员工" width="160" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <span>{{ scope.row.technicianName }}</span>
              </template>
            </el-table-column>
            <el-table-column label="点客">
              <template slot-scope="scope">
                <el-checkbox v-model="scope.row.isGuest" :true-label="1" :false-label="0" @change="changeCheckboxList(scope.$index,scope.row)"></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column label="提成点">
              <template slot-scope="scope">
                <el-input v-if="scope.row.levelType == 0" v-model="scope.row.percentage" size="mini" style="width: 100px;" placeholder="" :maxlength="6" :disabled="Lib.getPercentage()" @change="changeCheckboxList">
                  <template slot="append">{{ scope.row.percentageType === 1?'元':'%' }}</template>
                </el-input>
                <span v-else>--</span>
              </template>
            </el-table-column>
            <el-table-column prop="number" label="操作" width="80">
              <template slot-scope="scope">
                <yz-btn type="delete" @click="delChooseTechnician(scope.row.technicianId)">删除</yz-btn>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="newFootCss">
        <div class="newFootBtn">
          <el-button type="primary" @click="comfirmAddProject">确 定</el-button>
          <el-button @click="MerchandiserDialog = false">取 消</el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog class="merchandiserDialog chooseServiceCss" width="1000px" title="销售列表" :visible.sync="saleDialog" :append-to-body="true">
      <div class="el-message-box__content" style="height: 606px;padding: 0;">
        <div class="dialog_header">
          <el-input v-model="searchSaleVal" class="width_282" size="medium" placeholder="请输入员工姓名/工号" style="float:left;" @keyup.enter.native="commonSearch(2,'22')">
            <i slot="suffix" class="el-input__icon el-icon-search" style="cursor: pointer;" @click="commonSearch(2,'22')"></i>
          </el-input>
          <p>
            <el-tooltip effect="light" :content="dialogServiceName" placement="top" :disabled="tooltipStatus">
              <span @mouseover="tooltipStatus = Lib.textShow($event)">项目名称：{{ dialogServiceName }}</span>
            </el-tooltip>
            <el-tooltip effect="light" placement="right-start">
              <div slot="content">
                <p class="tooltip-p">提成点和提成金额展示“--”有三种情况：</p>
                <p class="tooltip-p">1.该项目在后台没有设置任何提成</p>
                <p class="tooltip-p">2.该项目在后台仅设置了销售达标提成</p>
                <p class="tooltip-p">3.该项目在后台仅设置了高级提成</p>
              </div>
              <i class="iconfont iconCdTwo">&#xe71a;</i>
            </el-tooltip>
          </p>
          <h6>
            <span>合计：</span>
            <label>￥{{ dialogServiceTotal }}</label>
            <samp>￥{{ dialogServicePreTotal }}</samp>
          <!-- <el-tooltip effect="light" content="小计=原价/折后价×项目次数" placement="right">
                            <i class="iconfont iconCdTwo">&#xe71a;</i>
                        </el-tooltip> -->
          </h6>
        </div>

        <div class="commonTable tablePointer" style="height: 528px;border: 1px solid #eee;width: 280px;float: left;overflow: hidden;">
          <el-tabs v-if="brandInfo.cardOpen == 1" v-model="activeName" class="brandList" @tab-click="getSaleData">
            <el-tab-pane v-for="(v,n) in brandInfo.cards" :key="n" :label="v.cardName" :name="v.id+''">
              <span v-if="v.cardName == '未分配'" slot="label">{{ v.cardName }}
                <el-tooltip class="item" effect="light" content="展示后台未分配轮牌的销售" placement="right">
                  <i class="el-icon-warning"></i>
                </el-tooltip>
              </span>
            </el-tab-pane>
          </el-tabs>
          <el-table ref="searchSaleTable" v-loading="loading" tooltip-effect="light" :data="searchSaleList.lookTechnicians" class="newSelect" height="530" @select="selectSale" @row-click="rowClickSale">
            <el-table-column :class-name="'ht_23'" type="selection" width="45" :selectable="checkSelectable"></el-table-column>
            <el-table-column label="工号" width="100">
              <template slot-scope="scope">
                <el-popover v-if="menusList.find(data => data.iDenTi === 'beauty-1-lp')" placement="right" trigger="hover">
                  <p style="padding: 10px;">{{ scope.row.message || '空闲中' }}</p>
                  <label slot="reference" :class="'stafIcon ' + (scope.row.state == 1 ? 'sifour' : scope.row.state == 2 ? 'sitwo' : scope.row.state == 3 ? 'sithree' : scope.row.state == 4 ? 'sifive' : scope.row.state == 5 ? 'sifive' : scope.row.state == 6 ? 'sifive' : 'sione')"></label>
                </el-popover>
                <el-tooltip effect="light" placement="top" :disabled="tooltipStatus">
                  <div slot="content">
                    <p>{{ scope.row.number }}</p>
                  </div>
                  <span class="commonTableShow" style="width: 60px;padding-left: 5px;" @mouseover="tooltipStatus = Lib.textShow($event)">{{ scope.row.number || '--' }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column prop="technicianName" label="姓名" :show-overflow-tooltip="true"></el-table-column>
          </el-table>
        </div>
        <div class="commonTable" style="height: 528px;border: 1px solid #eee;width: 630px;float: right;">
          <el-table tooltip-effect="light" class="merchandiserTable" :data="chooseSaleList" height="530">
            <el-table-column label="员工" width="160" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <span>{{ scope.row.technicianName }}</span>
              </template>
            </el-table-column>
            <el-table-column label="业绩占比">
              <template slot-scope="scope">
                <el-input v-model="scope.row.result" oninput="this.value = this.value.replace(/[^\d\.]|(?<=\d?\.\d?)\.|(?<=\d+\.\d{0})[\d+\.]/g, '')" size="mini" style="width: 100px;" :disabled="Lib.getPercentage()" placeholder="" @change="resultChange(scope.$index,1)">
                  <template slot="append">%</template>
                </el-input>
              </template>
            </el-table-column>
            <el-table-column label="提成点">
              <template slot-scope="scope">
                <div v-if="scope.row.isExit == 1">
                  <el-input v-if="scope.row.levelType == 0" v-model="scope.row.percentage" size="mini" style="width: 100px;" placeholder="" :maxlength="6" :disabled="Lib.getPercentage()" @change="resultChange(scope.$index,11)">
                    <template slot="append">{{ scope.row.percentageType == 1?'元':'%' }}</template>
                  </el-input>
                  <span v-else>--</span>
                </div>
                <div v-else>--</div>
              </template>
            </el-table-column>
            <el-table-column prop="number" label="操作" width="80">
              <template slot-scope="scope">
                <yz-btn type="delete" @click="delChooseSale(scope.row.technicianId)">删除</yz-btn>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="newFootCss">
        <div class="newFootBtn">
          <el-button type="primary" @click="comfirmAddSale">确 定</el-button>
          <el-button @click="saleDialog = false">取 消</el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog class="merchandiserDialog chooseServiceCss" width="1000px" title="销售员工列表" :visible.sync="productMDialog" :append-to-body="true">
      <div class="el-message-box__content" style="height: 606px;padding: 0;">
        <div class="dialog_header">
          <el-input v-model="searchPMVal" class="width_282" size="medium" placeholder="请输入员工姓名/工号" style="float:left;" @keyup.enter.native="commonSearch(3,'33')">
            <i slot="suffix" class="el-input__icon el-icon-search" style="cursor: pointer;" @click="commonSearch(3,'33')"></i>
          </el-input>
          <p>
            <el-tooltip effect="light" :content="dialogProductName" placement="top" :disabled="tooltipStatus">
              <span @mouseover="tooltipStatus = Lib.textShow($event)">产品名称：{{ dialogProductName }}</span>
            </el-tooltip>
            <el-tooltip effect="light" placement="right-start">
              <div slot="content">
                <p class="tooltip-p">提成点和提成金额展示“--”有三种情况：</p>
                <p class="tooltip-p">1.该产品在后台没有设置任何提成</p>
                <p class="tooltip-p">2.该产品在后台仅设置了销售达标提成</p>
                <p class="tooltip-p">3.该产品在后台仅设置了高级提成</p>
              </div>
              <i class="iconfont iconCdTwo">&#xe71a;</i>
            </el-tooltip>
          </p>
          <h6>
            <span>合计：</span>
            <label>￥{{ dialogTotal }}</label>
            <samp>￥{{ dialogPreTotal }}</samp>
            <el-tooltip effect="light" content="合计=折后价/原价×数量" placement="right">
              <i class="iconfont iconCdTwo">&#xe71a;</i>
            </el-tooltip>
          </h6>
        </div>

        <div class="commonTable tablePointer" style="height: 528px;border: 1px solid #eee;width: 280px;float: left;overflow: hidden;">
          <el-tabs v-if="brandInfo.cardOpen == 1" v-model="activeName" class="brandList" @tab-click="getProductStaffData">
            <el-tab-pane v-for="(v,n) in brandInfo.cards" :key="n" :label="v.cardName" :name="v.id+''">
              <span v-if="v.cardName == '未分配'" slot="label">{{ v.cardName }}
                <el-tooltip class="item" effect="light" content="展示后台未分配轮牌的销售" placement="right">
                  <i class="el-icon-warning"></i>
                </el-tooltip>
              </span>
            </el-tab-pane>
          </el-tabs>
          <el-table ref="productTCTable" v-loading="loading" tooltip-effect="light" :data="searchPMList.lookTechnicians" class="newSelect" height="530" @select="selectChoosePMEvent" @row-click="choosePMEvent">
            <el-table-column :class-name="'ht_23'" type="selection" width="45" :selectable="checkSelectable"></el-table-column>
            <el-table-column label="工号" width="100">
              <template slot-scope="scope">
                <el-popover v-if="menusList.find(data => data.iDenTi === 'beauty-1-lp')" placement="right" trigger="hover">
                  <p style="padding: 10px;">{{ scope.row.message || '空闲中' }}</p>
                  <label slot="reference" :class="'stafIcon ' + (scope.row.state == 1 ? 'sifour' : scope.row.state == 2 ? 'sitwo' : scope.row.state == 3 ? 'sithree' : scope.row.state == 4 ? 'sifive' : scope.row.state == 5 ? 'sifive' : scope.row.state == 6 ? 'sifive' : 'sione')"></label>
                </el-popover>
                <el-tooltip effect="light" placement="top" :disabled="tooltipStatus">
                  <div slot="content">
                    <p>{{ scope.row.number }}</p>
                  </div>
                  <span class="commonTableShow" style="width: 60px;padding-left: 5px;" @mouseover="tooltipStatus = Lib.textShow($event)">{{ scope.row.number || '--' }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column prop="technicianName" label="姓名" :show-overflow-tooltip="true"></el-table-column>
          </el-table>
        </div>
        <div class="commonTable" style="height: 528px;border: 1px solid #eee;width: 630px;float: right;">
          <el-table tooltip-effect="light" class="merchandiserTable" :data="choosePMList" height="530">
            <el-table-column label="员工" width="160" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <span>{{ scope.row.technicianName }}</span>
              </template>
            </el-table-column>
            <el-table-column label="业绩占比">
              <template slot-scope="scope">
                <el-input v-model="scope.row.result" oninput="this.value = this.value.replace(/[^\d\.]|(?<=\d?\.\d?)\.|(?<=\d+\.\d{0})[\d+\.]/g, '')" size="mini" style="width: 100px;" :disabled="Lib.getPercentage()" placeholder="" @change="resultChange(scope.$index,2)">
                  <template slot="append">%</template>
                </el-input>
              </template>
            </el-table-column>
            <el-table-column label="提成点">
              <template slot-scope="scope">
                <div v-if="scope.row.isExit == 1">
                  <el-input v-if="scope.row.levelType == 0" v-model="scope.row.percentage" size="mini" style="width: 100px;" placeholder="" :maxlength="6" :disabled="Lib.getPercentage()" @change="resultChange(scope.$index,22)">
                    <template slot="append">{{ scope.row.percentageType == 1?'元':'%' }}</template>
                  </el-input>
                  <span v-else>--</span>
                </div>
                <div v-else>--</div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="newFootCss">
        <div class="newFootBtn">
          <el-button type="primary" @click="comfirmAddPM">确 定</el-button>
          <el-button @click="productMDialog = false">取 消</el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog class="merchandiserDialog chooseServiceCss" width="1000px" title="选择销售人员" :visible.sync="packageDialog" :append-to-body="true">
      <div class="el-message-box__content" style="height: 606px;padding: 0;">
        <div class="dialog_header">
          <el-input v-model="searchPackageVal" class="width_282" placeholder="请输入员工姓名/工号" style="float:left;" @keyup.enter.native="commonSearch(4,'44')">
            <i slot="suffix" class="el-input__icon el-icon-search" style="cursor: pointer;float:left;" @click="commonSearch(4,'44')"></i>
          </el-input>
          <p>
            <el-tooltip effect="light" :content="dialogPackageName" placement="top" :disabled="tooltipStatus">
              <span @mouseover="tooltipStatus = Lib.textShow($event)">套餐名称：{{ dialogPackageName }}</span>
            </el-tooltip>
            <el-tooltip effect="light" placement="right-start">
              <div slot="content">
                <p class="tooltip-p">提成点和提成金额展示“--”有三种情况：</p>
                <p class="tooltip-p">1.该套餐在后台没有设置任何提成</p>
                <p class="tooltip-p">2.该套餐在后台仅设置了销售达标提成</p>
                <p class="tooltip-p">3.该套餐在后台仅设置了高级提成</p>
              </div>
              <i class="iconfont iconCdTwo">&#xe71a;</i>
            </el-tooltip>
          </p>
          <h6>
            <span>合计：</span>
            <label>￥{{ dialogPackageTotal }}</label>
            <samp>￥{{ dialogPackagePreTotal }}</samp>
            <el-tooltip effect="light" content="合计=折后价/原价×数量" placement="right">
              <i class="iconfont iconCdTwo">&#xe71a;</i>
            </el-tooltip>
          </h6>
        </div>

        <div class="commonTable tablePointer" style="height: 528px;border: 1px solid #eee;width: 280px;float: left;overflow: hidden;">
          <el-tabs v-if="brandInfo.cardOpen == 1" v-model="activeName" class="brandList" @tab-click="getStaffIdListData">
            <el-tab-pane v-for="(v,n) in brandInfo.cards" :key="n" :label="v.cardName" :name="v.id+''">
              <span v-if="v.cardName == '未分配'" slot="label">{{ v.cardName }}
                <el-tooltip class="item" effect="light" content="展示后台未分配轮牌的销售" placement="right">
                  <i class="el-icon-warning"></i>
                </el-tooltip>
              </span>
            </el-tab-pane>
          </el-tabs>
          <el-table ref="packageTCTable" v-loading="loading" tooltip-effect="light" :data="searchPackageList.lookTechnicians" class="newSelect" height="530" @select="selectChoosePackageEvent" @row-click="choosePackageEvent">
            <el-table-column :class-name="'ht_23'" type="selection" width="45" :selectable="checkSelectable"></el-table-column>
            <el-table-column prop="number" label="工号" width="100">
              <template slot-scope="scope">
                <el-popover v-if="menusList.find(data => data.iDenTi === 'beauty-1-lp')" placement="right" trigger="hover">
                  <p style="padding: 10px;">{{ scope.row.message || '空闲中' }}</p>
                  <label slot="reference" :class="'stafIcon ' + (scope.row.state == 1 ? 'sifour' : scope.row.state == 2 ? 'sitwo' : scope.row.state == 3 ? 'sithree' : scope.row.state == 4 ? 'sifive' : scope.row.state == 5 ? 'sifive' : scope.row.state == 6 ? 'sifive' : 'sione')"></label>
                </el-popover>
                <el-tooltip effect="light" placement="top" :disabled="tooltipStatus">
                  <div slot="content">
                    <p>{{ scope.row.number }}</p>
                  </div>
                  <span class="commonTableShow" style="width: 60px;padding-left: 5px;" @mouseover="tooltipStatus = Lib.textShow($event)">{{ scope.row.number || '--' }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column prop="technicianName" label="姓名" :show-overflow-tooltip="true"></el-table-column>
          </el-table>
        </div>
        <div class="commonTable" style="height: 528px;border: 1px solid #eee;width: 630px;float: right;">
          <el-table tooltip-effect="light" class="merchandiserTable" :data="choosePackageList" height="530">
            <el-table-column label="员工" width="160" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <span>{{ scope.row.technicianName }}</span>
              </template>
            </el-table-column>
            <el-table-column label="业绩占比">
              <template slot-scope="scope">
                <el-input v-model="scope.row.result" oninput="this.value = this.value.replace(/[^\d\.]|(?<=\d?\.\d?)\.|(?<=\d+\.\d{0})[\d+\.]/g, '')" size="mini" style="width: 100px;" :disabled="Lib.getPercentage()" placeholder="" @change="resultChange(scope.$index,3)">
                  <template slot="append">%</template>
                </el-input>
              </template>
            </el-table-column>
            <el-table-column label="提成点">
              <template slot-scope="scope">
                <div v-if="scope.row.isExit == 1">
                  <el-input v-if="scope.row.levelType == 0" v-model="scope.row.percentage" size="mini" style="width: 100px;" placeholder="" :maxlength="6" :disabled="Lib.getPercentage()" @change="resultChange(scope.$index,33)">
                    <template slot="append">{{ scope.row.percentageType == 1?'元':'%' }}</template>
                  </el-input>
                  <span v-else>--</span>
                </div>
                <div v-else>--</div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="newFootCss">
        <div class="newFootBtn">
          <el-button type="primary" @click="comfirmAddPackage">确 定</el-button>
          <el-button @click="packageDialog = false">取 消</el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog class="memberDialog" :title="digForm.status == 1 ? '会员充值' : '新增会员'" :visible.sync="digForm.memberDialog" :append-to-body="true">
      <iframe :src="digForm.memberManageSrc"></iframe>
    </el-dialog>
    <book :show.sync="bookVisible"></book>
    <checkIntoRoom :id="id" :show.sync="check_in_visible" :phone-number="MemberInfo.phone ? MemberInfo.phone : searchStatus == 1 ? '' : form.phone" :check-in-data="check_in_data" :title-status="titleStatus" @update="updateCheckInData" />
    <!--顾客编辑-->
    <customerDialog v-if="customerVisible" :customer-visible="customerVisible" :title="customerStatus" @close="onCloseDialog" />
    <!-- 自定义服务时长 -->
    <el-dialog class="serviceTimeDialog" title="自定义服务时长" :visible.sync="serviceTimeDialog" width="400px" :append-to-body="true">
      <div class="dialog_header">
        <el-input-number v-model="duration" :min="15" :max="240"></el-input-number>
      </div>
      <div class="newFootCss">
        <div class="newFootBtn">
          <el-button @click="serviceTimeDialog = false">取 消</el-button>
          <el-button type="primary" @click="comfirmSetTime">确 定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getItemTypeAndItemList, // （服务开单或修改订单）获得已经设置的统称项目信息
  getItemListPage, // （服务开单或修改订单）获得已经设置的统称项目item信息
  getProductType, // 获得产品分类信息
  getMemberCardMsg, // 获得会员卡相关信息
  getProductList, // 获得产品列表
  getBeautyPackageList, // 查询会员套餐订单记录
  getOrderItemList, // (3.8.0)根据关键字查询项目，产品，套餐信息
  getBilling4Book, // 获得预约开单需要的信息
  getOrderDetails4Update, // (修改订单)获得服务开单修改需要的数据
  getCanDeductList, // （6.2）获取会员可划扣列表
  getTechnicianListByItemId, // （服务开单或修改订单）根据项目id获得统称列表
  saveOrUpdate, // （3.8.0服务开单或修改订单）新增或修改服务开单数据
  getMemberUrl,
  getPercentageSkin, // （4.5.0）获取全局提成设置
  getCustomerMsgList, // 4.7.0获取顾客列表
  getPayCodeList, // (3.8.0)获得店铺结算设置信息
  erpTechnicianCardByMainId, // 5.7erp选择统称，选择销售的轮牌列表
  getStaffBrandList, // 5.7（服务开单或修改订单）根据项目、产品、套餐id获取统称-员工列表
  getAllOrderCount,
  checkElectronicTicket, // 6.3电子票核销
  getByTechnicianListByCardId, // （6.5）根据轮牌列表查询员工列表
} from './api';
import {
  getAllOrderListPage, getCheckOutOrder, getBookFailures, getSureOrFalse
} from '../../../service/api';
import { getBookCancelMsg } from '../../../publicVue/thirdPage/api';
import drawer from '../../../publicVue/drawer';
import book from '../beautyCard/template/book';
import checkIntoRoom from './components/checkIntoRoom';
import customerDialog from '../../../customer/template/customer_detail';
import PositiveTime from './components/positiveTime';

export default {
  components: {
    book,
    checkIntoRoom,
    customerDialog,
    drawer,
    PositiveTime
  },
  data() {
    return {
      id: '', // 服务开单--订单Id
      navStatus: '1', // 切换状态   1项目  2产品  3套餐
      state: '',
      chooseName: '',
      chooseFormIndex: '',
      MerchandiserDialog: false, // 选择开单员弹出窗口
      chooseItemId: '', // 选择的项目ID
      searchMerchandiserVal: '', // 搜索开单员
      searchMerchandiserList: [], // 搜索开单员列表
      chooseMerchandiserList: [], // 选择开单员列表
      serviceItemIds: '', // 修改订单--删除项目的ids
      productIds: '', // 修改订单--删除产品的ids
      percentageTotal: '0', // 提成总价

      saleDialog: false, // 选择销售员工弹出窗口--项目
      searchSaleVal: '', // 搜索开单员
      searchSaleList: [], // 搜索开单员列表
      chooseSaleList: [], // 选择销售员工列表--项目
      percentageTotalSale: '0', // 提成总价--项目--选择销售

      productMDialog: false, // 选择产品销售开单员--弹出框
      searchPMVal: '', // 搜索产品销售开单员
      searchPMList: {
        lookTechnicians: []
      }, // 搜索得出的统称列表
      choosePMList: [], // 选择的统称列表
      productPercentageTotal: '0',

      packageDialog: false, // 选择开单员--弹出窗口
      searchPackageVal: '', // 开单员列表--搜索值
      searchPackageList: [], // 开单员列表
      choosePackageList: [], // 选择的开单员列表
      searchChoosePackageId: '', // 选择的套餐ID --弹出窗口
      pageNum: 1, // 开单员列表--页码
      rowCount: 1, // 开单员列表--总条数
      packageIndex: '',
      packagePercentageTotal: '0', // 套餐提成总价

      dialogServiceName: '', // 弹出框选择的项目名称
      dialogServiceTotal: 0, // 弹出框选择的项目总价
      dialogServicePreTotal: 0, // 弹出框选择的项目原价
      chooseItemTypeId: '', // 选择的项目分类ID
      itemTypeList: [], // 项目分类列表
      serviceList: [], // 项目列表
      pageNum1: 1, // 项目页码
      pages1: 1, // 项目总页码数

      chooseProductTypeId: '', // 选择的产品分类ID
      productTypeList: [], // 产品分类列表
      productList: [], // 产品列表
      pageNum2: 1, // 产品页码
      pages2: 1, // 产品总页码数

      searchStatus: 1, // 搜索的状态
      mealList: [], // 套餐列表
      pageNum3: 1, // 套餐页码
      pages3: 1, // 套餐总页码数
      dialogPackageName: '', // 弹出框选择的套餐名称
      dialogPackageTotal: 0, // 弹出框选择的套餐总价
      dialogPackagePreTotal: 0, // 弹出框选择的套餐原价

      textareaVal: '', // 备注内容
      listTotal: '0.00', // 订单合计
      MemberInfo: { // 会员信息
        discount: '',
      },
      form: { // 表单信息
        phone: '',
        name: '',
        number: '',
        count: '',
        bookOrderId: '',
        tableData: [],
        packageData: []
      },

      uaValue: 'pc', // 判断是手机端还是PC端   pc为PC端，mobile为手机端
      submitBtnStatus: false,
      scaleStan: 0, // 全局提成  0为原价算提成   1为折后价算提成
      resultType: 1, // 业绩占比   1为整单业绩  2为自动平分

      tooltipStatus: false, // 文字过长的显示和隐藏
      digForm: {
        memberDialog: false, // 新增会员弹框
        memberManageSrc: '',
        status: 0,
      },
      choosePMIndex: 0,
      dialogProductName: '',
      dialogTotal: 0,
      dialogPreTotal: 0,
      innerVisible: false,
      bookVisible: false,
      deadlineStatus: window.sessionStorage.deadlineStatus,
      desktopStatus: false, // 判断是否是桌面端
      // 5.3.0专用
      check_in_visible: false,
      check_in_loading: false,
      check_in_data: {
        roomInfosList: [{
          roomName: '',
          peopleNumber: ''
        }]
      },
      roomBtnStatus: 1, // 开房按钮展现与否  1不展示（没有房态菜单）  2展示
      inputShow: 1, // 1展示  2不展示
      editOldPriceStatus: '', // 改原价状态
      editDiscountPriceStatus: '', // 改折后价状态
      radioChange: '',

      // 5.6
      loading1: true,
      loading2: true,
      loading3: true,
      loading4: false,
      loadS1: true,
      loadS2: true,
      loadS3: true,
      isDeduct: 0, // 是否是划扣
      customerVisible: false, // 顾客编辑弹窗
      customerInfo: {}, // 顾客信息数据
      bookStatus: 3, // 预约定金状态

      // 5.7
      brandInfo: {},
      activeName: '',

      // 5.8
      clickS1: false,
      clickS2: false,

      // 5.9
      handCustomer: {
        id: '',
        manNumber: 0,
        womanNumber: 0,
        midNumber: 1
      },
      handList: [],
      // delHandList: [],
      handSwitch: 0, // 订单手牌开关  0开  1关
      customerSwitch: 0, // 订单顾客开关  0开  1关

      // 5.10
      titleStatus: window.sessionStorage.tidyStatus, // 设置的房态  1房间  2床位  3台位

      // 6.2
      radioLeft: '1',
      activeIndex: '项目',
      giftProjectList: [],
      giftProductList: [],
      giftPackageList: [],
      ticketList: [],
      ticketProjectList: [],
      giftStatus: 1, // 赠品标题
      addGiftDia: false, // 赠品--弹出窗
      giftTypeId: '', // 赠品--分类ID值
      giftTypeList: [],
      giftSearchVal: '', // 赠品--搜索值
      addGiftList: [], // 赠品列表
      chooseGiftList: [], // 选择赠品列表
      giftPageNum: 1, // 赠品页码
      giftTotalCount: 1, // 赠品总条数
      takeOrderDia: false, // 取单弹出窗口
      loading: true,
      toList: [{ orderContent: [] }, { orderContent: [] }, { orderContent: [] }, { orderContent: [] }],
      toPageSize: 9,
      toPageNum: 1,
      toRowCount: 0,
      chooseId: '', // 取消预约的ID
      cancelStatus: 1, // 取消预约退不退定金
      diaStatus: 3, // 弹出窗口文案提示状态
      dialogVisible: false,
      delForm: {
        delDiglogStatus: false,
        title: '',
        id: '',
        url: 'deleteOrder',
        text1: '',
        text2: '',
        status: false
      },
      giftSvList: [],
      giftPdList: [],
      giftPkList: [],
      pickerOptions: {
        disabledDate(time) {
          return Date.now() > time.getTime() + 3600 * 1000 * 24;
        }
      },
      menusList: JSON.parse(window.sessionStorage.menusList),
      codeNum: new Date().getTime(),
      orderCount: 0,
      giftLoad: true,

      // 6.3
      writeOffDia: false,
      paymentCode: '',
      loadStatus: 1,

      // 6.5
      allDisplay: false, // 项目/产品/套餐选择优惠权益
      qyIndex: '', // 选择优惠权益的索引值
      pjdActiveName: 'first', // 项目选择优惠权益--tab切换
      projectRI: '', // 项目选择优惠权益--选择的具体优惠权益
      productRI: [], // 产品选择优惠权益--选择的具体优惠权益
      packageRI: [], // 套餐选择优惠权益--选择的具体优惠权益
      chooseInfoRI: {
        qyList: [],
        package: []
      }, // 优惠权益--选择的
      batchAddDia: false, // 批量添加销售--弹出窗口
      batchAddVal: '', // 批量添加销售--搜索值
      buyGiftList: [], // 买赠赠送的商品
      fullGiftList: [], // 满赠赠送的商品

      // 6.7
      actServiceType: '',
      actProductType: '',
      apackageType: '',

      // 6.8
      serviceTimeDialog: false, // 自定义服务时长弹窗
      duration: 15, // 自定义服务时长的值
      chooseServiceIndex: 0, // 选择修改的自定义时长索引值

      // 6.81
      customerStatus: '新增顾客',
    };
  },
  watch: {
    pageNum1(val) {
      this.pageNum1 = val * 1;
    },
    pageNum2(val) {
      this.pageNum2 = val * 1;
    },
    'digForm.memberDialog': function (val) {
      if (val == false) {
        this.memberSearch();
      }
    },
    customerVisible(val) {
      if (val == false) this.newEditMemberPhone();
    },
    // 6.2
    radioLeft(val) {
      if (val == 3) {
        this.handleClick({ label: '套餐' });
      } else if (val == 2) {
        this.activeIndex = '套餐';
        this.buckleTab({ label: this.activeIndex });
      } else {
        this.activeIndex = '项目';
        this.handleClick({ label: this.activeIndex });
      }
    },
    addGiftDia(val) {
      if (val == false) {
        this.addGiftList = [];
      }
    },
    'delForm.status': function (val) {
      if (val == true) {
        this.toPageNum = 1;
        this.getTakeOrderData();
      }
    },
    writeOffDia(val) {
      if (val == false) this.paymentCode = '';
    },
    allDisplay(val) {
      if (!val) this.formChange();
    },
  },
  activated() {
    this.getOrderCount();
    this.initialization();
  },
  methods: {
    // 数据重新加载
    refreshData() {
      this.memberSearch();
    },
    // 新增顾客
    showCustomerDialog() {
      if (this.Lib.checkPower('beauty-2-xzgk') == false) return;
      this.customerStatus = '新增顾客';
      this.customerVisible = true;
    },
    // 设置服务时长
    setTime(index) {
      this.chooseServiceIndex = index;
      this.duration = JSON.parse(JSON.stringify(this.form.tableData[this.chooseServiceIndex].serviceTime));
      this.serviceTimeDialog = true;
    },
    // 确认设置服务时长
    comfirmSetTime() {
      this.form.tableData[this.chooseServiceIndex].serviceTime = JSON.parse(JSON.stringify(this.duration));
      this.serviceTimeDialog = false;
    },
    tipInfo() {
      this.$message({ type: 'warning', message: '已经是最小数量了' });
    },
    forceUpdate() {
      this.$forceUpdate();
    },
    // 展示原价金额
    showOriginalPrice(obj) {
      if (obj.listStatus == 1) {
        if (obj.qyCheckBox == 1) {
          return obj.wholesalePrice;
        }
        return obj.price;
      }
      let status = 0;
      obj.qyCheckBox.forEach((a) => {
        if (a == 1) {
          status = 1;
        }
      });
      if (status == 1) {
        return obj.wholesalePrice;
      }
      return obj.price;
    },
    // 计算折后价
    calculationDiscountMoney(obj, index) {
      let total = 0;
      if (obj.listStatus == 1) {
        obj.qyCheckBox = obj.qyCheckBox || '';
      } else {
        obj.qyCheckBox = obj.qyCheckBox || [];
      }
      obj.qyList = obj.qyList || [];
      obj.package = obj.package || [];
      obj.qyList.forEach((a) => {
        if (obj.listStatus == 1) {
          if (obj.qyCheckBox == a.type) {
            if (a.type == 1 || a.type == 2 || a.type == 3 || a.type == 4 || a.type == 5) {
              total += (a.originalPrice - a.rightsPrice) * a.qyCount;
            }
          }
        } else {
          obj.qyCheckBox.forEach((b) => {
            if (b == a.type) {
              if (a.type == 1 || a.type == 2 || a.type == 3 || a.type == 4 || a.type == 5) {
                total += (a.originalPrice - a.rightsPrice) * a.qyCount;
              }
            }
          });
        }
      });
      obj.package.forEach((b) => {
        if (obj.listStatus == 1) {
          if (obj.qyCheckBox == (b.clientVipCardId || b.giftId || b.eitemId)) {
            total += obj.price * b.qyCount;
          }
        } else {
          obj.qyCheckBox.forEach((c) => {
            if (c == (b.clientVipCardId || b.giftId || b.eitemId)) {
              total += obj.price * b.qyCount;
            }
          });
        }
      });
      const lastPrice = ((obj.price * obj.count - total) / obj.count).toFixed(2);
      this.form.tableData[index].discountMoney = lastPrice;
      return lastPrice;
    },
    // 判断批量添加销售按钮隐藏与否
    batchAddSalesIsshow() {
      let status = 0;
      this.form.tableData.forEach((a) => {
        if ((a.listStatus == 1 || a.listStatus == 2) && this.salesEquity(a)) {
          status = 1;
        } else if (a.listStatus == 3) {
          status = 1;
        }
      });
      return status;
    },
    // 项目或者产品--判断是否可以选择销售
    salesEquity(obj) {
      if (obj.listStatus == 1) {
        if (obj.qyCheckBox * 1 < 100) { return true; }
        return false;
      } if (obj.listStatus == 2) {
        let num = 0;
        obj.qyCheckBox.forEach((a) => {
          if (a * 1 < 100) num = 1;
        });
        if (num == 1) { return true; }
        return false;
      }
    },
    // 获取买赠的赠品列表
    getBuyGiftList() {
      this.buyGiftList = [];
      this.fullGiftList = [];
      const newArr = [];
      const newArrTwo = [];
      this.form.tableData.forEach((a) => {
        if (a.hasActivity == 1) {
          if (a.activityInfo.activityType == 3 && (a.listStatus == 2 || a.listStatus == 3)) {
            let max = 0;
            let maxIndex = 0;
            a.activityInfo.lookActivityGivenList.forEach((b, n) => {
              if (a.count >= b.buyNumber && b.buyNumber * 1 > max) {
                max = b.buyNumber;
                maxIndex = n;
              }
            });
            const val = a.activityInfo.lookActivityGivenList[maxIndex];
            if (val.givenType == 1 && a.count >= val.buyNumber) {
              val.lookActivityGivenConditionList.forEach((c) => {
                c.buyGiftCount = c.giftCount;
                this.buyGiftList.push(c);
              });
            } else if (val.givenType == 2 && a.count >= val.buyNumber) {
              val.lookActivityGivenConditionList.forEach((c) => {
                // eslint-disable-next-line operator-assignment
                c.buyGiftCount = Math.floor(a.count / val.buyNumber) * c.giftCount;
                this.buyGiftList.push(c);
              });
            }
          }
          if (a.activityInfo.activityType == 4) {
            const obj = {};
            obj.activityId = a.activityInfo.activityId;
            obj.lookActivityGivenList = a.activityInfo.lookActivityGivenList;
            obj.total = this.calculationPreferential(a);
            if (newArrTwo.find((b) => b.activityId == a.activityInfo.activityId)) {
              newArrTwo.find((b, n) => {
                if (b.activityId == a.activityInfo.activityId) {
                  newArrTwo[n].total = (newArrTwo[n].total * 1 + this.calculationPreferential(a) * 1).toFixed(2);
                }
              });
            } else {
              newArrTwo.push(obj);
            }
          }
        }
        if (a.listStatus == 1 && a.hasActivity == 1) {
          if (a.activityInfo.activityType == 3) {
            const obj = {};
            obj.activityInfo = a.activityInfo;
            obj.count = a.count;
            obj.id = a.dictItemId;
            newArr.push(obj);
          }
        }
      });
      const arr = [];
      newArr.forEach((x) => {
        let num = 0;
        newArr.forEach((y) => {
          if (x.id == y.id) {
            num += 1;
          }
        });
        x.count = num;
        arr.push(x);
      });
      const res = new Map();
      const giftArr = arr.filter((z) => !res.has(z.id) && res.set(z.id, 1));
      giftArr.forEach((i) => {
        let max = 0;
        let maxIndex = 0;
        i.activityInfo.lookActivityGivenList.forEach((b, n) => {
          if (i.count >= b.buyNumber && b.buyNumber * 1 > max) {
            max = b.buyNumber;
            maxIndex = n;
          }
        });
        const val = i.activityInfo.lookActivityGivenList[maxIndex];
        if (val.givenType == 1 && i.count >= val.buyNumber) {
          val.lookActivityGivenConditionList.forEach((c) => {
            c.buyGiftCount = c.giftCount;
            this.buyGiftList.push(c);
          });
        } else if (val.givenType == 2 && i.count >= val.buyNumber) {
          val.lookActivityGivenConditionList.forEach((c) => {
            // eslint-disable-next-line operator-assignment
            c.buyGiftCount = Math.floor(i.count / val.buyNumber) * c.giftCount;
            this.buyGiftList.push(c);
          });
        }
      });

      // 6.6满赠算法
      newArrTwo.forEach((i) => {
        let max = 0;
        let maxIndex = 0;
        i.lookActivityGivenList.forEach((b, n) => {
          if (i.total >= b.satisfyPrice && b.satisfyPrice * 1 > max) {
            max = b.satisfyPrice;
            maxIndex = n;
          }
        });
        const val = i.lookActivityGivenList[maxIndex];
        if (i.total >= val.satisfyPrice) {
          val.lookActivityGivenConditionList.forEach((c) => {
            c.buyGiftCount = c.giftCount;
            this.fullGiftList.push(c);
          });
        }
      });
    },
    // 勾选赋值--套餐
    checkValueTc(val) {
      this.packageRI = [val];
      this.chooseInfoRI.qyList.forEach((b) => {
        if (b.type == val) {
          b.qyCount = this.form.tableData[this.qyIndex].count;
          b.ischeck = true;
        } else {
          b.ischeck = false;
        }
      });
    },
    // 勾选判断--套餐
    checkDisabledTc(v) {
      const obj = this.chooseInfoRI;
      if (this.allDisplay) {
        if ((obj.chooseCount == this.form.tableData[this.qyIndex].count || this.packageRI.length == 2) && v.ischeck == false) {
          return true;
        }
      }
      if (obj.qyList.find((a) => a.type == 2)) {
        if (this.packageRI.find((a) => a == 4)) {
          return !!(v.type == 5 || v.type == 99);
        } if (this.packageRI.find((a) => a == 5)) {
          return !!(v.type == 4 || v.type == 99);
        } if (this.packageRI.find((a) => a == 99)) {
          return !!(v.type == 4 || v.type == 5);
        }
      }
    },
    // 勾选判断--项目权益
    checkPqyDisabled(v) {
      if (v.type == 2) {
        let num = 0;
        this.form.tableData.forEach((a, m) => {
          if ((a.dictItemId == this.chooseInfoRI.dictItemId) && (a.qyCheckBox == 2) && (this.qyIndex * 1 != m * 1)) {
            num++;
          }
        });
        if (v.promotionSaleCount * 1 == num * 1) {
          return true;
        }
        return false;
      }
      return false;
    },
    // 勾选判断--项目划扣
    checkXmDisabled(v) {
      let num = 0;
      this.form.tableData.forEach((a) => {
        if ((a.qyCheckBox == (v.clientVipCardId || v.giftId || v.eitemId))) {
          num += v.qyCount * 1;
        }
      });
      let total = 9999;
      if (v.countLimitType == 1) {
        v.canDeductItemDetailList.forEach((c) => {
          if (c.dictItemId == this.chooseInfoRI.dictItemId) {
            total = c.remaining;
          }
        });
      } else if (v.countLimitType == 3) {
        total = v.remaining;
      } else {
        total = 999;
      }
      if (total * 1 > num * 1) {
        return false;
      }
      return true;
    },
    // 勾选赋值--产品
    checkValueCp(val) {
      this.productRI = [val];
      this.chooseInfoRI.qyList.forEach((b) => {
        if (b.type == val) {
          b.qyCount = this.form.tableData[this.qyIndex].count;
          b.ischeck = true;
        } else {
          b.ischeck = false;
        }
      });
    },
    // 勾选判断--产品权益
    checkDisabledCpqy(v) {
      const obj = this.chooseInfoRI;
      const arr = [];
      this.productRI.forEach((a) => {
        if (a * 1 < 7) {
          arr.push(a);
        }
      });
      if (this.allDisplay) {
        if ((obj.chooseCount == this.form.tableData[this.qyIndex].count || arr.length == 2) && v.ischeck == false) {
          return true;
        }
      }
      if (obj.qyList.find((a) => a.type == 2)) {
        if (arr.find((a) => a == 4)) {
          return !!(v.type == 5 || v.type == 99);
        } if (arr.find((a) => a == 5)) {
          return !!(v.type == 4 || v.type == 99);
        } if (arr.find((a) => a == 99)) {
          return !!(v.type == 4 || v.type == 5);
        }
      }
    },
    // 勾选判断--产品划扣
    checkDisabledCphk(v) {
      let num = 0;
      this.form.tableData.forEach((a) => {
        if ((a.qyCheckBox == (v.clientVipCardId || v.giftId || v.eitemId))) {
          num += v.qyCount * 1;
        }
      });
      let total = 9999;
      if (v.countLimitType == 1) {
        v.canDeductProductDetailList.forEach((c) => {
          if (c.productId == this.chooseInfoRI.productId) {
            total = c.remaining;
          }
        });
      } else if (v.countLimitType == 3) {
        total = v.remaining;
      } else {
        total = 999;
      }
      const obj = this.chooseInfoRI;
      if (this.allDisplay) {
        if ((obj.chooseCount == this.form.tableData[this.qyIndex].count) && !v.ischeck) {
          return true;
        }
      }
      if (total * 1 > num * 1) {
        return false;
      }
      return true;
    },
    // 选择/改变优惠权益
    qyChange(index, status, tabs, vObj) {
      const obj = this.chooseInfoRI;
      if (obj.listStatus == 1) {
        obj.qyList.forEach((b) => {
          if (this.projectRI == b.type) {
            b.ischeck = true;
          } else {
            b.ischeck = false;
          }
        });
        obj.package.forEach((j) => {
          if (this.projectRI == (j.clientVipCardId || j.giftId || j.eitemId)) {
            j.ischeck = true;
          } else {
            j.ischeck = false;
          }
        });
      } else if (obj.listStatus == 2) {
        if (tabs == 1 && status == 2) {
          const arr = [];
          this.productRI.forEach((e) => {
            if (e * 1 < 100) {
              arr.push(e);
            }
          });
          // 经销商判断
          if (vObj.type == 1 && arr.find((a) => a == 1)) {
            this.checkValueCp(1);
          }
          // 特价判断
          if (vObj.type == 2 && arr.find((a) => a == 2)) {
            if (this.form.tableData[this.qyIndex].count * 1 >= vObj.promotionSaleCount * 1) {
              obj.qyList[index].qyCount = vObj.promotionSaleCount;
            } else {
              this.checkValueCp(2);
            }
          }
          // 定折判断
          if (vObj.type == 3 && arr.find((a) => a == 3)) {
            this.checkValueCp(3);
          }
          // 会员优惠判断
          if (vObj.type == 4 && arr.find((a) => a == 4) && !obj.qyList.find((a) => a.type == 2)) {
            this.checkValueCp(4);
          }
          // 改价判断
          if (vObj.type == 5 && arr.find((a) => a == 5) && !obj.qyList.find((a) => a.type == 2)) {
            this.checkValueCp(5);
          }
          // 不使用优惠判断
          if (vObj.type == 99 && arr.find((a) => a == 99) && !obj.qyList.find((a) => a.type == 2)) {
            this.checkValueCp(99);
          }
        }
        if (obj.package.length > 0 && tabs == 2) {
          let residueCount = 0;
          if (obj.package[index].countLimitType == 1) {
            obj.package[index].canDeductProductDetailList.forEach((a) => {
              if (a.productId == obj.productId) {
                residueCount = a.remaining;
              }
            });
          } else if (obj.package[index].countLimitType == 2) {
            residueCount = 9999;
          } else {
            residueCount = obj.package[index].remaining;
          }
          if (obj.package[index].qyCount > residueCount) {
            this.$message('超过可选数量');
            setTimeout(() => {
              obj.package[index].qyCount = obj.package[index].qyCount * 1 - 1;
              this.$forceUpdate();
            }, 10);
            return;
          }
        }
        // 常规判断
        let totalNumOne = 0;
        obj.qyList.forEach((c) => {
          c.ischeck = false;
        });
        obj.package.forEach((i) => {
          i.ischeck = false;
        });
        this.productRI.forEach((a) => {
          obj.qyList.forEach((b) => {
            if (a == b.type) {
              totalNumOne += b.qyCount;
              b.ischeck = true;
            }
          });
          obj.package.forEach((j) => {
            if (a == (j.clientVipCardId || j.giftId || j.eitemId)) {
              totalNumOne += j.qyCount;
              j.ischeck = true;
            }
          });
        });
        if (totalNumOne > obj.count) {
          this.$message('超过可选数量');
          let totalNumTwo = 0;
          if (status == 1) {
            setTimeout(() => {
              if (tabs == 1) {
                obj.qyList[index].qyCount = obj.qyList[index].qyCount * 1 - 1;
              } else {
                obj.package[index].qyCount = obj.package[index].qyCount * 1 - 1;
              }
              this.productRI.forEach((a) => {
                obj.qyList.forEach((b) => {
                  if (a == b.type) {
                    totalNumTwo += b.qyCount;
                    b.ischeck = true;
                  }
                });
                obj.package.forEach((j) => {
                  if (a == (j.clientVipCardId || j.giftId || j.eitemId)) {
                    totalNumTwo += j.qyCount;
                    j.ischeck = true;
                  }
                });
              });
              obj.chooseCount = totalNumTwo;
              this.$forceUpdate();
            }, 10);
          } else {
            this.productRI.forEach((e, m) => {
              if (e == obj.qyList[index].type) {
                obj.qyList[index].ischeck = false;
                this.productRI.splice(m, 1);
              }
              if (e == (obj.package[index].clientVipCardId || obj.package[index].giftId || obj.package[index].eitemId)) {
                obj.package[index].ischeck = false;
                this.productRI.splice(m, 1);
              }
            });
            obj.qyList.forEach((c) => {
              c.ischeck = false;
            });
            obj.package.forEach((i) => {
              i.ischeck = false;
            });
            setTimeout(() => {
              this.productRI.forEach((a) => {
                obj.qyList.forEach((b) => {
                  if (a == b.type) {
                    totalNumTwo += b.qyCount;
                    b.ischeck = true;
                  }
                });
                obj.package.forEach((j) => {
                  if (a == (j.clientVipCardId || j.giftId || j.eitemId)) {
                    totalNumTwo += j.qyCount;
                    j.ischeck = true;
                  }
                });
              });
              obj.chooseCount = totalNumTwo;
            }, 10);
          }
        } else {
          obj.chooseCount = totalNumOne;
        }
      } else {
        if (status == 2) {
          // 经销商判断
          if (vObj.type == 1 && this.packageRI.find((a) => a == 1)) {
            this.checkValueTc(1);
          }
          // 特价判断
          if (vObj.type == 2 && this.packageRI.find((a) => a == 2)) {
            if (this.form.tableData[this.qyIndex].count * 1 >= vObj.promotionSaleCount * 1) {
              obj.qyList[index].qyCount = vObj.promotionSaleCount;
            } else {
              this.checkValueTc(2);
            }
          }
          // 定折判断
          if (vObj.type == 3 && this.packageRI.find((a) => a == 3)) {
            this.checkValueTc(3);
          }
          // 会员优惠判断
          if (vObj.type == 4 && this.packageRI.find((a) => a == 4) && !obj.qyList.find((a) => a.type == 2)) {
            this.checkValueTc(4);
          }
          // 改价判断
          if (vObj.type == 5 && this.packageRI.find((a) => a == 5) && !obj.qyList.find((a) => a.type == 2)) {
            this.checkValueTc(5);
          }
          // 不使用优惠判断
          if (vObj.type == 99 && this.packageRI.find((a) => a == 99) && !obj.qyList.find((a) => a.type == 2)) {
            this.checkValueTc(99);
          }
        }
        let totalNumOne = 0;
        // 常规判断
        obj.qyList.forEach((c) => {
          c.ischeck = false;
        });
        this.packageRI.forEach((a) => {
          obj.qyList.forEach((b) => {
            if (a == b.type) {
              totalNumOne += b.qyCount;
              b.ischeck = true;
            }
          });
        });
        if (totalNumOne > this.form.tableData[this.qyIndex].count * 1) {
          this.$message('超过可选数量');
          let totalNumTwo = 0;
          if (status == 1) {
            setTimeout(() => {
              obj.qyList[index].qyCount = obj.qyList[index].qyCount * 1 - 1;
              this.packageRI.forEach((a) => {
                obj.qyList.forEach((b) => {
                  if (a == b.type) {
                    totalNumTwo += b.qyCount;
                    b.ischeck = true;
                  }
                });
              });
              obj.chooseCount = totalNumTwo;
              this.$forceUpdate();
            }, 10);
          } else {
            this.packageRI.forEach((e, m) => {
              if (e == obj.qyList[index].type) {
                obj.qyList[index].ischeck = false;
                this.packageRI.splice(m, 1);
              }
            });
            obj.qyList.forEach((c) => {
              c.ischeck = false;
            });
            setTimeout(() => {
              this.packageRI.forEach((a) => {
                obj.qyList.forEach((b) => {
                  if (a == b.type) {
                    totalNumTwo += b.qyCount;
                    b.ischeck = true;
                  }
                });
              });
              obj.chooseCount = totalNumTwo;
            }, 10);
          }
        } else {
          obj.chooseCount = totalNumOne;
        }
      }
    },
    // 选择/改变优惠权益
    changePrice(status, obj) {
      if (status == 1) {
        if (obj.rightsPrice * 1 > obj.price * 1) obj.rightsPrice = JSON.parse(JSON.stringify(obj.price));
        obj.percentage = (obj.rightsPrice / obj.price * 100).toFixed(2);
      } else {
        if (obj.percentage * 1 > 100) obj.percentage = 100;
        if (obj.percentage * 1 < 0) obj.percentage = 0;
        obj.rightsPrice = (obj.percentage * obj.price / 100).toFixed(2);
      }
    },
    // 计算优惠
    calculationPreferential(obj) {
      let total = 0;
      if (obj.listStatus == 1) {
        obj.qyCheckBox = obj.qyCheckBox || '';
      } else {
        obj.qyCheckBox = obj.qyCheckBox || [];
      }
      obj.qyList = obj.qyList || [];
      obj.package = obj.package || [];
      obj.qyList.forEach((a) => {
        if (obj.listStatus == 1) {
          if (obj.qyCheckBox == a.type) {
            if (a.type == 1 || a.type == 2 || a.type == 3 || a.type == 4 || a.type == 5) {
              total += (a.originalPrice - a.rightsPrice) * a.qyCount;
            }
          }
        } else {
          obj.qyCheckBox.forEach((b) => {
            if (b == a.type) {
              if (a.type == 1 || a.type == 2 || a.type == 3 || a.type == 4 || a.type == 5) {
                total += (a.originalPrice - a.rightsPrice) * a.qyCount;
              }
            }
          });
        }
      });
      obj.package.forEach((b) => {
        if (obj.listStatus == 1) {
          if (obj.qyCheckBox == (b.clientVipCardId || b.giftId || b.eitemId)) {
            total += obj.price * b.qyCount;
          }
        } else {
          obj.qyCheckBox.forEach((c) => {
            if (c == (b.clientVipCardId || b.giftId || b.eitemId)) {
              total += obj.price * b.qyCount;
            }
          });
        }
      });
      const lastPrice = (obj.price * obj.count - total).toFixed(2);
      return lastPrice;
    },
    // 已使用优惠权益信息
    getChooseQyinfo(obj, status) {
      let strings = '';
      if (obj.listStatus == 1) {
        obj.qyCheckBox = obj.qyCheckBox || '';
      } else {
        obj.qyCheckBox = obj.qyCheckBox || [];
      }
      obj.qyList = obj.qyList || [];
      obj.package = obj.package || [];
      obj.qyList.forEach((a) => {
        if (status == 1) {
          if (obj.listStatus == 1) {
            if (obj.qyCheckBox == a.type) {
              strings += this.qyTabOne(a);
            }
          } else {
            obj.qyCheckBox.forEach((b) => {
              if (b == a.type) {
                strings += this.qyTabOne(a);
              }
            });
          }
        } else if (a.ischeck == true) {
          strings += this.qyTabOne(a);
        }
      });
      let electronicTicketTotal = 0;
      let giftTotal = 0;
      let packageTotal = 0;
      let eStatus = 0;
      let gStatus = 0;
      let pStatus = 0;
      obj.package.forEach((b) => {
        if (status == 1) {
          if (obj.listStatus == 1) {
            if (obj.qyCheckBox == (b.clientVipCardId || b.giftId || b.eitemId)) {
              if (b.isElectronicTicket == 1) {
                electronicTicketTotal += obj.price * b.qyCount;
                eStatus = 1;
              } else if (b.isGift == 1 && !b.clientVipCardId) {
                giftTotal += obj.price * b.qyCount;
                gStatus = 1;
              } else {
                packageTotal += obj.price * b.qyCount;
                pStatus = 1;
              }
            }
          } else {
            obj.qyCheckBox.forEach((c) => {
              if (c == (b.clientVipCardId || b.giftId || b.eitemId)) {
                if (b.isElectronicTicket == 1) {
                  electronicTicketTotal += obj.price * b.qyCount;
                  eStatus = 1;
                } else if (b.isGift == 1 && !b.clientVipCardId) {
                  giftTotal += obj.price * b.qyCount;
                  gStatus = 1;
                } else {
                  packageTotal += obj.price * b.qyCount;
                  pStatus = 1;
                }
              }
            });
          }
        } else if (b.ischeck == true) {
          if (b.isElectronicTicket == 1) {
            electronicTicketTotal += obj.price * b.qyCount;
            eStatus = 1;
          } else if (b.isGift == 1 && !b.clientVipCardId) {
            giftTotal += obj.price * b.qyCount;
            gStatus = 1;
          } else {
            packageTotal += obj.price * b.qyCount;
            pStatus = 1;
          }
        }
      });
      if (eStatus == 1) {
        strings += `电子票划扣-￥${(electronicTicketTotal * 1).toFixed(2)}，`;
      }
      if (gStatus == 1) {
        strings += `赠品划扣-￥${(giftTotal * 1).toFixed(2)}，`;
      }
      if (pStatus == 1) {
        strings += `套餐划扣-￥${(packageTotal * 1).toFixed(2)}，`;
      }
      const arr = strings.split('，');
      let newString = '';
      arr.forEach((a, m) => {
        if (a) {
          newString += a + (arr.length == (m + 2) ? '' : '，');
        }
      });
      return newString || '不使用优惠权益';
    },
    // 获取经销商等级
    getJxsdj() {
      if (this.MemberInfo.wholesaleInfo) {
        return this.MemberInfo.wholesaleInfo.gradeName;
      }
      return '经销商等级';
    },
    qyTabOne(a) {
      if (a.type == 1) {
        return `${this.getJxsdj()}权益，`;
      } if (a.type == 2 || a.type == 3 || a.type == 4 || a.type == 5) {
        return `${a.type == 2 ? '特价促销' : a.type == 3 ? '定时打折' : a.type == 4 ? '会员优惠' : '改价优惠'}-￥${((a.price - a.rightsPrice) * a.qyCount).toFixed(2)}，`;
      } if (a.type == 99) {
        return '';
      }
    },
    // 自动选择权益
    autoChooseRights(val) {
      const obj = this.form.tableData;
      obj.forEach((a, m) => {
        if (!a.qyList) {
          this.matching(a, m);
        } else if (a.qyList.length == 0) {
          this.matching(a, m);
        }
        if (a.listStatus == 1) {
          this.serviceAcrs(a, m);
        } else if (a.listStatus == 2) {
          this.productAcrs(a, m, val);
        } else {
          this.packageAcrs(a, m);
        }
      });
    },
    matching(obj, index) {
      console.log(obj);
      obj.qyList = [];
      if (obj.listStatus == 1) {
        obj.qyCheckBox = obj.qyCheckBox || '';
      } else {
        obj.qyCheckBox = obj.qyCheckBox || [];
      }
      if (obj.isWholesale == 1) {
        obj.qyList.push({
          isWholesale: 1,
          wholesalePrice: obj.wholesalePrice,
          originalPrice: obj.price,
          qyCount: 1,
          info: `享受${this.getJxsdj()}权益价格`,
          price: obj.price,
          rightsPrice: obj.wholesalePrice,
          title: '使用经销商权益',
          type: 1,
          memberDiscount: obj.memberDiscount,
          memberPrice: obj.memberPrice,
          ischeck: obj.listStatus == 1 ? (obj.qyCheckBox == 1) : !!obj.qyCheckBox.find((a) => a == 1),
        });
      }
      if (obj.hasActivity == 1) {
        if (obj.activityInfo.activityType == 1) {
          obj.qyList.push({
            activityId: obj.activityInfo.activityId,
            activityType: obj.activityInfo.activityType,
            title: '特价促销活动',
            info: `特价促销价格${obj.activityInfo.activityPrice}元`,
            originalPrice: obj.price,
            promotionSaleCount: obj.activityInfo.promotionSaleCount,
            qyCount: 1,
            price: obj.price,
            rightsPrice: obj.activityInfo.activityPrice,
            type: 2,
            memberDiscount: obj.memberDiscount,
            memberPrice: obj.memberPrice,
            ischeck: obj.listStatus == 1 ? (obj.qyCheckBox == 2) : !!obj.qyCheckBox.find((a) => a == 2),
          });
        } else if (obj.activityInfo.activityType == 2) {
          obj.qyList.push({
            activityId: obj.activityInfo.activityId,
            activityType: obj.activityInfo.activityType,
            title: '定时打折活动',
            info: `定时打${obj.activityInfo.discount}折`,
            originalPrice: obj.price,
            qyCount: 1,
            price: obj.price,
            rightsPrice: obj.activityInfo.activityPrice,
            type: 3,
            memberDiscount: obj.memberDiscount,
            memberPrice: obj.memberPrice,
            ischeck: obj.listStatus == 1 ? (obj.qyCheckBox == 3) : !!obj.qyCheckBox.find((a) => a == 3),
          });
        }
      }
      if (this.MemberInfo.cardNo) {
        obj.qyList.push({
          twoDiscountType: obj.discountType,
          twoPrice: obj.memberPrice,
          title: '会员折扣优惠',
          info: `享受${obj.discountType == 1 ? (`${obj.memberPrice}元`) : (`${obj.memberDiscount}折`)}优惠`,
          originalPrice: obj.price,
          qyCount: 1,
          price: obj.price,
          rightsPrice: obj.memberPrice,
          type: 4,
          memberDiscount: obj.memberDiscount,
          memberPrice: obj.memberPrice,
          ischeck: obj.listStatus == 1 ? (obj.qyCheckBox == 4) : !!obj.qyCheckBox.find((a) => a == 4),
        });
      }
      if (this.editDiscountPriceStatus != 1) {
        obj.qyList.push({
          isChangePrice: 1,
          percentage: 100,
          title: '使用改价优惠',
          info: '',
          originalPrice: obj.price,
          qyCount: 1,
          price: obj.price,
          rightsPrice: obj.price,
          type: 5,
          memberDiscount: obj.memberDiscount,
          memberPrice: obj.memberPrice,
          ischeck: obj.listStatus == 1 ? (obj.qyCheckBox == 5) : !!obj.qyCheckBox.find((a) => a == 5),
        });
      }
      obj.qyList.push({
        title: '不使用优惠权益',
        info: '选择后不享受任何优惠',
        originalPrice: obj.price,
        qyCount: 1,
        price: obj.price,
        rightsPrice: obj.price,
        type: 99,
        memberDiscount: obj.memberDiscount,
        memberPrice: obj.memberPrice,
        ischeck: obj.listStatus == 1 ? (obj.qyCheckBox == 99) : !!obj.qyCheckBox.find((a) => a == 99),
      });
      if (obj.listStatus != 3) {
        obj.package.forEach((a) => {
          a.qyCount = 1;
          a.ischeck = false;
        });
      }
      this.form.tableData[index] = JSON.parse(JSON.stringify(obj));
    },
    // 计算数量
    calculateQuantityTwo(obj) {
      const arr = [];
      const arrTwo = [];
      obj.qyCheckBox.forEach((a) => {
        if (a * 1 < 100) arr.push(a);
        else arrTwo.push(a);
      });
      if (arr.length > 0) {
        let ast = 0;
        obj.qyList.forEach((a) => {
          if (a.type == obj.qyCheckBox[0] && a.qyCount == 1) {
            ast = 1;
            a.ischeck = false;
          } else if (a.type == obj.qyCheckBox[0] && a.qyCount > 1) {
            a.qyCount = a.qyCount * 1 - 1;
          }
        });
        if (ast == 1) obj.qyCheckBox.splice(0, 1);
      } else if (arrTwo.length > 0) {
        let ast = 0;
        obj.package.forEach((b) => {
          if (obj.qyCheckBox[0] == (b.clientVipCardId || b.giftId || b.eitemId) && b.qyCount == 1) {
            ast = 1;
            b.ischeck = false;
          } else if (obj.qyCheckBox[0] == (b.clientVipCardId || b.giftId || b.eitemId) && b.qyCount > 1) {
            b.qyCount = b.qyCount * 1 - 1;
          }
        });
        if (ast == 1) obj.qyCheckBox.splice(0, 1);
      }
      let totalCount = 0;
      obj.qyList.forEach((a) => {
        if (a.ischeck) {
          totalCount += a.qyCount * 1;
        }
      });
      obj.package.forEach((a) => {
        if (a.ischeck) {
          totalCount += a.qyCount * 1;
        }
      });
      if (totalCount > obj.count * 1) {
        this.calculateQuantityTwo(obj);
      }
    },
    calculateQuantityOne(obj) {
      let totalCount = 0;
      obj.qyList.forEach((a) => {
        if (a.ischeck) {
          totalCount += a.qyCount * 1;
        }
      });
      obj.package.forEach((a) => {
        if (a.ischeck) {
          totalCount += a.qyCount * 1;
        }
      });
      if (totalCount > obj.count * 1) {
        if (obj.count == 1) {
          obj.qyCheckBox = [];
          obj.qyList.forEach((b) => {
            b.ischeck = false;
          });
          obj.package.forEach((b) => {
            b.ischeck = false;
          });
        } else {
          this.calculateQuantityTwo(obj);
        }
      }
    },
    // 项目自动选择权益
    serviceAcrs(obj, index) {
      obj.qyList.forEach((b) => {
        b.ischeck = (obj.qyCheckBox == b.type);
      });
      obj.package.forEach((b) => {
        b.ischeck = (obj.qyCheckBox == (b.clientVipCardId || b.giftId || b.eitemId));
      });
      if (obj.qyCheckBox.length == 0) {
        if (obj.qyList[0].type == 2) {
          let num = 0;
          this.form.tableData.forEach((a) => {
            if (a.dictItemId == obj.dictItemId) {
              num += 1;
            }
          });
          if (num > obj.activityInfo.promotionSaleCount) {
            if (obj.qyList[1].type == 5) {
              obj.qyList[2].qyCount = 1;
              obj.qyList[2].ischeck = true;
              obj.qyCheckBox = obj.qyList[2].type;
            } else {
              obj.qyList[1].qyCount = 1;
              obj.qyList[1].ischeck = true;
              obj.qyCheckBox = obj.qyList[1].type;
            }
          } else {
            obj.qyList[0].qyCount = 1;
            obj.qyList[0].ischeck = true;
            obj.qyCheckBox = obj.qyList[0].type;
          }
        } else if (obj.qyList[0].type == 5) {
          obj.qyList[1].qyCount = 1;
          obj.qyList[1].ischeck = true;
          obj.qyCheckBox = obj.qyList[1].type;
        } else {
          obj.qyList[0].qyCount = 1;
          obj.qyList[0].ischeck = true;
          obj.qyCheckBox = obj.qyList[0].type;
        }
      }
      this.form.tableData[index] = JSON.parse(JSON.stringify(obj));
      setTimeout(() => {
        this.determineUse(index);
      }, 0);
    },
    // 产品自动选择权益
    productAcrs(obj, index, val) {
      const arr = [];
      const arrTwo = [];
      obj.qyList.forEach((b) => {
        b.ischeck = !!obj.qyCheckBox.find((a) => a == b.type);
      });
      obj.package.forEach((b) => {
        b.ischeck = !!obj.qyCheckBox.find((a) => a == (b.clientVipCardId || b.giftId || b.eitemId));
      });
      this.calculateQuantityOne(obj);
      obj.qyCheckBox.forEach((a) => {
        if (a * 1 < 100) arr.push(a);
        else arrTwo.push(a);
      });
      let totalCount = 0;
      obj.package.forEach((a) => {
        if (a.ischeck) {
          totalCount += a.qyCount * 1;
        }
      });
      const tNum = obj.count * 1 - totalCount;
      if (arrTwo.length == 0) {
        if (arr.length == 1 && obj.qyList.find((a) => (a.type == 2 && a.ischeck))) {
          let psCount = 0;
          let psIndex = 0;
          obj.qyList.forEach((a, m) => {
            if (a.ischeck) {
              psCount = JSON.parse(JSON.stringify(a.promotionSaleCount)) * 1;
              psIndex = JSON.parse(JSON.stringify(m)) * 1;
            }
          });
          if (obj.count * 1 > psCount * 1) {
            obj.qyList[psIndex].qyCount = psCount;
            obj.qyList[psIndex + 1].qyCount = obj.count * 1 - psCount * 1;
            obj.qyList[psIndex + 1].ischeck = true;
            obj.qyCheckBox.push(obj.qyList[psIndex + 1].type);
          } else {
            obj.qyList[psIndex].qyCount = obj.count * 1;
          }
        } else if (arr.length == 1 && !obj.qyList.find((a) => (a.type == 2 && a.ischeck))) {
          obj.qyList.forEach((a) => {
            if (a.ischeck) {
              a.qyCount = obj.count;
            }
          });
        } else if (arr.length == 2) {
          let psCount = 0;
          let psIndex = 0;
          let nextIndex = 0;
          obj.qyList.forEach((a, m) => {
            if (a.type == 2) {
              psCount = JSON.parse(JSON.stringify(a.promotionSaleCount)) * 1;
              psIndex = JSON.parse(JSON.stringify(m)) * 1;
            }
            if (a.type != 2 && a.ischeck) {
              nextIndex = JSON.parse(JSON.stringify(m)) * 1;
            }
          });
          if (obj.count * 1 > psCount * 1) {
            obj.qyList[psIndex].qyCount = psCount;
            obj.qyList[nextIndex].qyCount = obj.count * 1 - psCount * 1;
          } else {
            obj.qyList[psIndex].qyCount = obj.count * 1;
            obj.qyList[nextIndex].ischeck = false;
            obj.qyCheckBox = [obj.qyCheckBox[0]];
          }
        } else if (obj.qyList[0].type == 5) {
          obj.qyList[1].qyCount = 1;
          obj.qyList[1].ischeck = true;
          obj.qyCheckBox = [obj.qyList[1].type];
        } else {
          obj.qyList[0].qyCount = obj.count * 1;
          obj.qyList[0].ischeck = true;
          obj.qyCheckBox = [obj.qyList[0].type];
        }
        this.form.tableData[index] = JSON.parse(JSON.stringify(obj));
        setTimeout(() => {
          this.determineUse(index);
        }, 0);
      } else if (arrTwo.length > 0 && val == 2 && tNum > 0) {
        if (arr.length == 1 && obj.qyList.find((a) => (a.type == 2 && a.ischeck))) {
          let psCount = 0;
          let psIndex = 0;
          obj.qyList.forEach((a, m) => {
            if (a.ischeck) {
              psCount = JSON.parse(JSON.stringify(a.promotionSaleCount)) * 1;
              psIndex = JSON.parse(JSON.stringify(m)) * 1;
            }
          });
          if (tNum * 1 > psCount * 1) {
            obj.qyList[psIndex].qyCount = psCount;
            obj.qyList[psIndex + 1].qyCount = tNum * 1 - psCount * 1;
            obj.qyList[psIndex + 1].ischeck = true;
            obj.qyCheckBox.push(obj.qyList[psIndex + 1].type);
          } else {
            obj.qyList[psIndex].qyCount = tNum * 1;
          }
        } else if (arr.length == 1 && !obj.qyList.find((a) => (a.type == 2 && a.ischeck))) {
          obj.qyList.forEach((a) => {
            if (a.ischeck) {
              a.qyCount = tNum;
            }
          });
        } else if (arr.length == 2) {
          let psCount = 0;
          let psIndex = 0;
          let nextIndex = 0;
          obj.qyList.forEach((a, m) => {
            if (a.type == 2) {
              psCount = JSON.parse(JSON.stringify(a.promotionSaleCount)) * 1;
              psIndex = JSON.parse(JSON.stringify(m)) * 1;
            }
            if (a.type != 2 && a.ischeck) {
              nextIndex = JSON.parse(JSON.stringify(m)) * 1;
            }
          });
          if (tNum * 1 > psCount * 1) {
            obj.qyList[psIndex].qyCount = psCount;
            obj.qyList[nextIndex].qyCount = tNum * 1 - psCount * 1;
          } else {
            obj.qyList[psIndex].qyCount = tNum * 1;
            obj.qyList[nextIndex].ischeck = false;
            obj.qyCheckBox = [obj.qyCheckBox[0]];
          }
        } else if (obj.qyList[0].type == 5) {
          obj.qyList[1].qyCount = 1;
          obj.qyList[1].ischeck = true;
          obj.qyCheckBox = [obj.qyList[1].type];
        } else {
          obj.qyList[0].qyCount = tNum * 1;
          obj.qyList[0].ischeck = true;
          obj.qyCheckBox = [obj.qyList[0].type];
        }
        this.form.tableData[index] = JSON.parse(JSON.stringify(obj));
        setTimeout(() => {
          this.determineUse(index);
        }, 0);
      }
    },
    // 套餐自动选择权益
    packageAcrs(obj, index) {
      obj.qyList.forEach((b) => {
        b.ischeck = !!obj.qyCheckBox.find((a) => a == b.type);
      });
      if (obj.qyCheckBox.length == 1 && obj.qyList.find((a) => (a.type == 2 && a.ischeck))) {
        let psCount = 0;
        let psIndex = 0;
        obj.qyList.forEach((a, m) => {
          if (a.ischeck) {
            psCount = JSON.parse(JSON.stringify(a.promotionSaleCount)) * 1;
            psIndex = JSON.parse(JSON.stringify(m)) * 1;
          }
        });
        if (obj.count * 1 > psCount * 1) {
          obj.qyList[psIndex].qyCount = psCount;
          obj.qyList[psIndex + 1].qyCount = obj.count * 1 - psCount * 1;
          obj.qyList[psIndex + 1].ischeck = true;
          obj.qyCheckBox.push(obj.qyList[psIndex + 1].type);
        } else {
          obj.qyList[psIndex].qyCount = obj.count * 1;
        }
      } else if (obj.qyCheckBox.length == 1 && !obj.qyList.find((a) => (a.type == 2 && a.ischeck))) {
        obj.qyList.forEach((a) => {
          if (a.ischeck) {
            a.qyCount = obj.count;
          }
        });
      } else if (obj.qyCheckBox.length == 2) {
        let psCount = 0;
        let psIndex = 0;
        let nextIndex = 0;
        obj.qyList.forEach((a, m) => {
          if (a.type == 2) {
            psCount = JSON.parse(JSON.stringify(a.promotionSaleCount)) * 1;
            psIndex = JSON.parse(JSON.stringify(m)) * 1;
          }
          if (a.type != 2 && a.ischeck) {
            nextIndex = JSON.parse(JSON.stringify(m)) * 1;
          }
        });
        if (obj.count * 1 > psCount * 1) {
          obj.qyList[psIndex].qyCount = psCount;
          obj.qyList[nextIndex].qyCount = obj.count * 1 - psCount * 1;
        } else {
          obj.qyList[psIndex].qyCount = obj.count * 1;
          obj.qyList[nextIndex].ischeck = false;
          obj.qyCheckBox = [obj.qyCheckBox[0]];
        }
      } else if (obj.qyList[0].type == 5) {
        obj.qyList[1].qyCount = 1;
        obj.qyList[1].ischeck = true;
        obj.qyCheckBox = [obj.qyList[1].type];
      } else {
        obj.qyList[0].qyCount = 1;
        obj.qyList[0].ischeck = true;
        obj.qyCheckBox = [obj.qyList[0].type];
      }
      this.form.tableData[index] = JSON.parse(JSON.stringify(obj));
      setTimeout(() => {
        this.determineUse(index);
      }, 0);
    },
    // 确定使用权益
    determineUse(index) {
      let obj = {};
      if (this.allDisplay) {
        obj = this.chooseInfoRI;
      } else {
        obj = this.form.tableData[index];
      }
      if (obj.listStatus == 1) {
        obj.detailList = [];
        if (this.allDisplay) {
          obj.qyCheckBox = JSON.parse(JSON.stringify(this.projectRI));
        }
        obj.qyList.forEach((a) => {
          if (obj.qyCheckBox == a.type) {
            const nobj = {};
            nobj.memberDiscount = a.memberDiscount;
            nobj.memberPrice = a.memberPrice;
            nobj.originalPrice = a.originalPrice;
            nobj.qyCount = 1;
            nobj.type = a.type;
            if (a.type == 1) {
              nobj.isWholesale = 1;
              nobj.wholesalePrice = a.wholesalePrice;
              nobj.rightsPrice = a.rightsPrice || a.wholesalePrice;
            } else if (a.type == 2 || a.type == 3) {
              nobj.activityId = obj.activityInfo.activityId;
              nobj.activityType = obj.activityInfo.activityType;
              nobj.rightsPrice = a.rightsPrice || obj.activityInfo.activityPrice;
            } else if (a.type == 4) {
              nobj.twoDiscountType = obj.discountType;
              nobj.twoPrice = a.twoPrice || obj.memberPrice;
              nobj.rightsPrice = a.rightsPrice || obj.memberPrice;
            } else if (a.type == 5) {
              nobj.isChangePrice = 1;
              nobj.rightsPrice = a.rightsPrice;
            } else if (a.type == 99) {
              nobj.rightsPrice = a.rightsPrice || obj.price;
            }
            obj.detailList.push(nobj);
          }
        });
        obj.package.forEach((b) => {
          if (obj.qyCheckBox == (b.clientVipCardId || b.giftId || b.eitemId)) {
            b.ischeck = true;
          }
        });
      } else if (obj.listStatus == 2) {
        obj.detailList = [];
        if (this.allDisplay) {
          obj.qyCheckBox = JSON.parse(JSON.stringify(this.productRI));
        }
        obj.qyList.forEach((a) => {
          let num = 0;
          obj.qyCheckBox.forEach((b) => {
            if (a.type == b) {
              num = 1;
            }
          });
          if (num == 1) {
            const nobj = {};
            nobj.memberDiscount = a.memberDiscount;
            nobj.memberPrice = a.memberPrice;
            nobj.originalPrice = a.originalPrice;
            nobj.qyCount = a.qyCount;
            nobj.type = a.type;
            if (a.type == 1) {
              nobj.isWholesale = 1;
              nobj.wholesalePrice = a.wholesalePrice;
              nobj.rightsPrice = a.rightsPrice || a.wholesalePrice;
            } else if (a.type == 2 || a.type == 3) {
              nobj.activityId = obj.activityInfo.activityId;
              nobj.activityType = obj.activityInfo.activityType;
              nobj.rightsPrice = a.rightsPrice || obj.activityInfo.activityPrice;
            } else if (a.type == 4) {
              nobj.twoDiscountType = obj.discountType;
              nobj.twoPrice = a.twoPrice || obj.memberPrice;
              nobj.rightsPrice = a.rightsPrice || obj.memberPrice;
            } else if (a.type == 5) {
              nobj.isChangePrice = 1;
              nobj.rightsPrice = a.rightsPrice;
            } else if (a.type == 99) {
              nobj.rightsPrice = a.rightsPrice || obj.price;
            }
            obj.detailList.push(nobj);
          }
        });
        let total = 0;
        obj.detailList.forEach((a) => {
          total += a.qyCount * 1;
        });
        obj.package.forEach((a) => {
          if (a.ischeck) {
            total += a.qyCount * 1;
          }
        });
        if ((this.form.tableData[index].count * 1 > total * 1) && this.allDisplay && window.location.href.indexOf('/stage/service') > -1) {
          this.$message('数量不对，请检查清楚');
          return;
        }
      } else {
        obj.detailList = [];
        if (this.allDisplay) {
          obj.qyCheckBox = JSON.parse(JSON.stringify(this.packageRI));
        }
        obj.qyList.forEach((a) => {
          let num = 0;
          obj.qyCheckBox.forEach((b) => {
            if (a.type == b) {
              num = 1;
            }
          });
          if (num == 1) {
            const nobj = {};
            nobj.memberDiscount = a.memberDiscount;
            nobj.memberPrice = a.memberPrice;
            nobj.originalPrice = a.originalPrice;
            nobj.qyCount = a.qyCount;
            nobj.type = a.type;
            if (a.type == 1) {
              nobj.isWholesale = 1;
              nobj.wholesalePrice = a.wholesalePrice;
              nobj.rightsPrice = a.rightsPrice || a.wholesalePrice;
            } else if (a.type == 2 || a.type == 3) {
              nobj.activityId = obj.activityInfo.activityId;
              nobj.activityType = obj.activityInfo.activityType;
              nobj.rightsPrice = a.rightsPrice || obj.activityInfo.activityPrice;
            } else if (a.type == 4) {
              nobj.twoDiscountType = obj.discountType;
              nobj.twoPrice = a.twoPrice || obj.memberPrice;
              nobj.rightsPrice = a.rightsPrice || obj.memberPrice;
            } else if (a.type == 5) {
              nobj.isChangePrice = 1;
              nobj.rightsPrice = a.rightsPrice;
            } else if (a.type == 99) {
              nobj.rightsPrice = a.rightsPrice || obj.price;
            }
            obj.detailList.push(nobj);
          }
        });
        let total = 0;
        obj.detailList.forEach((a) => {
          total += a.qyCount * 1;
        });
        if ((this.form.tableData[index].count * 1 > total * 1) && this.allDisplay && window.location.href.indexOf('/stage/service') > -1) {
          this.$message('数量不对，请检查清楚');
          return;
        }
      }
      this.form.tableData[index] = JSON.parse(JSON.stringify(obj));
      this.allDisplay = false;
    },
    // 获取周期展示
    getCycle(val, status) {
      const arr = val.split(',');
      const newArr = arr.sort();
      const lastArr = [];
      newArr.forEach((v) => {
        if (v) lastArr.push(v);
      });
      let cycleArr = '';
      if (status == 1) {
        newArr.forEach((a, m) => {
          if (a == 1) cycleArr += `周一${newArr.length == (m + 1) ? '' : '、'}`;
          else if (a == 2) cycleArr += `周二${newArr.length == (m + 1) ? '' : '、'}`;
          else if (a == 3) cycleArr += `周三${newArr.length == (m + 1) ? '' : '、'}`;
          else if (a == 4) cycleArr += `周四${newArr.length == (m + 1) ? '' : '、'}`;
          else if (a == 5) cycleArr += `周五${newArr.length == (m + 1) ? '' : '、'}`;
          else if (a == 6) cycleArr += `周六${newArr.length == (m + 1) ? '' : '、'}`;
          else if (a == 7) cycleArr += `周日${newArr.length == (m + 1) ? '' : '、'}`;
        });
      } else {
        newArr.forEach((b, n) => {
          if (n == 0) cycleArr += '每月';
          if (b) cycleArr += `${b}日${newArr.length == (n + 1) ? '' : '、'}`;
        });
      }
      return cycleArr;
    },
    // 获取权益列表
    chooseRI(obj, n, status) {
      if (obj.deductType == 1) {
        this.$message('预约订单中已使用划扣，不可修改优惠权益');
        return;
      }
      obj.package = obj.package || [];
      this.qyIndex = n;
      this.chooseInfoRI = obj;
      if (obj.qyList) {
        if (obj.qyList.length > 0) {
          if (!status) this.allDisplay = true;
          setTimeout(() => {
            if (obj.listStatus == 1) this.projectRI = obj.qyCheckBox || '';
            else if (obj.listStatus == 2) this.productRI = obj.qyCheckBox || [];
            else if (obj.listStatus == 3) this.packageRI = obj.qyCheckBox || [];
            obj.qyList.forEach((c) => {
              c.ischeck = false;
            });
            obj.package.forEach((i) => {
              i.ischeck = false;
            });
            if (obj.listStatus == 1) {
              obj.qyList.forEach((b) => {
                if (this.projectRI == b.type) {
                  b.ischeck = true;
                }
              });
              obj.package.forEach((j) => {
                if (this.projectRI == (j.clientVipCardId || j.giftId || j.eitemId)) {
                  j.ischeck = true;
                }
              });
              obj.chooseCount = 1;
            } else if (obj.listStatus == 2) {
              let totalNumOne = 0;
              this.productRI.forEach((a) => {
                obj.qyList.forEach((b) => {
                  if (a == b.type) {
                    totalNumOne += b.qyCount;
                    b.ischeck = true;
                  }
                });
                obj.package.forEach((j) => {
                  if (a == (j.clientVipCardId || j.giftId || j.eitemId)) {
                    totalNumOne += j.qyCount;
                    j.ischeck = true;
                  }
                });
              });
              obj.chooseCount = totalNumOne;
            } else {
              let totalNumOne = 0;
              this.packageRI.forEach((a) => {
                obj.qyList.forEach((b) => {
                  if (a == b.type) {
                    totalNumOne += b.qyCount;
                    b.ischeck = true;
                  }
                });
              });
              obj.chooseCount = totalNumOne;
            }
            if (!this.allDisplay) this.formChange();
          }, 10);
        }
      }
    },
    // 初始化加载
    initialization() {
      this.getPayList();
      const menusList = JSON.parse(window.sessionStorage.menusList);
      menusList.forEach((a) => {
        if (a.menus_name == '房态') {
          setTimeout(() => {
            this.roomBtnStatus = 2;
          }, 100);
        }
      });
      this.uaValue = this.Lib.pcOrMobile();
      Object.assign(this.$data, this.$options.data());
      this.id = window.sessionStorage.editOrderId ? window.sessionStorage.editOrderId : '';
      this.form.bookOrderId = window.sessionStorage.bookOrderId ? window.sessionStorage.bookOrderId : '';
      if (this.id) {
        this.getOrderDetailsData();
      } else if (this.form.bookOrderId) {
        this.getEditBespeakInfo(this.form.bookOrderId);
      } else if (!this.form.bookOrderId && window.sessionStorage.userPhone) {
        this.form.phone = window.sessionStorage.userPhone;
        this.clearOrderData('1');
        this.memberSearch();
      } else if (this.$route.params.form) {
        this.clearOrderData('1');
        this.form.phone = this.$route.params.form.customerPhone;
        this.memberSearch();
      } else {
        this.clearOrderData('1');
      }
      this.getItemListData();
      this.getProductTypeData();
    },
    // 扫码核销
    writeOffSubmit() {
      this.Lib.keyboardBlur();
      checkElectronicTicket({ checkCode: this.paymentCode, mainId: window.sessionStorage.mainId }).then((res) => {
        if (res.code == 0) {
          this.form.phone = res.data[0].phone;
          this.radioLeft = '2';
          if (res.data[0].isCanDeduct == 1) {
            if (res.data[0].isElectronicTicket == 1 && res.data[0].eitemId) {
              this.memberSearch(this.form.phone, '', '电子票', res.data[0].canDeductItemDetailList[0]);
              this.activeIndex = '电子票';
            } else if (res.data[0].isElectronicTicket == 1 && !res.data[0].eitemId) {
              this.memberSearch(this.form.phone, '', '电子票', '');
              this.activeIndex = '电子票';
            } else {
              this.memberSearch(this.form.phone, '', '套餐', '');
              this.activeIndex = '套餐';
            }
          } else if (res.data[0].isElectronicTicket == 1) {
            this.memberSearch(this.form.phone, '', '电子票', '');
            this.activeIndex = '电子票';
          } else {
            this.memberSearch(this.form.phone, '', '套餐', '');
            this.activeIndex = '套餐';
          }
          this.paymentCode = '';
          this.$nextTick(() => {
            this.$refs.refsqp.focus();
          }, 100);
        } else {
          console.log(res);
        }
        this.writeOffDia = false;
      });
    },
    // 获取订单数量
    getOrderCount() {
      getAllOrderCount({ mainId: window.sessionStorage.mainId }).then((res) => {
        if (res.code === 0) {
          this.orderCount = res.data.count4NoPay;
        } else {
          console.log(res);
        }
      });
    },
    // 核销
    writeOff() {
      this.writeOffDia = true;
    },
    // 取单
    takeOrder() {
      this.takeOrderDia = true;
      this.toPageNum = 1;
      this.getTakeOrderData();
    },
    // 获取取单列表数据
    getTakeOrderData() {
      const data = {
        pageSize: this.toPageSize,
        pageNum: this.toPageNum,
        mainId: window.sessionStorage.mainId,
        keyWord: '',
        remark: '',
        openStartDate: '',
        openEndDate: '',
        closeStartDate: '',
        closeEndDate: '',
        orderStatus: '1',
        orderType: '',
        memberType: '',
        technicianIds: '',
        isHasTechnician: null
      };
      this.loading = true;
      getAllOrderListPage(data).then((res) => {
        if (res.code === 0) {
          this.toList = res.data.records;
          this.toRowCount = res.data.total;
          this.loading = false;
        } else {
          console.log(res);
        }
      });
    },
    toSizeChange(val) {
      this.toPageNum = val;
      this.getTakeOrderData();
    },
    toCurrentChange(val) {
      this.toPageNum = val;
      this.getTakeOrderData();
    },
    // 修改订单
    editOrder(id) {
      window.sessionStorage.editOrderId = id;
      this.$route.params.form = '';
      this.initialization();
    },
    // 结算订单
    settlementOrder(id, val, type, phone) {
      if (type == 3) {
        window.sessionStorage.rechargePhone = phone;
        this.$router.push({
          name: 'stage-recharge',
          params: {
            partPay: 1,
            id
          }
        });
      } else {
        window.sessionStorage.settlementOrderId = id;
        this.$router.push({
          name: 'stage-orderSettlement',
          params: {
            partPay: val ? 1 : 0
          }
        });
      }
    },
    // 删除订单
    delOrder(id, type) {
      this.delForm.delDiglogStatus = true;
      this.delForm.id = id;
      this.delForm.title = '提示';
      this.delForm.url = type == 2 ? 'deleteQuickOrder' : 'deleteOrder';
      this.delForm.text1 = '确认要删除这条订单吗？';
      this.delForm.text2 = '删除后订单数据将无法恢复';
      this.delForm.status = false;
    },
    // 调用公共组件--赋值
    getDelData(list) {
      this.delForm = list;
    },
    // 从订单点击退房
    onCheckOutOrder(v) {
      // 5.10
      this.$confirm(this.getRoomType == 1 ? '确定退房?' : '确定退位?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        getCheckOutOrder({ orderCode: v.orderCode, mainId: window.sessionStorage.mainId }).then((res) => {
          if (res.code == 0) {
            this.$message({ message: this.getRoomType == 1 ? '退房成功' : '退位成功', type: 'success' });
            this.toPageNum = 1;
            this.getTakeOrderData();
          } else {
            console.log(res);
          }
        });
      });
    },
    // 待确认状态修改  1是确认  0是拒绝
    isConfirm(id, status) {
      this.diaStatus = status;
      this.chooseId = id;
      if (this.diaStatus == 0) {
        this.dialogVisible = true;
      } else {
        this.comfirmCancelBespeak();
      }
    },
    // 确定取消/拒绝预约
    comfirmCancelBespeak() {
      if (this.diaStatus == 2) {
        const data = {
          id: this.chooseId
        };
        getBookFailures(data).then((res) => {
          if (res.code == 0) {
            this.$message({ message: '取消成功', type: 'success' });
            window.sessionStorage.editOrderId = '';
            window.sessionStorage.bookOrderId = '';
            this.$route.params.form = '';
            this.initialization();
          } else {
            this.$message(res.msg);
          }
        });
      } else {
        const data = {
          orderId: this.chooseId,
          type: this.diaStatus
        };
        getSureOrFalse(data).then((res) => {
          if (res.code == 0) {
            this.$message({ message: (this.diaStatus == 1 ? '确认成功' : '拒绝成功'), type: 'success' });
            this.dialogVisible = false;
            this.toPageNum = 1;
            this.getTakeOrderData();
          } else {
            this.$message(res.msg);
          }
        });
      }
    },
    // 预约开单
    openBill(id) {
      window.sessionStorage.editOrderId = '';
      window.sessionStorage.bookOrderId = id;
      this.$route.params.form = '';
      this.initialization();
    },
    // 取消预约
    cancelBespeak(id, source, num) {
      this.diaStatus = num;
      this.getMsg(id);
    },
    getMsg(id) {
      getBookCancelMsg({ id }).then((res) => {
        if (res.code == 0) {
          this.cancelStatus = res.data ? res.data.cancelStatus ? 1 : 0 : 0;
          this.chooseId = id;
          this.dialogVisible = true;
        } else {
          console.log(res);
        }
      });
    },
    // 输出  1-项目  2-产品  3-套餐
    getGiftVal() {
      return this.giftStatus == 1 ? '项目' : this.giftStatus == 2 ? '产品' : '套餐';
    },
    // 6.2添加赠品
    addGift(val) {
      this.addGiftDia = true;
      this.giftTypeId = '';
      this.giftSearchVal = '';
      this.giftStatus = val;
      this.giftLoad = true;
      if (val == 1) {
        getItemTypeAndItemList({}).then((res) => {
          if (res.code == 0) {
            this.giftTypeList = res.data.itemTypeList;
          }
        });
      } else if (val == 2) {
        getProductType({}).then((res) => {
          if (res.code == 0) {
            this.giftTypeList = res.data;
          }
        });
      }
      this.giftPageNum = 1;
      this.getGiftList(val, 1);
    },
    // 获取项目列表数据
    getGiftList(val, status) {
      if (val == 1) {
        const data = {
          typeId: this.giftTypeId,
          pageNum: this.giftPageNum,
          phone: this.MemberInfo.phone || '',
          keyWord: this.giftSearchVal,
          isDeduct: 0
        };
        if (status == 1) {
          this.chooseGiftList = JSON.parse(JSON.stringify(this.giftSvList));
        }
        getItemListPage(data).then((res) => {
          if (res.code == 0) {
            this.addGiftList = res.data.records;
            this.giftTotalCount = res.data.total;
            this.addGiftList.forEach((a) => {
              this.chooseGiftList.forEach((b) => {
                if (a.itemId == b.itemId) {
                  this.chooseSelectionGift(a);
                }
              });
            });
          } else {
            console.log(res.data);
          }
          this.giftLoad = false;
        });
      } else if (val == 2) {
        const data = {
          typeId: this.giftTypeId,
          keyWord: this.giftSearchVal,
          phone: this.MemberInfo.phone || '',
          pageNum: this.giftPageNum,
          isDeduct: 0
        };
        if (status == 1) {
          this.chooseGiftList = JSON.parse(JSON.stringify(this.giftPdList));
        }
        getProductList(data).then((res) => {
          if (res.code == 0) {
            this.addGiftList = res.data.records;
            this.giftTotalCount = res.data.total;
            this.addGiftList.forEach((a) => {
              this.chooseGiftList.forEach((b) => {
                if (a.productId == b.productId) {
                  this.chooseSelectionGift(a);
                }
              });
            });
          } else {
            console.log(res.data);
          }
          this.giftLoad = false;
        });
      } else {
        const data = {
          mainId: window.sessionStorage.mainId,
          pageNum: this.giftPageNum,
          pageSize: 10,
          type: 0,
          phone: this.MemberInfo.phone || '',
          keyword: this.giftSearchVal
        };
        if (status == 1) {
          this.chooseGiftList = JSON.parse(JSON.stringify(this.giftPkList));
        }
        getBeautyPackageList(data).then((res) => {
          if (res.code == 0) {
            this.addGiftList = res.data.records;
            this.giftTotalCount = res.data.total;
            this.addGiftList.forEach((a) => {
              this.chooseGiftList.forEach((b) => {
                if (a.id == b.id) {
                  this.chooseSelectionGift(a);
                }
              });
            });
          } else {
            console.log(res.data);
          }
          this.giftLoad = false;
        });
      }
    },
    // 回选赠品多选选择框--true
    chooseSelectionGift(row) {
      const vm = this;
      setTimeout(() => {
        vm.$refs.multipleTable.toggleRowSelection(row, true);
      }, 100);
    },
    // 回选赠品多选选择框--false
    delSelectionGift(row) {
      const vm = this;
      setTimeout(() => {
        vm.$refs.multipleTable.toggleRowSelection(row, false);
      }, 100);
    },
    // 6.2删除赠品
    delGift(index, val) {
      if (val == 1) {
        this.giftSvList.splice(index, 1);
      } else if (val == 2) {
        this.giftPdList.splice(index, 1);
      } else {
        this.giftPkList.splice(index, 1);
      }
    },
    // 改变赠品项目分类--事件
    giftTypeChange() {
      this.getGiftList(this.giftStatus);
    },
    // 全选项目赠品列表
    selectAll(selections) {
      const vm = this;
      if (this.giftStatus == 1) {
        if (selections.length === 0) {
          this.addGiftList.forEach((a) => {
            let num = '';
            vm.chooseGiftList.forEach((v, n) => {
              if (v.itemId == a.itemId) {
                num = n;
              }
            });
            if (num !== '') vm.chooseGiftList.splice(num, 1);
          });
          return;
        }
        selections.forEach((a) => {
          let num = 0;
          vm.chooseGiftList.forEach((b) => {
            if (a.itemId != b.itemId) {
              num += 1;
            }
          });
          if (num == vm.chooseGiftList.length) {
            vm.chooseGiftList.push(a);
          }
        });
      } else if (this.giftStatus == 2) {
        if (selections.length === 0) {
          this.addGiftList.forEach((a) => {
            let num = '';
            vm.chooseGiftList.forEach((v, n) => {
              if (v.productId == a.productId) {
                num = n;
              }
            });
            if (num !== '') vm.chooseGiftList.splice(num, 1);
          });
          return;
        }
        selections.forEach((a) => {
          let num = 0;
          vm.chooseGiftList.forEach((b) => {
            if (a.productId != b.productId) {
              num += 1;
            }
          });
          if (num == vm.chooseGiftList.length) {
            vm.chooseGiftList.push(a);
          }
        });
      } else {
        if (selections.length === 0) {
          this.addGiftList.forEach((a) => {
            let num = '';
            vm.chooseGiftList.forEach((v, n) => {
              if (v.id == a.id) {
                num = n;
              }
            });
            if (num !== '') vm.chooseGiftList.splice(num, 1);
          });
          return;
        }
        selections.forEach((a) => {
          let num = 0;
          vm.chooseGiftList.forEach((b) => {
            if (a.id != b.id) {
              num += 1;
            }
          });
          if (num == vm.chooseGiftList.length) {
            vm.chooseGiftList.push(a);
          }
        });
      }
    },
    handleSelectionChange(row, event, column, target) {
      const vm = this;
      if (target) {
        vm.$refs.multipleTable.toggleRowSelection(row);
      }
      let chooseNum = 0;
      let index;
      if (this.giftStatus == 1) {
        for (let j = 0; vm.chooseGiftList.length > j; j++) {
          if (vm.chooseGiftList[j].itemId == row.itemId) {
            index = j;
          } else {
            chooseNum++;
          }
        }
      } else if (this.giftStatus == 2) {
        for (let j = 0; vm.chooseGiftList.length > j; j++) {
          if (vm.chooseGiftList[j].productId == row.productId) {
            index = j;
          } else {
            chooseNum++;
          }
        }
      } else {
        for (let j = 0; vm.chooseGiftList.length > j; j++) {
          if (vm.chooseGiftList[j].id == row.id) {
            index = j;
          } else {
            chooseNum++;
          }
        }
      }
      if (chooseNum == vm.chooseGiftList.length) {
        vm.chooseGiftList.push(row);
      } else {
        vm.chooseGiftList.splice(index, 1);
      }
    },
    // 删除已勾选的赠品项目
    delChooseGift(item, index) {
      this.chooseGiftList.splice(index, 1);
      this.delSelectionGift(item);
    },
    handleSizeChange(val) {
      this.giftPageNum = val;
      this.getGiftList(this.giftStatus);
    },
    handleCurrentChange(val) {
      this.giftPageNum = val;
      this.getGiftList(this.giftStatus);
    },
    comfirmAddGift() {
      const vm = this;
      vm.addGiftDia = false;
      if (vm.chooseGiftList) {
        vm.chooseGiftList.forEach((x) => {
          x.expireTime = x.expireTime || '';
          x.giftId = x.giftId || '';
          x.givingQuantity = x.givingQuantity || 1;
          x.orderId = x.orderId || '';
        });
      }
      if (vm.giftStatus == 1) {
        vm.giftSvList = JSON.parse(JSON.stringify(vm.chooseGiftList));
      } else if (vm.giftStatus == 2) {
        vm.giftPdList = JSON.parse(JSON.stringify(vm.chooseGiftList));
      } else {
        vm.giftPkList = JSON.parse(JSON.stringify(vm.chooseGiftList));
      }
    },
    // 5.9添加手牌
    addHand() {
      this.handList.push({
        id: '',
        handCardNumber: '',
        status: 0,
        inputStatus: 1
      });
    },
    // 5.9删除手牌
    delHand(index) {
      this.handList.splice(index, 1);
    },
    // 5.4  勾选禁用判断
    checkSelectable(row) {
      return !((row.state == 4 || row.state == 5 || row.state == 6));
    },
    checkRoomBtn() {
      // if (data.isShow != 1 && this.id) {
      //   this.$message('已有房间产生住房记录');
      //   return;
      // }
      this.check_in_visible = true;
    },
    desktopClassReturn() {
      if (window.require !== undefined) {
        this.desktopStatus = true;
      } else if (window.sessionStorage.ishd == 1) {
        this.desktopStatus = true;
      } else {
        this.desktopStatus = false;
      }
      if (this.deadlineStatus == 'true') {
        return 'list listThree scrollbar';
      }
      return 'list listFour scrollbar';
    },
    desktopStyleReturn() {
      if (window.require !== undefined) {
        this.desktopStatus = true;
      } else if (window.sessionStorage.ishd == 1) {
        this.desktopStatus = true;
      } else {
        this.desktopStatus = false;
      }
      if (this.deadlineStatus == 'true') {
        return 'height: calc(100vh - 412px);margin-bottom: 0;';
      }
      return 'height: calc(100vh - 336px) !important;margin-bottom: 0;';
    },
    getHeightClass() {
      if (window.require !== undefined) {
        this.desktopStatus = true;
      } else if (window.sessionStorage.ishd == 1) {
        this.desktopStatus = true;
      } else {
        this.desktopStatus = false;
      }
      if (this.searchStatus == 1) {
        if (this.customerSwitch == 0 || this.handSwitch == 0) {
          return 'newTableThreeDesk';
        }
        return 'newTableSixDesk';
      }
      if (this.searchStatus == 2) {
        if (this.customerSwitch == 0 || this.handSwitch == 0) {
          return 'newTableFourDesk';
        }
        return 'newTableSevenDesk';
      }
      if (this.searchStatus == 3) {
        if (this.customerSwitch == 0 || this.handSwitch == 0) {
          return 'newTableFiveDesk';
        }
        return 'newTableEightDesk';
      }
    },
    // 调用公共组件--赋值
    memberUrl(list) {
      this.digForm = list;
    },
    // open 新增会员
    newGetMemberUrl(val, phone) {
      this.digForm.memberDialog = true;
      this.digForm.status = val;
      const data = { type: val };
      getMemberUrl(data).then((res) => {
        if (res.code == 0) {
          this.digForm.memberManageSrc = `${res.data}?phone=${phone}&hideBack=1&shopId=${window.sessionStorage.shopId}`;
        } else {
          console.log(res);
          // this.$message(res.msg)
        }
      });
    },
    // 搜索下拉列表
    querySearch(queryString, cb) {
      this.state = queryString;
      const data = {
        mainId: window.sessionStorage.mainId,
        keyWord: this.state,
        phone: this.MemberInfo.phone || ''
      };
      getOrderItemList(data).then((res) => {
        if (res.code == 0 && res.data) {
          const itemOne = [];
          res.data.itemList.forEach((v) => {
            v.value = v.itemName;
            itemOne.push(v);
          });
          const itemTwo = [];
          res.data.productList.forEach((v) => {
            v.value = v.productName + v.productCode + v.barCode;
            itemTwo.push(v);
          });
          const itemThree = [];
          res.data.packageList.forEach((v) => {
            v.value = v.vipCardName;
            itemThree.push(v);
          });
          const resultsOne = itemOne.filter(this.createFilter(queryString));
          const resultsTwo = itemTwo.filter(this.createFilter(queryString));
          const resultsThree = itemThree.filter(this.createFilter(queryString));
          const arr = [
            {
              itemList: resultsOne,
              productList: resultsTwo,
              packageList: resultsThree,
            }
          ];
          cb(arr);
        } else {
          console.log(res.msg);
        }
      });
    },
    // 搜索下拉列表--比较value值
    createFilter(queryString) {
      return (restaurant) => (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) >= 0);
    },
    // 搜索下拉列表--选择
    handleSelect() {
      const newName = this.chooseName;
      this.state = newName;
    },
    // 搜索获取会员信息
    memberSearch(val, info, code, tObj) {
      this.check_in_loading = true;
      this.Lib.keyboardBlur();
      const vm = this;
      if (this.form.phone) {
        // if (this.Lib.CheckPhone(this.form.phone) == false) {
        //   this.newGetCustomerList(this.form.phone);
        //   return;
        // }
        vm.newEditMemberPhone(val, info, code, tObj);
      } else {
        if (val == '99') {
          vm.pageNum1 = 1;
          vm.getServiceList();
          return false;
        }
        return false;
      }
      // vm.check_in_data = {
      //   roomInfosList: [{
      //     roomName: '',
      //     peopleNumber: ''
      //   }]
      // };
    },
    // 新需求5.9那时，顾客列表
    newGetCustomerList(val) {
      const data = {
        mainId: window.sessionStorage.mainId,
        sex: '',
        memberType: '',
        grade: '',
        rate: '',
        birthdayStart: '',
        birthdayEnd: '',
        source: '',
        pageNum: 1,
        pageSize: 9999,
        phone: val
      };
      getCustomerMsgList(data).then((res) => {
        if (res.code == 0) {
          if (res.data.records.length == 0) {
            this.$message('暂无搜索结果');
          } else if (res.data.records.length == 1) {
            this.checkMember(res.data.records[0].phone);
          }
        }
      });
    },
    // 5.4服务开单换会员不清数据
    newEditMemberPhone(val, info, code, tObj) {
      let dictItemIds = '';
      let productIds = '';
      let packageIds = '';
      this.form.tableData.forEach((a) => {
        if (a.listStatus == 1) {
          dictItemIds += `${a.dictItemId},`;
        } else if (a.listStatus == 2) {
          productIds += `${a.productId},`;
        } else {
          packageIds += `${a.vipCardId},`;
        }
      });
      const data = {
        keyWord: this.form.phone || '',
        dictItemIds,
        productIds,
        packageIds
      };
      getMemberCardMsg(data).then((res) => {
        if (res.code == 0) {
          this.MemberInfo = res.data ? res.data.phone ? res.data : {} : {};
          this.check_in_loading = false;
          this.searchStatus = res.data ? res.data.cardNo ? 3 : this.form.phone ? 2 : 1 : 1;
          if (info) {
            res.data.nickName ? '' : (res.data.nickName = info.memberName);
            this.getNewBespeakData(info);
          }
          if (this.$route.params.form) {
            this.check_in_data = this.$route.params.form;
          }
          if ((this.handCustomer.womanNumber == 0 && this.handCustomer.manNumber == 0 && this.handCustomer.midNumber == 1) || (this.handCustomer.womanNumber == 1 && this.handCustomer.manNumber == 0 && this.handCustomer.midNumber == 0) || (this.handCustomer.womanNumber == 0 && this.handCustomer.manNumber == 1 && this.handCustomer.midNumber == 0)) {
            if (res.data.sex === '男') {
              this.handCustomer.womanNumber = 0;
              this.handCustomer.manNumber = 1;
              this.handCustomer.midNumber = 0;
            } else if (res.data.sex === '女') {
              this.handCustomer.womanNumber = 1;
              this.handCustomer.manNumber = 0;
              this.handCustomer.midNumber = 0;
            } else {
              this.handCustomer.womanNumber = 0;
              this.handCustomer.manNumber = 0;
              this.handCustomer.midNumber = 1;
            }
          }
          if (val == 99) this.getServiceList();
          // 6.5
          if (val != 99) {
            this.form.tableData.forEach((a) => {
              if (a.listStatus == 1) {
                a.qyList = [];
                a.qyCheckBox = '';
                a.detailList = [];
              } else if (a.listStatus == 2) {
                a.qyList = [];
                a.qyCheckBox = [];
                a.detailList = [];
              } else {
                a.qyList = [];
                a.qyCheckBox = [];
                a.detailList = [];
              }
            });
          }
          // 5.4
          this.form.tableData.forEach((b) => {
            if (b.listStatus == 1) {
              res.data.itemList ? '' : res.data.itemList = [];
              res.data.itemList.forEach((c) => {
                if (b.dictItemId == c.dictItemId) {
                  b.activityInfo = c.activityInfo;
                  b.hasActivity = c.hasActivity;
                  b.memberDiscount = c.memberDiscount;
                  b.memberPrice = c.memberPrice;
                  b.discountType = c.discountType;
                  b.price = c.price;
                  b.oldPrice = c.price;
                  b.editPrice = c.price;
                  b.package = [];
                  b.percentage4ServeList = b.percentage4ServeList;
                  b.percentageSellServeList = b.percentageSellServeList;
                  b.discountMoney = !this.MemberInfo.cardNo ? (c.isWholesale == 1 ? (c.wholesalePrice * 1).toFixed(2) : (c.hasActivity == 1 ? c.activityInfo.activityPrice * 1 : c.price * 1).toFixed(2)) : (c.isWholesale == 1 ? (c.wholesalePrice * 1).toFixed(2) : (c.hasActivity == 1 ? c.activityInfo.activityPrice * 1 : c.memberPrice * 1).toFixed(2));
                  b.isWholesale = c.isWholesale;
                }
              });
            } else if (b.listStatus == 2) {
              res.data.productList ? '' : res.data.productList = [];
              res.data.productList.forEach((d) => {
                if (b.productId == d.productId) {
                  b.activityInfo = d.activityInfo;
                  b.hasActivity = d.hasActivity;
                  b.memberDiscount = d.memberDiscount;
                  b.memberPrice = d.memberPrice;
                  b.discountType = d.discountType;
                  b.price = d.price;
                  b.oldPrice = d.price;
                  b.editPrice = d.price;
                  b.package = [];
                  b.percentage4ProductList = b.percentage4ProductList;
                  b.discountMoney = !this.MemberInfo.cardNo ? (d.isWholesale == 1 ? (d.wholesalePrice * 1).toFixed(2) : (d.hasActivity == 1 ? d.activityInfo.activityPrice * 1 : d.price * 1).toFixed(2)) : (d.isWholesale == 1 ? (d.wholesalePrice * 1).toFixed(2) : (d.hasActivity == 1 ? d.activityInfo.activityPrice * 1 : d.memberPrice * 1).toFixed(2));
                  b.isWholesale = d.isWholesale;
                }
              });
            } else {
              res.data.packageList ? '' : res.data.packageList = [];
              res.data.packageList.forEach((e) => {
                if (b.vipCardId == e.id) {
                  b.vipCardId = e.id;
                  b.activityInfo = e.activityInfo;
                  b.hasActivity = e.hasActivity;
                  b.memberDiscount = e.memberDiscount;
                  b.memberPrice = e.memberPrice;
                  b.discountType = e.discountType;
                  b.price = e.price;
                  b.oldPrice = e.price;
                  b.editPrice = e.price;
                  b.technicianId = '';
                  b.percentage4PackageList = b.percentage4PackageList;
                  b.discountMoney = !this.MemberInfo.cardNo ? (e.isWholesale == 1 ? (e.wholesalePrice * 1).toFixed(2) : (e.hasActivity == 1 ? e.activityInfo.activityPrice * 1 : e.price * 1).toFixed(2)) : (e.isWholesale == 1 ? (e.wholesalePrice * 1).toFixed(2) : (e.hasActivity == 1 ? e.activityInfo.activityPrice * 1 : e.memberPrice * 1).toFixed(2));
                  b.isWholesale = e.isWholesale;
                }
              });
            }
          });
          // 6.3
          if (code == '电子票') {
            this.activeIndex = '电子票';
            this.packageData(0, '电子票', tObj);
            this.packageData(3);
          } else if (code == '套餐') {
            this.packageData(0, '套餐', tObj);
            this.packageData(1);
          } else {
            this.packageData(0);
          }
        } else {
          console.log(res);
        }
        this.memberStatus();
        if (val != 99) {
          this.chooseNav(this.navStatus);
        }
      });
    },
    memberStatus() {
      const vm = this;
      setTimeout(() => {
        vm.formChange();
      }, 100);
    },
    // 获取顾客套餐列表
    packageData(val, code, tObj) {
      this.loadStatus = 1;
      const data = {
        deductType: val,
        mainId: window.sessionStorage.mainId,
        phone: this.form.phone
      };
      getCanDeductList(data).then((res) => {
        if (val == 1) {
          res.data ? this.giftPackageList = res.data : this.giftPackageList = [];
          this.formChange();
        } else if (val == 2) {
          res.data[0].canDeductItemDetailList.forEach((a) => {
            a.hkName = `赠品-${a.expireTime}`;
          });
          res.data[1].canDeductProductDetailList.forEach((b) => {
            b.hkName = `赠品-${b.expireTime}`;
          });
          res.data ? this.giftProjectList = res.data[0].canDeductItemDetailList : this.giftProjectList = [];
          res.data ? this.giftProductList = (res.data[1].canDeductProductDetailList || []) : this.giftProductList = [];
          this.formChange();
        } else if (val == 3) {
          res.data[0].canDeductItemDetailList.forEach((b) => {
            b.hkName = `电子票-${b.expireTime}`;
          });
          res.data ? this.ticketProjectList = res.data[0].canDeductItemDetailList : this.ticketProjectList = [];
          const arr = [];
          res.data.forEach((a, n) => {
            if (n > 0) {
              arr.push(a);
            }
          });
          this.ticketList = arr;
          this.formChange();
        } else {
          const arr = [];
          res.data.forEach((a, n) => {
            if (n > 2) {
              arr.push(a);
            } else if (n == 0 && a.canDeductItemDetailList) {
              a.canDeductItemDetailList.forEach((b) => {
                const obj = {};
                obj.canDeductItemDetailList = [b];
                obj.canDeductProductDetailList = [];
                obj.clientVipCardId = b.clientVipCardId;
                obj.count = null;
                obj.countLimitType = 1;
                obj.expireTime = b.expireTime;
                obj.giftId = b.giftId;
                obj.imgUrl = '';
                obj.name = `赠品-${b.expireTime}`;
                obj.vipCardId = null;
                obj.remaining = b.remaining;
                obj.isGift = 1;
                obj.isElectronicTicket = 0;
                arr.push(obj);
              });
            } else if (n == 1 && a.canDeductProductDetailList) {
              a.canDeductProductDetailList.forEach((c) => {
                const obj = {};
                obj.canDeductItemDetailList = [];
                obj.canDeductProductDetailList = [c];
                obj.clientVipCardId = c.clientVipCardId;
                obj.count = null;
                obj.countLimitType = 1;
                obj.expireTime = c.expireTime;
                obj.giftId = c.giftId;
                obj.imgUrl = '';
                obj.name = `赠品-${c.expireTime}`;
                obj.vipCardId = null;
                obj.remaining = c.remaining;
                obj.isGift = 1;
                obj.isElectronicTicket = 0;
                arr.push(obj);
              });
            } else if (n == 2 && a.canDeductItemDetailList) {
              a.canDeductItemDetailList.forEach((b) => {
                const obj = {};
                obj.canDeductItemDetailList = [b];
                obj.canDeductProductDetailList = [];
                obj.clientVipCardId = b.clientVipCardId;
                obj.count = null;
                obj.countLimitType = 1;
                obj.eitemId = b.eitemId;
                obj.expireTime = b.expireTime;
                obj.giftId = b.giftId;
                obj.imgUrl = '';
                obj.name = `电子票-${b.expireTime}`;
                obj.vipCardId = null;
                obj.remaining = b.remaining;
                obj.isGift = 0;
                obj.isElectronicTicket = 1;
                arr.push(obj);
              });
            }
          });
          this.form.packageData = arr;
          if (code == '电子票' && tObj) {
            this.loadStatus = 2;
            this.addListData(tObj, 1, tObj);
          } else if (code == '套餐' && tObj) {
            this.loadStatus = 2;
            this.addListData(tObj, 1, tObj);
          }
          this.formChange();
        }
        setTimeout(() => {
          this.loadStatus = 2;
        }, 300);
      });
    },
    onCloseDialog(val) {
      this.customerVisible = val;
    },
    handleClick(tab) {
      if (tab.label == '项目') {
        this.chooseNav('1');
      } else if (tab.label == '产品') {
        this.chooseNav('2');
      } else if (tab.label == '套餐') {
        this.chooseNav('3');
      }
    },
    // 划扣/充值
    buckleTab(tab) {
      if (tab.label == '套餐') {
        this.packageData(1);
      } else if (tab.label == '赠送') {
        this.packageData(2);
      } else if (tab.label == '电子票') {
        this.packageData(3);
      }
    },
    // 选择导航栏
    chooseNav(val) {
      if (val == 3) {
        this.pageNum3 = 1;
        this.loading3 = true;
        this.phoneSearch();
      } else if (val == 1) {
        this.pageNum1 = 1;
        this.loading1 = true;
        this.getServiceList();
      } else if (val == 2) {
        this.pageNum2 = 1;
        this.loading2 = true;
        this.getProductData();
      }
      this.navStatus = val;
    },
    // 选择销售员工--勾选事件
    selectBatch(selection, row) {
      const vm = this;
      const obj = {};
      obj.isExit = row.isExit;
      obj.isGuest = 0;
      obj.technicianId = row.technicianId;
      obj.name = row.name;
      obj.number = row.number;
      obj.levelType = row.levelType;
      obj.resultIsEdit = 0;
      obj.technicianName = row.technicianName;
      obj.isBatchAdd = 1;
      let chooseNum = 0;
      let index;
      for (let j = 0; vm.chooseSaleList.length > j; j++) {
        if (vm.chooseSaleList[j].technicianId == obj.technicianId) {
          index = j;
        } else {
          chooseNum++;
        }
      }
      if (chooseNum == vm.chooseSaleList.length) {
        vm.chooseSaleList.push(obj);
        vm.chooseSelection(obj, 4, true);
      } else {
        vm.chooseSaleList.splice(index, 1);
        vm.chooseSelection(obj, 4, false);
      }
    },
    // 选择批量添加销售--勾选事件
    rowClickBatch(row) {
      if (row.state == 4 || row.state == 5 || row.state == 6) return;
      const vm = this;
      const obj = {};
      obj.isExit = row.isExit;
      obj.isGuest = 0;
      obj.technicianId = row.technicianId;
      obj.name = row.name;
      obj.number = row.number;
      obj.levelType = row.levelType;
      obj.resultIsEdit = 0;
      obj.technicianName = row.technicianName;
      obj.isBatchAdd = 1;
      vm.$refs.batchTable.toggleRowSelection(row);
      let chooseNum = 0;
      let index;
      for (let j = 0; vm.chooseSaleList.length > j; j++) {
        if (vm.chooseSaleList[j].technicianId == obj.technicianId) {
          index = j;
        } else {
          chooseNum++;
        }
      }
      if (chooseNum == vm.chooseSaleList.length) {
        vm.chooseSaleList.push(obj);
      } else {
        vm.chooseSaleList.splice(index, 1);
      }
    },
    // 删除选择的销售--批量添加销售
    delChooseBatch(id) {
      const vm = this;
      for (let i = 0; vm.searchSaleList.length > i; i++) {
        if (vm.searchSaleList[i].technicianId == id) {
          vm.chooseSelection(vm.searchSaleList[i], 4, false);
        }
      }
      for (let j = 0; vm.chooseSaleList.length > j; j++) {
        if (vm.chooseSaleList[j].technicianId == id) {
          vm.chooseSaleList.splice(j, 1);
        }
      }
    },
    // 确定添加销售员工--批量添加销售
    comfirmAddBatch() {
      this.form.tableData.forEach((a) => {
        this.chooseSaleList.forEach((b) => {
          let num = 0;
          if (a.listStatus == 1) {
            a.percentageSellServeList.forEach((c) => {
              if (b.technicianId != c.technicianId) {
                num++;
              }
            });
            if (num == a.percentageSellServeList.length) {
              b.isBatchAdd = 1;
              b.result = this.resultType == 1 ? 100 : (100 / (this.chooseSaleList.length)).toFixed(0);
              a.percentageSellServeList.push(b);
            }
          } else if (a.listStatus == 2) {
            a.percentage4ProductList.forEach((c) => {
              if (b.technicianId != c.technicianId) {
                num++;
              }
            });
            if (num == a.percentage4ProductList.length) {
              b.isBatchAdd = 1;
              b.result = this.resultType == 1 ? 100 : (100 / (this.chooseSaleList.length)).toFixed(0);
              a.percentage4ProductList.push(b);
            }
          } else {
            a.percentage4PackageList.forEach((c) => {
              if (b.technicianId != c.technicianId) {
                num++;
              }
            });
            if (num == a.percentage4PackageList.length) {
              b.isBatchAdd = 1;
              b.result = this.resultType == 1 ? 100 : (100 / (this.chooseSaleList.length)).toFixed(0);
              a.percentage4PackageList.push(b);
            }
          }
        });
      });
      this.batchAddDia = false;
    },
    // 6.5--批量添加销售
    batchAdd() {
      if (this.form.tableData.length > 0) {
        getPercentageSkin({ mainId: window.sessionStorage.mainId }).then((res) => {
          this.scaleStan = res.data.scaleStan;
          this.resultType = res.data.resultType;
        });
        const data = {
          mainId: window.sessionStorage.mainId,
          cardType: 2,
          keyWord: this.batchAddVal
        };
        erpTechnicianCardByMainId(data).then((res) => {
          if (res.code == 0) {
            this.brandInfo = res.data;
            this.activeName = res.data.cards.length > 0 ? (`${res.data.cards[0].id}`) : '';
            this.getBatchData();
          } else {
            console.log(res);
          }
        });
      }
    },
    // 获取批量添加销售的数据
    getBatchData() {
      const data = {
        mainId: window.sessionStorage.mainId,
        cardId: this.brandInfo.cardOpen == 1 ? this.activeName : '',
        keyWord: this.batchAddVal
      };
      this.loading = true;
      this.chooseSaleList = [];
      getByTechnicianListByCardId(data).then((res) => {
        if (res.code == 0) {
          this.searchSaleList = res.data;
        } else {
          this.searchSaleList = [];
        }
        this.loading = false;
        this.batchAddDia = true;
      });
    },
    // 重置会员信息
    resetInfo() {
      if (this.bookStatus == 1) {
        this.$message('预约订单中已支付定金，不可更换顾客');
        return;
      } if (this.bookStatus == 2) {
        this.$message('预约订单中已使用划扣次数，不可更换顾客');
        return;
      }
      if (this.check_in_data.roomInfosList[0].roomName) {
        this.$confirm('此操作会清空开房信息, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.MemberInfo = '';
          this.searchStatus = 1;
          this.form.tableData.forEach((b) => {
            if (b.listStatus == 1) {
              b.price = b.oldPrice;
              b.editPrice = b.oldPrice;
              b.package = [];
              b.percentage4ServeList = [];
              b.percentageSellServeList = [];
              //   b.percentage4ServeList = b.percentage4ServeList
              //   b.percentageSellServeList = b.percentageSellServeList
              b.discountMoney = !this.MemberInfo.cardNo ? (b.price * 1).toFixed(2) : (b.memberPrice * 1).toFixed(2);
            } else if (b.listStatus == 2) {
              b.price = b.oldPrice;
              b.editPrice = b.oldPrice;
              b.package = [];
              b.percentage4ProductList = [];
              //   b.percentage4ProductList = b.percentage4ProductList
              b.discountMoney = !this.MemberInfo.cardNo ? (b.price * 1).toFixed(2) : (b.memberPrice * 1).toFixed(2);
            } else {
              b.price = b.oldPrice;
              b.editPrice = b.oldPrice;
              b.technicianId = '';
              b.percentage4PackageList = [];
              //   b.percentage4PackageList = b.percentage4PackageList
              b.discountMoney = !this.MemberInfo.cardNo ? (b.price * 1).toFixed(2) : (b.memberPrice * 1).toFixed(2);
            }
          });
          this.form.phone = '';
          this.form.packageData = [];
          this.formChange();
          this.phoneSearch();
          this.check_in_data = {
            roomInfosList: [{
              roomName: '',
              peopleNumber: ''
            }]
          };
          this.newEditMemberPhone();
        });
      } else {
        this.MemberInfo = '';
        this.searchStatus = 1;
        this.form.phone = '';
        this.phoneSearch();
        this.check_in_data = {
          roomInfosList: [{
            roomName: '',
            peopleNumber: ''
          }]
        };
        this.form.tableData.forEach((item) => {
          item.package = [];
        });
        this.form.packageData = [];
        this.newEditMemberPhone();
      }
      this.radioLeft = '1';
      this.chooseNav('1');
    },
    // 編輯顾客信息
    edit(phone) {
      window.sessionStorage.customerPhone = phone;
      this.customerStatus = '编辑顾客';
      this.customerVisible = true;
    },
    // 清空选择的项目  产品  套餐
    clearData() {
      let status = 0;
      this.form.tableData.forEach((a) => {
        if (a.bookAmount) {
          status = 1;
        }
        if (a.deductType == 1) {
          status = 2;
        }
      });
      if (status == 1) {
        this.$message('预约订单中已支付定金，不可删除');
        return;
      } if (status == 2) {
        this.$message('预约订单中已使用划扣次数，不可删除');
        return;
      }
      this.form.tableData = [];
      this.check_in_data = {
        roomInfosList: [{
          roomName: '',
          peopleNumber: ''
        }]
      };
      this.giftSvList = [];
      this.giftPdList = [];
      this.giftPkList = [];
      this.formChange();
    },
    // 获取项目列表数据
    getServiceList() {
      this.loadS1 = true;
      // 如果遇到卡项目可以解开
      // if (this.pageNum1 == 1) {
      //   this.loading1 = true;
      // }
      this.loadStatus = 1;
      const data = {
        typeId: this.chooseItemTypeId,
        pageNum: this.pageNum1,
        phone: this.MemberInfo.phone || '',
        keyWord: '',
        isDeduct: 0,
        activityType: this.chooseItemTypeId == 2 ? this.actServiceType : ''
      };
      getItemListPage(data).then((res) => {
        if (res.code == 0) {
          this.pages1 = res.data.pages;
          if (this.pageNum1 == 1 && this.chooseItemTypeId != 1) {
            this.serviceList = res.data.records;
            this.loading1 = false;
            this.pageNum1++;
            this.getServiceList();
          } else if (this.pageNum1 < 3 && this.pageNum1 > 1) {
            if (res.data.pages >= res.data.current) {
              res.data.records.forEach((a) => {
                this.serviceList.push(a);
              });
              this.pageNum1++;
              this.getServiceList();
            }
          } else if (this.pageNum1 >= 3) {
            if (res.data.pages >= res.data.current) {
              res.data.records.forEach((a) => {
                this.serviceList.push(a);
              });
              this.pageNum1++;
            }
          } else if (this.pageNum1 == 1 && this.chooseItemTypeId == 1) {
            this.serviceList = res.data.records;
            this.loading1 = false;
          }
        } else {
          console.log(res.data);
        }
        setTimeout(() => {
          this.loadStatus = 2;
          this.loadS1 = false;
        }, 300);
      });
    },
    // 改变项目分类
    changeProjectType(id) {
      if (this.loadS1 == true) {
        this.$message('数据努力加载中，请稍等...');
        return;
      }
      this.chooseItemTypeId = id;
      this.pageNum1 = 1;
      this.getServiceList();
    },
    // 6.7选择活动类型--项目
    changeAst(val) {
      if (this.loadS1 == true) {
        this.$message('数据努力加载中，请稍等...');
        return;
      }
      this.actServiceType = val;
      this.pageNum1 = 1;
      this.getServiceList();
    },
    // 改变产品分类
    changeProductType(id) {
      if (this.loadS2 == true) {
        this.$message('数据努力加载中，请稍等...');
        return;
      }
      this.chooseProductTypeId = id;
      this.pageNum2 = 1;
      this.getProductData();
    },
    // 6.7选择活动类型--产品
    changeApt(val) {
      if (this.loadS2 == true) {
        this.$message('数据努力加载中，请稍等...');
        return;
      }
      this.actProductType = val;
      this.pageNum2 = 1;
      this.getProductData();
    },
    // 修改改价的初始金额
    editRightsPrice(obj, val) {
      obj.qyList.forEach((a) => {
        a.originalPrice = val;
        a.price = val;
        a.memberPrice = obj.discountType == 0 ? (val * obj.memberDiscount / 10).toFixed(2) : obj.memberPrice;
        if (a.type == 5) {
          a.rightsPrice = val;
          a.percentage = 100;
        } else if (a.type == 4) {
          a.twoPrice = obj.discountType == 0 ? (val * obj.memberDiscount / 10).toFixed(2) : obj.memberPrice;
          a.rightsPrice = obj.discountType == 0 ? (val * obj.memberDiscount / 10).toFixed(2) : obj.memberPrice;
        } else if (a.type == 3) {
          a.rightsPrice = (val * obj.activityInfo.discount / 10).toFixed(2);
        } else if (a.type == 99) {
          a.rightsPrice = val;
        }
      });
      obj.detailList.forEach((a) => {
        a.originalPrice = val;
        a.memberPrice = obj.discountType == 0 ? (val * obj.memberDiscount / 10).toFixed(2) : obj.memberPrice;
        if (a.type == 5) {
          a.rightsPrice = val;
          a.percentage = 100;
        } else if (a.type == 4) {
          a.twoPrice = obj.discountType == 0 ? (val * obj.memberDiscount / 10).toFixed(2) : obj.memberPrice;
          a.rightsPrice = obj.discountType == 0 ? (val * obj.memberDiscount / 10).toFixed(2) : obj.memberPrice;
        } else if (a.type == 3) {
          a.rightsPrice = (val * obj.activityInfo.discount / 10).toFixed(2);
        } else if (a.type == 99) {
          a.rightsPrice = val;
        }
      });
    },
    // 修改项目/产品/套餐原价
    comfirmEditOldPrice(index, status) {
      setTimeout(() => {
        if (this.form.tableData[index].editPrice * 1 >= this.form.tableData[index].oldPrice * 1) {
          if (this.form.tableData[index].editPrice * 1 > 9999999) {
            this.$message('修改的价格不能大于9999999');
            this.form.tableData[index].price = 9999999;
            this.editRightsPrice(this.form.tableData[index], 9999999);
          } else {
            this.form.tableData[index].price = this.form.tableData[index].editPrice;
            this.editRightsPrice(this.form.tableData[index], this.form.tableData[index].editPrice);
          }
          if (status != 1 && this.MemberInfo.cardNo) {
            this.form.tableData[index].discountMoney = (this.form.tableData[index].editPrice * this.form.tableData[index].memberDiscount * 0.1).toFixed(2);
            this.formChange(index);
          }
          if (!this.MemberInfo.cardNo) {
            this.form.tableData[index].discountMoney = this.form.tableData[index].editPrice;
            this.formChange(index);
          }
        } else {
          this.$message('修改的价格不能小于原价');
          this.form.tableData[index].editPrice = this.form.tableData[index].oldPrice;
        }
        $('body').click();
        this.$forceUpdate();
      }, 100);
    },
    // 计算服务开单价格
    formChange(index) {
      const vm = this;
      let totalPrice = 0;
      // if (item) {
      //   if ((item.limitPurchase * 1 > 0)) {
      //     const data = Number(item.limitPurchase * 1 - item.alreadyPurchase * 1);
      //     if (data <= item.count) {
      //       const name2 = JSON.parse(JSON.stringify(data));
      //       item.count = name2;
      //       // vm.form.tableData[index].count = name2;
      //       return this.$message(`${item.vipCardName}限购${item.limitPurchase}次，该客户已购买过${item.alreadyPurchase}次，已达上限`);
      //     }
      //   }
      // }
      setTimeout(() => {
        if (index !== undefined && index !== null) {
          if (parseFloat(vm.form.tableData[index].count) < 1 || !vm.form.tableData[index].count) {
            vm.form.tableData[index].count = 1;
          } else if (parseFloat(vm.form.tableData[index].count) > 9999) {
            vm.form.tableData[index].count = 9999;
          } else {
            vm.form.tableData[index].count = Math.floor(vm.form.tableData[index].count);
          }
        }
        if (vm.form.tableData.length > 0) {
          vm.form.tableData.forEach((a) => {
            totalPrice += vm.calculationPreferential(a) * 1;
          });
          vm.listTotal = totalPrice.toFixed(2);
        } else {
          vm.listTotal = '0.00';
        }
        vm.$forceUpdate();
      }, 10);

      this.form.tableData.forEach((z) => {
        if (z.package.length == 0) {
          this.form.packageData.forEach((a) => {
            if (a.canDeductItemDetailList) {
              a.canDeductItemDetailList.forEach((b) => {
                if (a.countLimitType == 1) {
                  if (z.dictItemId == b.dictItemId && z.package && b.remaining != 0) {
                    a.ischeck = false;
                    a.qyCount = 1;
                    a.price = z.price;
                    z.package.push(a);
                  }
                } else if (a.countLimitType == 2) {
                  if (z.dictItemId == b.dictItemId) {
                    a.ischeck = false;
                    a.qyCount = 1;
                    a.price = z.price;
                    z.package.push(a);
                  }
                } else if (z.dictItemId == b.dictItemId && a.remaining) {
                  a.ischeck = false;
                  a.qyCount = 1;
                  a.price = z.price;
                  z.package.push(a);
                }
              });
            }
            if (a.canDeductProductDetailList) {
              a.canDeductProductDetailList.forEach((d) => {
                if (a.countLimitType == 1) {
                  if (z.productId == d.productId && z.package && d.remaining != 0) {
                    a.ischeck = false;
                    a.qyCount = this.getQycount(z, a);
                    a.price = z.price;
                    z.package.push(a);
                  }
                } else if (a.countLimitType == 2) {
                  if (z.productId == d.productId) {
                    a.ischeck = false;
                    a.qyCount = this.getQycount(z, a);
                    a.price = z.price;
                    z.package.push(a);
                  }
                } else if (z.productId == d.productId && a.remaining) {
                  a.ischeck = false;
                  a.qyCount = this.getQycount(z, a);
                  a.price = z.price;
                  z.package.push(a);
                }
              });
            }
          });
        }
      });
      this.getBuyGiftList();
      this.autoChooseRights((index !== undefined && index !== null) ? 2 : 1);
    },
    // 获取划扣的数量
    getQycount(obj, pobj) {
      let num = 1;
      obj.productDeductList = obj.productDeductList || [];
      obj.productDeductList.forEach((a) => {
        if (((a.vipCardId == pobj.vipCardId) && a.vipCardId) || ((a.giftId == pobj.giftId) && a.giftId) || ((a.clientVipCardId == pobj.clientVipCardId) && a.clientVipCardId)) {
          num = a.count;
        }
      });
      return num;
    },
    // 获得项目分类列表
    getItemListData() {
      const data = {};
      getItemTypeAndItemList(data).then((res) => {
        if (res.code == 0) {
          if (!this.chooseItemTypeId) this.chooseItemTypeId = res.data.itemTypeList[0].id;
          if (!this.id && !this.form.bookOrderId) this.getServiceList();
          this.itemTypeList = res.data.itemTypeList;
        }
      });
    },
    // 获得产品分类数据
    getProductTypeData() {
      const data = {};
      getProductType(data).then((res) => {
        if (res.code == 0) {
          if (!this.chooseProductTypeId && res.data.length > 0) this.chooseProductTypeId = res.data[0].productId;
          this.productTypeList = res.data;
        }
      });
    },
    // 产品销售列表
    getProductData() {
      this.loadS2 = true;
      this.loadStatus = 1;
      const data = {
        typeId: this.chooseProductTypeId ? this.chooseProductTypeId : null,
        keyWord: null,
        phone: this.MemberInfo.phone || '',
        pageNum: this.pageNum2,
        isDeduct: 0,
        activityType: this.chooseProductTypeId == 2 ? this.actProductType : ''
      };
      getProductList(data).then((res) => {
        if (res.code == 0) {
          this.pages2 = res.data.pages;
          if (this.pageNum2 == 1 && this.chooseProductTypeId != 1) {
            this.productList = res.data.records;
            this.loading2 = false;
            this.pageNum2++;
            this.getProductData();
          } else if (this.pageNum2 < 3 && this.pageNum2 > 1) {
            if (res.data.pages >= res.data.current) {
              res.data.records.forEach((a) => {
                this.productList.push(a);
              });
              this.pageNum2++;
              this.getProductData();
            }
          } else if (this.pageNum2 >= 3) {
            if (res.data.pages >= res.data.current) {
              res.data.records.forEach((a) => {
                this.productList.push(a);
              });
              this.pageNum2++;
            }
          } else if (this.pageNum2 == 1 && this.chooseProductTypeId == 1) {
            this.productList = [];
            this.productList = res.data.records;
            this.loading2 = false;
          }
        } else {
          console.log(res.data);
        }
        setTimeout(() => {
          this.loadStatus = 2;
          this.loadS2 = false;
        }, 300);
      });
    },
    changeMeal(val) {
      if (this.loadS3 == true) {
        this.$message('数据努力加载中，请稍等...');
        return;
      }
      this.apackageType = val;
      this.pageNum3 = 1;
      this.mealList = [];
      this.loading3 = true;
      this.phoneSearch();
    },
    // 查询顾客
    phoneSearch() {
      const vm = this;
      vm.loadS3 = true;
      vm.loadStatus = 1;
      const status = this.Lib.CheckPhone(vm.form.phone);
      if (status == false && vm.form.phone) {
        vm.$message('请输入正确的手机号');
        return;
      }
      const data = {
        mainId: window.sessionStorage.mainId,
        pageNum: vm.pageNum3,
        pageSize: 15,
        type: 0,
        phone: vm.MemberInfo.phone || '',
        limitType: this.apackageType,
      };
      getBeautyPackageList(data).then((res) => {
        if (res.code == 0) {
          const list = res.data.records ? res.data.records : res.data;
          this.pages3 = res.data.pages;
          if (this.pageNum3 == 1) {
            this.mealList = res.data.records;
            this.loading3 = false;
            this.pageNum3++;
            this.phoneSearch();
          } else if (this.pageNum3 < 3 && this.pageNum3 > 1) {
            if (res.data.pages >= res.data.current) {
              list.forEach((a) => {
                this.mealList.push(a);
              });
              this.pageNum3++;
              this.phoneSearch();
            }
          } else if (this.pageNum3 >= 3) {
            if (res.data.pages >= res.data.current) {
              res.data.records.forEach((a) => {
                this.mealList.push(a);
              });
              this.pageNum3++;
            }
          }
        } else {
          console.log(res.data);
        }
        setTimeout(() => {
          vm.loadS3 = false;
          vm.loadStatus = 2;
        }, 300);
      });
    },
    // 添加项目/产品/套餐
    addListData(item, val, list) {
      console.log('22222222221qaaaaaaaaaaaaaa1', item, val, list);
      if (this.loadStatus == 1) {
        this.$message('数据努力加载中，请稍等...');
        return;
      }
      if (list && item.isDeduct == 0) {
        this.$message(`该${val == 1 ? '项目' : val == 2 ? '产品' : '套餐'}不可划扣`);
        return;
      }
      if (val == 4) {
        this.chooseName = '';
        return;
      }
      if (val == 3 && this.searchStatus == 1) {
        return;
      }
      this.chooseName = item.name;
      let newStatus = 0;
      if (list) {
        if (val == 1) {
          if (list.clientVipCardId || list.vipCardId) {
            if (list.countLimitType == 1) {
              let count = 0;
              this.form.tableData.forEach((a) => {
                if (a.qyCheckBox == list.clientVipCardId || a.qyCheckBox == list.giftId) {
                  if (a.listStatus == 1) {
                    if (a.dictItemId == item.dictItemId) {
                      count++;
                    }
                  }
                }
              });
              this.form.tableData.forEach((a) => {
                if ((a.qyCheckBox == list.clientVipCardId || a.qyCheckBox == list.giftId) && (item.remaining * 1 == count) && a.listStatus == val && val == 1 && a.dictItemId == item.dictItemId) {
                  newStatus = 2;
                } else if ((a.qyCheckBox == list.clientVipCardId || a.qyCheckBox == list.giftId) && (count > item.remaining * 1) && a.listStatus == val && val == 1 && a.dictItemId == item.dictItemId) {
                  newStatus = 2;
                }
              });
            } else if (list.countLimitType == 2) {
              this.form.tableData.forEach((a) => {
                if ((a.qyCheckBox == list.clientVipCardId || a.qyCheckBox == list.giftId) && a.listStatus == val && val == 2 && a.productId == item.productId) {
                  a.count++;
                  newStatus = 1;
                }
              });
            } else {
              let count = 0;
              this.form.tableData.forEach((a) => {
                if (a.qyCheckBox == list.clientVipCardId || a.qyCheckBox == list.giftId) {
                  if (a.listStatus == 1) {
                    count++;
                  }
                }
              });
              if (count >= list.remaining) {
                newStatus = 2;
              }
              if (list.remaining > count) {
                this.form.tableData.forEach((a) => {
                  if ((a.qyCheckBox == list.clientVipCardId || a.qyCheckBox == list.giftId) && a.listStatus == val && val == 2) {
                    list.canDeductProductDetailList.forEach((c) => {
                      if (a.productId == c.productId) {
                        a.count++;
                        newStatus = 1;
                      }
                    });
                  }
                });
              }
            }
          } else if (!list.vipCardId && list.giftId) {
            let totalNum = 0;
            this.form.tableData.forEach((a) => {
              if ((a.qyCheckBox == list.clientVipCardId || a.qyCheckBox == list.giftId) && a.listStatus == val && val == 1 && a.dictItemId == item.dictItemId) {
                totalNum += 1;
              }
            });
            if (totalNum * 1 >= list.remaining * 1) {
              newStatus = 2;
            }
          } else if (list.eitemId) {
            this.form.tableData.forEach((a) => {
              if ((a.qyCheckBox == list.eitemId) && a.listStatus == val && val == 1 && a.dictItemId == item.dictItemId) {
                newStatus = 2;
              }
            });
          }
        } else {
          this.form.tableData.forEach((v) => {
            if (v.listStatus == val && val == 2 && v.productId == item.productId) {
              newStatus = 1;
              let qyNum = 0;
              let remainNum = 0;
              v.qyCheckBox.forEach((i) => {
                if (i == (list.clientVipCardId || list.giftId || list.eitemId)) {
                  v.package.forEach((j) => {
                    if (i == (j.clientVipCardId || j.giftId || j.eitemId)) {
                      j.canDeductProductDetailList.forEach((k) => {
                        if (k.productId == v.productId) {
                          remainNum = k.remaining;
                        }
                      });
                      if (remainNum > j.qyCount) {
                        j.ischeck = true;
                        j.qyCount += 1;
                      } else {
                        newStatus = 2;
                      }
                    }
                  });
                } else {
                  qyNum++;
                }
              });
              if (newStatus == 1) {
                v.count++;
              }
              if (v.qyCheckBox.length == qyNum) {
                v.package.forEach((j) => {
                  if ((j.clientVipCardId == list.clientVipCardId) || (j.giftId == list.giftId) || (j.eitemId == list.eitemId)) {
                    j.ischeck = true;
                    j.qyCount = 1;
                    v.qyCheckBox.push(list.clientVipCardId || list.giftId || list.eitemId);
                    const qyArr = [];
                    v.qyCheckBox.map((a) => {
                      qyArr.push(a);
                    });
                    v.qyCheckBox = [...new Set(qyArr)];
                  }
                });
              }
            } else if (v.listStatus == val && val == 3 && v.vipCardId == item.id) {
              v.count++;
              newStatus = 1;
            }
          });
        }
      } else {
        this.form.tableData.forEach((v) => {
          if (v.listStatus == val && val == 2 && v.productId == item.productId) {
            v.count++;
            newStatus = 1;
            if (item.limitPurchase > 0) {
              const data = Number(item.limitPurchase * 1 - item.alreadyPurchase * 1);
              if (data <= v.count) {
                v.count = data;
                newStatus = 3;
              }
            }
          } else if (v.listStatus == val && val == 3 && v.vipCardId == item.id) {
            v.count++;
            newStatus = 1;
            if (item.limitPurchase > 0) {
              const data = Number(item.limitPurchase * 1 - item.alreadyPurchase * 1);
              if (data < v.count) {
                v.count = data;
                newStatus = 3;
              }
            }
          }
        });
      }
      if (newStatus == 3) {
        return this.$message(`${item.vipCardName}限购${item.limitPurchase}次，该客户已购买过${item.alreadyPurchase}次，已达上限`);
      }
      if (newStatus == 2) {
        this.$message('该项目/产品/套餐已达到上限');
        return;
      }
      if (newStatus == 1) {
        this.autoChooseRights();
        this.formChange();
        return;
      }
      const obj = {};
      obj.count = list ? 1 : item.count;
      obj.oldPrice = item.price;
      obj.editPrice = item.price;
      obj.price = item.price;
      obj.memberDiscount = item.memberDiscount;
      obj.memberPrice = item.memberPrice;
      obj.discountType = item.discountType;
      obj.listStatus = val;
      // 6.3
      obj.isWholesale = item.isWholesale;
      // 6.4
      obj.activityInfo = item.activityInfo;
      obj.hasActivity = item.hasActivity;
      // 6.5
      obj.wholesalePrice = item.wholesalePrice;
      // 6.81-限购
      obj.limitPurchase = item.limitPurchase;
      obj.alreadyPurchase = item.alreadyPurchase;
      if (val == 1) {
        obj.id = item.id;
        obj.eitemId = list ? list.eitemId : '';
        obj.itemId = item.itemId;
        obj.dictItemId = item.dictItemId;
        obj.itemImgUrl = item.itemImgUrl;
        obj.itemName = list ? item.name : item.itemName;
        obj.package = [];
        obj.typeName = item.typeName;
        obj.percentage4ServeList = [];
        obj.percentageSellServeList = [];
        obj.status = item.status;
        obj.isPercentage = item.isPercentage;
        obj.discountMoney = !this.MemberInfo.cardNo ? (item.isWholesale == 1 ? (item.wholesalePrice * 1).toFixed(2) : (item.hasActivity == 1 ? item.activityInfo.activityPrice * 1 : item.price * 1).toFixed(2)) : (item.isWholesale == 1 ? (item.wholesalePrice * 1).toFixed(2) : (item.hasActivity == 1 ? item.activityInfo.activityPrice * 1 : item.memberPrice * 1).toFixed(2));
        // 6.1
        obj.giftId = list ? list.giftId : '';
        obj.giftItemDeductList = [];
        // 6.2
        obj.vipCardId = list ? list.vipCardId : '';
        // 6.5
        obj.qyCheckBox = list ? (list.clientVipCardId || list.giftId || list.eitemId) : '';
        // 6.8
        obj.serviceTime = item.serviceTime;
      } else if (val == 2) {
        obj.eitemId = list ? list.eitemId : '';
        obj.imgUrl = item.imgUrl;
        obj.isPercentage = item.isPercentage;
        obj.productId = item.productId;
        obj.productCode = item.productCode;
        obj.package = [];
        obj.productName = list ? item.name : item.productName;
        obj.unitId = item.unitId;
        obj.typeName = item.typeName;
        obj.percentage4ProductList = [];
        obj.discountMoney = !this.MemberInfo.cardNo ? (item.isWholesale == 1 ? (item.wholesalePrice * 1).toFixed(2) : (item.hasActivity == 1 ? item.activityInfo.activityPrice * 1 : item.price * 1).toFixed(2)) : (item.isWholesale == 1 ? (item.wholesalePrice * 1).toFixed(2) : (item.hasActivity == 1 ? item.activityInfo.activityPrice * 1 : item.memberPrice * 1).toFixed(2));
        // 6.1
        obj.giftId = list ? list.giftId : '';
        obj.giftProductDeductList = [];
        // 6.2
        obj.vipCardId = list ? list.vipCardId : '';
        // 6.5
        obj.qyCheckBox = list ? [list.clientVipCardId || list.giftId || list.eitemId] : [];
      } else if (val == 3) {
        obj.id = '';
        obj.vipCardId = item.id;
        obj.package = [];
        obj.technicianId = '';
        obj.vipCardName = item.vipCardName;
        obj.isPercentage = item.isPercentage;
        obj.percentage4PackageList = [];
        obj.discountMoney = !this.MemberInfo.cardNo ? (item.isWholesale == 1 ? (item.wholesalePrice * 1).toFixed(2) : (item.hasActivity == 1 ? item.activityInfo.activityPrice * 1 : item.price * 1).toFixed(2)) : (item.isWholesale == 1 ? (item.wholesalePrice * 1).toFixed(2) : (item.hasActivity == 1 ? item.activityInfo.activityPrice * 1 : item.memberPrice * 1).toFixed(2));
      }
      if (obj.limitPurchase > 0) {
        const data = Number(obj.limitPurchase * 1 - obj.alreadyPurchase * 1);
        if (data < obj.count) {
          return this.$message(`${obj.vipCardName}限购${obj.limitPurchase}次，该客户已购买过${obj.alreadyPurchase}次，已达上限`);
        }
      }
      this.form.tableData.push(obj);
      this.autoChooseRights();
      this.formChange();
    },
    // 删除项目
    delListData(index, a, b) {
      if (a) {
        this.$message('预约订单中已支付定金，不可删除');
        return;
      } if (b === 1) {
        this.$message('预约订单中已使用划扣次数，不可删除');
        return;
      }
      this.form.tableData.splice(index, 1);
      this.formChange();
    },
    // 获取改价的值
    getEditPriceVal(obj, status) {
      let newObj = {};
      obj.detailList.forEach((a) => {
        if (a.type == 5) {
          newObj = a;
        }
      });
      if (newObj.isChangePrice == 1) {
        if (status == 1) {
          return newObj.rightsPrice;
        }
        return (newObj.rightsPrice / obj.price * 100).toFixed(2);
      }
      if (status == 1) {
        return obj.price;
      }
      return 100;
    },
    // 获取权益的数量
    getCount(obj, status, type) {
      if (status == 1) {
        return 1;
      }
      let num = 1;
      obj.detailList.forEach((a) => {
        if (a.type == type) {
          num = a.count * 1;
        }
      });
      return num;
    },
    // 修改订单自动匹配
    editMatching(obj, mtype, status) {
      console.log(obj);
      obj.qyList = [];
      if (status == 1) {
        obj.qyCheckBox = obj.qyCheckBox || '';
      } else {
        obj.qyCheckBox = obj.qyCheckBox || [];
      }
      if (obj.isWholesale == 1) {
        obj.qyList.push({
          isWholesale: 1,
          wholesalePrice: obj.wholesalePrice,
          originalPrice: obj.price,
          qyCount: this.getCount(obj, status, 1),
          info: `享受${this.getJxsdj()}权益价格`,
          price: obj.price,
          rightsPrice: obj.wholesalePrice,
          title: '使用经销商权益',
          type: 1,
          memberDiscount: obj.memberDiscount,
          memberPrice: obj.memberPrice,
          ischeck: status == 1 ? (obj.qyCheckBox == 1) : !!obj.qyCheckBox.find((a) => a == 1),
        });
      }
      if (obj.hasActivity == 1) {
        if (obj.activityInfo.activityType == 1) {
          obj.qyList.push({
            activityId: obj.activityInfo.activityId,
            activityType: obj.activityInfo.activityType,
            title: '特价促销活动',
            info: `特价促销价格${obj.activityInfo.activityPrice}元`,
            originalPrice: obj.price,
            promotionSaleCount: obj.activityInfo.promotionSaleCount,
            qyCount: this.getCount(obj, status, 2),
            price: obj.price,
            rightsPrice: obj.activityInfo.activityPrice,
            type: 2,
            memberDiscount: obj.memberDiscount,
            memberPrice: obj.memberPrice,
            ischeck: status == 1 ? (obj.qyCheckBox == 2) : !!obj.qyCheckBox.find((a) => a == 2),
          });
        } else if (obj.activityInfo.activityType == 2) {
          obj.qyList.push({
            activityId: obj.activityInfo.activityId,
            activityType: obj.activityInfo.activityType,
            title: '定时打折活动',
            info: `定时打${obj.activityInfo.discount}折`,
            originalPrice: obj.price,
            qyCount: this.getCount(obj, status, 3),
            price: obj.price,
            rightsPrice: obj.activityInfo.activityPrice,
            type: 3,
            memberDiscount: obj.memberDiscount,
            memberPrice: obj.memberPrice,
            ischeck: status == 1 ? (obj.qyCheckBox == 3) : !!obj.qyCheckBox.find((a) => a == 3),
          });
        }
      }
      if (mtype == 1) {
        obj.qyList.push({
          twoDiscountType: obj.discountType,
          twoPrice: obj.memberPrice,
          title: '会员折扣优惠',
          info: `享受${obj.discountType == 1 ? (`${obj.memberPrice}元`) : (`${obj.memberDiscount}折`)}优惠`,
          originalPrice: obj.price,
          qyCount: this.getCount(obj, status, 4),
          price: obj.price,
          rightsPrice: obj.memberPrice,
          type: 4,
          memberDiscount: obj.memberDiscount,
          memberPrice: obj.memberPrice,
          ischeck: status == 1 ? (obj.qyCheckBox == 4) : !!obj.qyCheckBox.find((a) => a == 4),
        });
      }
      if (this.editDiscountPriceStatus != 1) {
        obj.qyList.push({
          isChangePrice: 1,
          percentage: this.getEditPriceVal(obj, 2),
          title: '使用改价优惠',
          info: '',
          originalPrice: obj.price,
          qyCount: this.getCount(obj, status, 5),
          price: obj.price,
          rightsPrice: this.getEditPriceVal(obj, 1),
          type: 5,
          memberDiscount: obj.memberDiscount,
          memberPrice: obj.memberPrice,
          ischeck: status == 1 ? (obj.qyCheckBox == 5) : !!obj.qyCheckBox.find((a) => a == 5),
        });
      }
      obj.qyList.push({
        title: '不使用优惠权益',
        info: '选择后不享受任何优惠',
        originalPrice: obj.price,
        qyCount: this.getCount(obj, status, 99),
        price: obj.price,
        rightsPrice: obj.price,
        type: 99,
        memberDiscount: obj.memberDiscount,
        memberPrice: obj.memberPrice,
        ischeck: status == 1 ? (obj.qyCheckBox == 99) : !!obj.qyCheckBox.find((a) => a == 99),
      });
      return obj.qyList;
    },
    // 获取修改订单时的数据
    getOrderDetailsData() {
      this.loading4 = true;
      const data = {
        id: this.id
      };
      getOrderDetails4Update(data).then((res) => {
        // this.MemberInfo = res.data.memberMsg ? res.data.memberMsg : ""
        this.radioChange = 99;
        this.textareaVal = res.data.remark;
        this.form.name = res.data.memberName;
        this.form.phone = res.data.phone;
        res.data.cards.forEach((f) => {
          f.inputStatus = 1;
        });
        if (res.data.cards) this.handList = res.data.cards;
        if (res.data.orderCustomer) this.handCustomer = res.data.orderCustomer;
        this.memberSearch('99');
        this.form.tableData = [];
        this.bookStatus = (res.data.deductType == 1) ? 2 : res.data.bookAmount ? 1 : 3;
        if (res.data.serveItemsList) {
          res.data.serveItemsList.forEach((a) => {
            a.listStatus = 1;
            a.memberDiscount = a.memberDiscount;
            a.package = [];
            a.eitemId = a.orderItemDeduct ? a.orderItemDeduct.isElectronicTicketDeduct == 1 ? a.orderItemDeduct.clientItemId : '' : '';
            a.deductType = a.orderItemDeduct ? a.orderItemDeduct.deductType : 0;

            a.percentage4ServeList.forEach((b) => {
              b.percentage = b.item4ServeList[0].price;
              b.levelType = b.item4ServeList[0].setType;
              b.percentageId = b.item4ServeList[0].percentageId;
              b.percentageType = b.item4ServeList[0].percentageType;
            });
            a.percentageSellServeList.forEach((c) => {
              c.percentage = c.percentageNumber;
              c.levelType = c.setType;
              c.result = c.percentageNum;
              c.resultIsEdit = 1;
            });
            // 6.1
            a.giftId = a.giftId ? a.giftId : '';
            a.giftItemDeductList = a.giftItemDeductList ? a.giftItemDeductList : [];
            a.giftItemDeduct = a.giftItemDeduct ? a.giftItemDeduct : [];
            // 6.2
            a.vipCardId = a.giftItemDeduct ? a.giftItemDeduct.packageGiftId : '';
            // 6.5
            a.detailList.forEach((b) => {
              a.qyCheckBox = b.type;
              b.qyCount = b.count;
            });
            a.itemDeductList.forEach((b) => {
              a.qyCheckBox = b.clientVipCardId || b.giftId || b.eitemId;
            });
            a.qyList = this.editMatching(a, res.data.memberType, 1);
            this.form.tableData.push(a);
          });
        }
        if (res.data.productSalesList) {
          res.data.productSalesList.forEach((v) => {
            v.listStatus = 2;
            v.memberDiscount = v.memberDiscount;
            v.package = [];
            if (v.percentage4ProductList) {
              v.percentage4ProductList.forEach((c) => {
                c.percentage = c.percentageNumber;
                c.levelType = c.setType;
                c.result = c.percentageNum;
                c.resultIsEdit = 1;
              });
            }
            // 6.1
            v.giftId = v.giftId ? v.giftId : '';
            v.giftProductDeductList = v.giftProductDeductList ? v.giftProductDeductList : [];
            // 6.2
            v.vipCardId = v.productDeduct ? v.productDeduct.packageGiftId : '';
            // 6.3
            v.eitemId = v.productDeduct ? v.productDeduct.isElectronicTicketDeduct == 1 ? v.productDeduct.clientItemId : '' : '';
            // 6.5
            v.qyCheckBox = [];
            v.detailList.forEach((x) => {
              v.qyCheckBox.push(x.type);
              x.qyCount = x.count;
            });
            v.productDeductList.forEach((x) => {
              if (x.clientVipCardId) v.qyCheckBox.push(x.clientVipCardId);
              else if (x.giftId) v.qyCheckBox.push(x.giftId);
              else if (x.eitemId) v.qyCheckBox.push(x.eitemId);
            });
            v.qyList = this.editMatching(v, res.data.memberType, 2);
            this.form.tableData.push(v);
          });
        }
        if (res.data.vipCardList) {
          res.data.vipCardList.forEach((b) => {
            b.listStatus = 3;
            // b.alreadyPurchase = Number(b.alreadyPurchase * 1 - b.count * 1);
            b.alreadyPurchase = b.alreadyPurchase;
            b.limitPurchase = b.limitPurchase;
            b.memberDiscount = b.memberDiscount;
            b.percentage4PackageList ? '' : b.percentage4PackageList = [];
            b.percentage4PackageList.forEach((c) => {
              c.percentage = c.percentageNumber;
              c.levelType = c.setType;
              c.result = c.percentageNum;
              c.resultIsEdit = 1;
            });
            b.qyCheckBox = [];
            b.detailList.forEach((x) => {
              b.qyCheckBox.push(x.type);
              x.qyCount = x.count;
            });
            b.qyList = this.editMatching(b, res.data.memberType, 3);
            this.form.tableData.push(b);
          });
        }
        // 6.2
        if (res.data.giftItemList) {
          res.data.giftItemList.forEach((a) => {
            a.itemName = a.giftName;
            a.name = a.giftName;
          });
        }
        if (res.data.giftProductList) {
          res.data.giftProductList.forEach((a) => {
            a.name = a.giftName;
            a.productName = a.giftName;
          });
        }
        if (res.data.giftPackageList) {
          res.data.giftPackageList.forEach((a) => {
            a.id = a.vipCardId;
            a.vipCardName = a.giftName;
          });
        }
        this.giftSvList = res.data.giftItemList;
        this.giftPdList = res.data.giftProductList;
        this.giftPkList = res.data.giftPackageList;

        this.listTotal = res.data.itemsSumTotal * 1 + res.data.productsSumTotal * 1;
        this.formChange();
        // 5.3.0
        if (res.data.dto) {
          res.data.dto.is_edit = 1;
          this.check_in_data = res.data.dto;
          res.data.dto.checkInList.forEach((a) => {
            if (this.titleStatus == 1) {
              a.roomName = a.name;
            } else {
              a.bedNum = a.name;
            }
          });
          this.check_in_data.roomInfosList = res.data.dto.checkInList;
        } else {
          this.check_in_loading = false;
          this.check_in_data = {
            roomInfosList: [{
              roomName: '',
              peopleNumber: ''
            }]
          };
        }
        this.loading4 = false;
        this.$forceUpdate();
      });
    },
    // 获取修改信息
    getEditBespeakInfo(id) {
      const newData = { orderId: id };
      this.loading4 = true;
      getBilling4Book(newData).then((res) => {
        const { data } = res;
        this.form.phone = data.phone;
        this.textareaVal = data.remark;
        this.memberSearch('', data);
      });
    },
    // 构建预约的提成数据
    getNewBespeakData(data) {
      const dataTwo = {
        itemId: data.itemId,
        pageNo: 1,
        keyWord: '',
        pageSize: 999999,
        mainId: window.sessionStorage.mainId,
        isDeduct: data.deductType, // 5.6新加  是否是划扣（0：不是 1：是）
      };
      getTechnicianListByItemId(dataTwo).then((res) => {
        const arr = [];
        const obj = {};
        obj.count = 1;
        obj.oldPrice = data.price;
        obj.editPrice = data.price;
        obj.price = data.price;
        obj.listStatus = 1;
        obj.memberDiscount = data.memberDiscount;
        obj.memberPrice = data.memberPrice;
        obj.discountType = data.discountType;
        obj.discountMoney = (((data.bookAmount * 1) > (data.memberPrice * 1)) ? (data.bookAmount * 1) : (data.memberPrice * 1)).toFixed(2);
        obj.id = '';
        obj.isWholesale = data.isWholesale;
        obj.activityInfo = data.activityInfo;
        obj.hasActivity = data.hasActivity;
        obj.wholesalePrice = data.wholesalePrice;
        obj.giftItemDeductList = [];
        obj.itemId = data.itemId;
        obj.dictItemId = data.dictItemId;
        obj.itemName = data.itemName;
        obj.typeName = data.itemTypeName;
        obj.bookAmount = data.bookAmount;
        obj.deductType = data.deductType;
        obj.package = [];
        obj.isGift = 0;
        obj.qyCheckBox = data.clientVipCardId;
        if (data.technicianName) {
          obj.percentage4ServeList = [];
          res.data.lookItemPercentages.forEach((a) => {
            if (a.technicianId == data.technicianId) {
              a.percentage = this.MemberInfo.cardNo ? a.isMemberGuest : a.isVisitorGuest;
              a.percentageId = a.id;
              a.isGuest = 1;
              obj.percentage4ServeList.push(a);
            }
          });
        } else {
          obj.percentage4ServeList = [];
        }
        obj.percentageSellServeList = [];
        obj.status = 0;
        // 5.1版本新增内容
        obj.itemImgUrl = data.itemImgUrl;
        obj.isPercentage = data.isPercentage;
        obj.serviceTime = data.serviceTime;
        arr.push(obj);
        this.bookStatus = (data.deductType == 1) ? 2 : data.bookAmount ? 1 : 3;
        this.form.tableData = arr;
        this.loading4 = false;
        this.formChange();
      });
    },
    // 清空提交数据
    clearOrderData(val) {
      if (val == 1) {
        this.form.name = window.sessionStorage.userName;
        this.form.phone = window.sessionStorage.userPhone;
        this.form.bookOrderId = window.sessionStorage.bookOrderId;
      } else {
        this.form.name = '';
        this.form.phone = '';
      }
    },
    // 搜索项目开单员列表
    commonSearch(num, val) {
      this.Lib.keyboardBlur();
      if (val === '11') {
        this.newGetBrandList(1, 1);
      } else if (val === '22') {
        this.newGetBrandList(2, 2);
      } else if (val === '33') {
        this.newGetBrandList(2, 3);
      } else if (val === '44') {
        this.newGetBrandList(2, 4);
      }
      if (num === 1) {
        this.getStaffData();
      } else if (num === 2) {
        this.getSaleData();
      } else if (num === 3) {
        this.getProductStaffData();
      } else if (num === 4) {
        this.getStaffIdListData();
      }
    },
    // 获得项目开单员列表
    getStaffData() {
      const data = {
        itemId: this.chooseItemId,
        pageNo: 1,
        keyWord: this.searchMerchandiserVal,
        pageSize: 999999,
        mainId: window.sessionStorage.mainId,
        isDeduct: this.isDeduct, // 5.6新加
        cardId: this.brandInfo.cardOpen == 1 ? this.activeName : '', // 5.7新加  轮牌主键id
        type: 1, // 5.7新加 1：项目（选择统称） 2：项目（选择销售） 3：产品（选择销售） 4：套餐（选择销售）
      };
      this.loading = true;
      getStaffBrandList(data).then((res) => {
        if (res.code == 0) {
          let allSearchMerchandiserList = [];
          if (res.data == null) {
            this.searchMerchandiserList = [];
          } else {
            this.searchMerchandiserList = res.data.lookItemPercentages;
            allSearchMerchandiserList = res.data.lookAllItemPercentages;
          }
          const newList = [];
          if (this.chooseMerchandiserList.length > 0) {
            for (let i = 0; this.chooseMerchandiserList.length > i; i++) {
              for (let j = 0; this.searchMerchandiserList.length > j; j++) {
                if (this.chooseMerchandiserList[i].technicianId == this.searchMerchandiserList[j].technicianId) {
                  this.chooseSelection(this.searchMerchandiserList[j], 1, true);
                }
              }
            }
          }
          if (this.chooseMerchandiserList.length > 0) {
            for (let i = 0; this.chooseMerchandiserList.length > i; i++) {
              for (let j = 0; allSearchMerchandiserList.length > j; j++) {
                if (this.chooseMerchandiserList[i].technicianId == allSearchMerchandiserList[j].technicianId) {
                  const item = this.chooseMerchandiserList[i];
                  const sitem = allSearchMerchandiserList[j];
                  const obj = {};
                  obj.isGuest = item.isGuest;
                  obj.endNum = sitem.endNum;
                  obj.percentage = item.percentage;
                  obj.number = sitem.number;
                  obj.levelType = sitem.levelType;
                  obj.technicianId = sitem.technicianId;
                  obj.percentageId = sitem.id;
                  obj.technicianName = sitem.technicianName;
                  obj.isMemberGuest = sitem.isMemberGuest;
                  obj.isMemberNotGuest = sitem.isMemberNotGuest;
                  obj.isVisitorGuest = sitem.isVisitorGuest;
                  obj.isVisitorNotGuest = sitem.isVisitorNotGuest;
                  obj.percentageType = sitem.percentageType;
                  newList.push(obj);
                }
              }
            }
            this.chooseMerchandiserList = newList;
            this.changeCheckboxList();
          }
        }
        this.loading = false;
      });
    },
    // 项目销售开单员列表
    getSaleData() {
      const data = {
        itemId: this.chooseItemId,
        pageNo: 1,
        keyWord: this.searchSaleVal,
        pageSize: 999999,
        mainId: window.sessionStorage.mainId,
        cardId: this.brandInfo.cardOpen == 1 ? this.activeName : '', // 5.7新加  轮牌主键id
        type: 2, // 5.7新加 1：项目（选择统称） 2：项目（选择销售） 3：产品（选择销售） 4：套餐（选择销售）
      };
      this.loading = true;
      getStaffBrandList(data).then((res) => {
        if (res.code == 0) {
          this.searchSaleList = res.data;
          if (this.chooseSaleList.length > 0) {
            this.chooseSaleList.forEach((a) => {
              this.searchSaleList.lookTechnicians.forEach((b) => {
                if (a.technicianId == b.technicianId) {
                  a.isExit = b.isExit;
                  // percentageType = 1是固定提成 2是比例提成
                  a.percentageType = this.searchSaleList.percentageType;
                  a.name = b.name;
                  a.guest = this.searchSaleList.guest;
                  a.noGuest = this.searchSaleList.noGuest;
                  a.number = b.number;
                  a.levelType = b.levelType;
                  a.noVipGuest = this.searchSaleList.noVipGuest;
                  a.vipGuest = this.searchSaleList.vipGuest;
                  a.result = this.resultType == 1 ? 100 : (100 / (this.chooseSaleList.length + 1)).toFixed(0);
                  a.resultIsEdit = 0;
                  // 如果是会员
                  if (this.MemberInfo.cardNo) {
                    a.percentage = this.searchSaleList.vipGuest;
                  } else {
                    a.percentage = this.searchSaleList.guest;
                  }
                  a.technicianName = b.technicianName;
                  a.isBatchAdd = 0;
                  this.chooseSelection(b, 12, true);
                }
              });
            });
            this.getSalePrice();
          }
        } else {
          this.searchSaleList = [];
          this.getSalePrice();
        }
        this.loading = false;
      });
    },
    // 选择项目提成员工--弹出窗口  scaleStan（0按原价计算，1按折后价计算）  resultType（1整单业绩，2自动平分）
    chooseStaff(index, obj) {
      // 5.6添加的-选择统称需要传isDelete(选择划扣传-1,无传-0)
      if (obj.qyCheckBox * 1 > 100) {
        this.isDeduct = 1;
      } else {
        this.isDeduct = 0;
      }
      this.searchMerchandiserVal = '';
      getPercentageSkin({ mainId: window.sessionStorage.mainId }).then((res) => {
        this.scaleStan = res.data.scaleStan;
        this.resultType = res.data.resultType;
      });
      this.chooseFormIndex = index;
      this.MerchandiserDialog = true;
      this.dialogServiceName = this.form.tableData[index].itemName;
      this.dialogServiceTotal = (this.form.tableData[index].discountMoney * this.form.tableData[index].count).toFixed(2);
      this.dialogServicePreTotal = (this.form.tableData[index].price * this.form.tableData[index].count).toFixed(2);
      this.chooseItemId = this.form.tableData[index].itemId;

      const files = this.form.tableData[index].percentage4ServeList;
      const arr = [];
      if (files.length > 0) {
        for (let i = 0, len = files.length; i < len; i++) {
          const item = files[i];
          arr.push(item);
        }
      }
      this.chooseMerchandiserList = arr;
      this.changeCheckboxList();
      if (this.Lib.checkPower('beauty-1-lp', 2)) {
        this.newGetBrandList(1, 1);
      } else {
        this.getStaffData();
      }
    },
    // 选择项目销售员工--弹出窗口  scaleStan（0按原价计算，1按折后价计算）  resultType（1整单业绩，2自动平分）
    chooseSale(index) {
      this.searchMerchandiserVal = '';
      getPercentageSkin({ mainId: window.sessionStorage.mainId }).then((res) => {
        this.scaleStan = res.data.scaleStan;
        this.resultType = res.data.resultType;
      });
      this.chooseFormIndex = index;
      this.saleDialog = true;
      this.dialogServiceName = this.form.tableData[index].itemName;
      this.dialogServiceTotal = (this.form.tableData[index].discountMoney * this.form.tableData[index].count).toFixed(2);
      this.dialogServicePreTotal = (this.form.tableData[index].price * this.form.tableData[index].count).toFixed(2);
      this.chooseItemId = this.form.tableData[index].itemId;

      const files = this.form.tableData[index].percentageSellServeList;
      const arr = [];
      if (files.length > 0) {
        for (let i = 0, len = files.length; i < len; i++) {
          const item = files[i];
          arr.push(item);
        }
      }
      this.chooseSaleList = arr;
      this.getSalePrice();
      if (this.Lib.checkPower('beauty-1-lp', 2)) {
        this.newGetBrandList(2, 2);
      } else {
        this.getSaleData();
      }
    },
    newGetBrandList(val, num) {
      const data = {
        mainId: window.sessionStorage.mainId,
        cardType: val,
        itemId: num == 1 ? this.chooseItemId : '',
        keyWord: num == 1 ? this.searchMerchandiserVal : num == 2 ? this.searchSaleVal : num == 3 ? this.searchPMVal : this.searchPackageVal
      };
      erpTechnicianCardByMainId(data).then((res) => {
        if (res.code == 0) {
          this.brandInfo = res.data;
          this.activeName = res.data.cards.length > 0 ? (`${res.data.cards[0].id}`) : '';
          if (num == 1) {
            this.getStaffData();
          } else if (num == 2) {
            this.getSaleData();
          } else if (num == 3) {
            this.getProductStaffData();
          } else if (num == 4) {
            this.getStaffIdListData();
          }
        } else {
          console.log(res);
        }
      });
    },
    // 计算提成总价
    changeCheckboxList(index, row) {
      const vm = this;
      let percentagePrice = 0;
      if (vm.chooseMerchandiserList) {
        if (row) {
          vm.chooseMerchandiserList[index].percentage = (vm.MemberInfo.cardNo && vm.chooseMerchandiserList[index].isGuest == 0) ? row.isMemberNotGuest : (vm.MemberInfo.cardNo && vm.chooseMerchandiserList[index].isGuest == 1) ? row.isMemberGuest : (!vm.MemberInfo.cardNo && vm.chooseMerchandiserList[index].isGuest == 0) ? row.isVisitorNotGuest : row.isVisitorGuest;
        }
        if (vm.chooseMerchandiserList.length > 0) {
          vm.chooseMerchandiserList.forEach((v) => {
            const newVal = v.percentageType == 1 ? (v.percentage * vm.form.tableData[vm.chooseFormIndex].count).toFixed(2) : vm.scaleStan == 1 ? (v.percentage * vm.dialogServiceTotal * 0.01) : (v.percentage * vm.dialogServicePreTotal * 0.01);
            percentagePrice += newVal * 1;
          });
          vm.percentageTotal = (percentagePrice * 1).toFixed(2);
        } else {
          vm.percentageTotal = 0;
        }
      } else {
        vm.percentageTotal = 0;
      }
    },
    // 计算提成总价--项目--选择销售
    getSalePrice(index, row) {
      const vm = this;
      let percentagePrice = 0;
      vm.chooseSaleList.forEach((a) => {
        if (a.resultIsEdit == 0) {
          a.result = this.resultType == 1 ? 100 : (100 / (vm.chooseSaleList.length * 1)).toFixed(0);
        }
      });
      if (vm.chooseSaleList) {
        if (row) {
          vm.chooseSaleList[index].percentage = (vm.MemberInfo.cardNo && vm.chooseSaleList[index].isGuest == 0) ? row.isMemberNotGuest : (vm.MemberInfo.cardNo && vm.chooseSaleList[index].isGuest == 1) ? row.isMemberGuest : (!vm.MemberInfo.cardNo && vm.chooseSaleList[index].isGuest == 0) ? row.isVisitorNotGuest : row.isVisitorGuest;
        }
        if (vm.chooseSaleList.length > 0) {
          vm.chooseSaleList.forEach((v) => {
            const newVal = v.percentageType == 1 ? (v.percentage * vm.form.tableData[vm.chooseFormIndex].count).toFixed(2) : vm.scaleStan == 1 ? (v.percentage * vm.dialogServiceTotal * 0.01) : (v.percentage * vm.dialogServicePreTotal * 0.01);
            percentagePrice += newVal * 1;
          });
          vm.percentageTotalSale = (percentagePrice * 1).toFixed(2);
        } else {
          vm.percentageTotalSale = 0;
        }
      } else {
        vm.percentageTotalSale = 0;
      }
    },
    // 选择开单员--勾选事件
    selectMerchandiser(selection, row) {
      const vm = this;
      const obj = {};
      obj.endNum = row.endNum;
      obj.number = row.number;
      obj.levelType = row.levelType;
      obj.technicianId = row.technicianId;
      obj.percentageId = row.id;
      obj.technicianName = row.technicianName;
      obj.isGuest = 0;
      obj.percentage = this.MemberInfo.cardNo ? row.isMemberNotGuest : row.isVisitorNotGuest;
      obj.startNum = row.startNum;
      obj.endNum = row.endNum;
      obj.isDelete = row.isDelete;
      obj.isMemberGuest = row.isMemberGuest;
      obj.isMemberNotGuest = row.isMemberNotGuest;
      obj.isVisitorGuest = row.isVisitorGuest;
      obj.isVisitorNotGuest = row.isVisitorNotGuest;
      obj.percentageType = row.percentageType;
      let chooseNum = 0;
      let index;
      for (let j = 0; vm.chooseMerchandiserList.length > j; j++) {
        if (vm.chooseMerchandiserList[j].technicianId == obj.technicianId) {
          index = j;
        } else {
          chooseNum++;
        }
      }
      if (chooseNum == vm.chooseMerchandiserList.length) {
        vm.chooseMerchandiserList.push(obj);
        vm.chooseSelection(obj, 1, true);
      } else {
        vm.chooseMerchandiserList.splice(index, 1);
        vm.chooseSelection(obj, 1, false);
      }
      setTimeout(() => {
        vm.changeCheckboxList();
      }, 100);
    },
    // 选择销售员工--勾选事件
    selectSale(selection, row) {
      const vm = this;
      const obj = {};
      obj.isExit = row.isExit;
      obj.isGuest = 0;
      // percentageType = 1是固定提成 2是比例提成
      obj.percentageType = this.searchSaleList.percentageType;
      obj.technicianId = row.technicianId;
      obj.name = row.name;
      obj.technicianName = row.technicianName;
      obj.guest = this.searchSaleList.guest;
      obj.noGuest = this.searchSaleList.noGuest;
      obj.number = row.number;
      obj.levelType = row.levelType;
      obj.noVipGuest = this.searchSaleList.noVipGuest;
      obj.vipGuest = this.searchSaleList.vipGuest;
      obj.result = this.resultType == 1 ? 100 : (100 / (this.chooseSaleList.length + 1)).toFixed(0);
      obj.resultIsEdit = 0;
      // 如果是会员
      if (this.MemberInfo.cardNo) {
        obj.percentage = this.searchSaleList.vipGuest;
      } else {
        obj.percentage = this.searchSaleList.guest;
      }
      let chooseNum = 0;
      let index;
      for (let j = 0; vm.chooseSaleList.length > j; j++) {
        if (vm.chooseSaleList[j].technicianId == obj.technicianId) {
          index = j;
        } else {
          chooseNum++;
        }
      }
      if (chooseNum == vm.chooseSaleList.length) {
        vm.chooseSaleList.push(obj);
        vm.chooseSelection(obj, 12, true);
      } else {
        vm.chooseSaleList.splice(index, 1);
        vm.chooseSelection(obj, 12, false);
      }
      setTimeout(() => {
        vm.getSalePrice();
      }, 100);
    },
    // 选择开单员--勾选事件
    rowClickMerchandiser(row) {
      if (row.state == 4 || row.state == 5 || row.state == 6) return;
      const vm = this;
      const obj = {};
      obj.endNum = row.endNum;
      obj.number = row.number;
      obj.levelType = row.levelType;
      obj.technicianId = row.technicianId;
      obj.percentageId = row.id;
      obj.name = row.name;
      obj.technicianName = row.technicianName;
      obj.isGuest = 0;
      obj.percentage = this.MemberInfo.cardNo ? row.isMemberNotGuest : row.isVisitorNotGuest;
      obj.startNum = row.startNum;
      obj.endNum = row.endNum;
      obj.isDelete = row.isDelete;
      obj.isMemberGuest = row.isMemberGuest;
      obj.isMemberNotGuest = row.isMemberNotGuest;
      obj.isVisitorGuest = row.isVisitorGuest;
      obj.isVisitorNotGuest = row.isVisitorNotGuest;
      obj.percentageType = row.percentageType;
      vm.$refs.searchMerchandiserTable.toggleRowSelection(row);
      let chooseNum = 0;
      let index;
      for (let j = 0; vm.chooseMerchandiserList.length > j; j++) {
        if (vm.chooseMerchandiserList[j].technicianId == obj.technicianId) {
          index = j;
        } else {
          chooseNum++;
        }
      }
      if (chooseNum == vm.chooseMerchandiserList.length) {
        vm.chooseMerchandiserList.push(obj);
        setTimeout(() => {
          vm.changeCheckboxList();
        }, 100);
      } else {
        vm.chooseMerchandiserList.splice(index, 1);
        setTimeout(() => {
          vm.changeCheckboxList();
        }, 100);
      }
    },
    // 选择销售员工--勾选事件
    rowClickSale(row) {
      if (row.state == 4 || row.state == 5 || row.state == 6) return;
      const vm = this;
      const obj = {};
      obj.isExit = row.isExit;
      obj.isGuest = 0;
      // percentageType = 1是固定提成 2是比例提成
      obj.percentageType = this.searchSaleList.percentageType;
      obj.technicianId = row.technicianId;
      obj.name = row.name;
      obj.guest = this.searchSaleList.guest;
      obj.noGuest = this.searchSaleList.noGuest;
      obj.number = row.number;
      obj.levelType = row.levelType;
      obj.noVipGuest = this.searchSaleList.noVipGuest;
      obj.vipGuest = this.searchSaleList.vipGuest;
      obj.result = this.resultType == 1 ? 100 : (100 / (this.chooseSaleList.length + 1)).toFixed(0);
      obj.resultIsEdit = 0;
      // 如果是会员
      if (this.MemberInfo.cardNo) {
        obj.percentage = this.searchSaleList.vipGuest;
      } else {
        obj.percentage = this.searchSaleList.guest;
      }
      obj.technicianName = row.technicianName;
      vm.$refs.searchSaleTable.toggleRowSelection(row);
      let chooseNum = 0;
      let index;
      for (let j = 0; vm.chooseSaleList.length > j; j++) {
        if (vm.chooseSaleList[j].technicianId == obj.technicianId) {
          index = j;
        } else {
          chooseNum++;
        }
      }
      if (chooseNum == vm.chooseSaleList.length) {
        vm.chooseSaleList.push(obj);
        setTimeout(() => {
          vm.getSalePrice();
        }, 100);
      } else {
        vm.chooseSaleList.splice(index, 1);
        setTimeout(() => {
          vm.getSalePrice();
        }, 100);
      }
    },
    // 确定添加提成员工
    comfirmAddProject() {
      const files = this.chooseMerchandiserList;
      const arr = [];
      if (this.chooseMerchandiserList.length > 0) {
        for (let i = 0, len = files.length; i < len; i++) {
          const item = files[i];
          item.percentage = item.percentage == '' ? 0 : item.percentage;
          arr.push(item);
        }
      }
      this.form.tableData[this.chooseFormIndex].percentage4ServeList = arr;
      this.MerchandiserDialog = false;
    },
    // 确定添加销售员工
    comfirmAddSale() {
      const files = this.chooseSaleList;
      const arr = [];
      if (this.chooseSaleList.length > 0) {
        for (let i = 0, len = files.length; i < len; i++) {
          const item = files[i];
          item.result = item.result == '' ? 0 : item.result;
          item.percentage = item.percentage == '' ? 0 : item.percentage;
          arr.push(item);
        }
      }
      this.form.tableData[this.chooseFormIndex].percentageSellServeList = arr;
      this.saleDialog = false;
    },
    // 删除选择的提成统称
    delChooseTechnician(id) {
      const vm = this;
      for (let i = 0; vm.searchMerchandiserList.length > i; i++) {
        if (vm.searchMerchandiserList[i].technicianId == id) {
          vm.chooseSelection(vm.searchMerchandiserList[i], 1, false);
        }
      }
      for (let j = 0; vm.chooseMerchandiserList.length > j; j++) {
        if (vm.chooseMerchandiserList[j].technicianId == id) {
          vm.chooseMerchandiserList.splice(j, 1);
          setTimeout(() => {
            vm.changeCheckboxList();
          }, 100);
        }
      }
    },
    // 删除选择的销售--项目
    delChooseSale(id) {
      const vm = this;
      for (let i = 0; vm.searchSaleList.lookTechnicians.length > i; i++) {
        if (vm.searchSaleList.lookTechnicians[i].technicianId == id) {
          vm.chooseSelection(vm.searchSaleList.lookTechnicians[i], 12, false);
        }
      }
      for (let j = 0; vm.chooseSaleList.length > j; j++) {
        if (vm.chooseSaleList[j].technicianId == id) {
          vm.chooseSaleList.splice(j, 1);
          setTimeout(() => {
            vm.getSalePrice();
          }, 100);
        }
      }
    },
    // 回选多选选择框
    chooseSelection(row, val, status) {
      const vm = this;
      setTimeout(() => {
        if (val == 1) {
          vm.$refs.searchMerchandiserTable.toggleRowSelection(row, status);
        } else if (val == 12) {
          vm.$refs.searchSaleTable.toggleRowSelection(row, status);
        } else if (val == 2) {
          vm.$refs.productTCTable.toggleRowSelection(row, status);
        } else if (val == 3) {
          vm.$refs.packageTCTable.toggleRowSelection(row, status);
        } else {
          vm.$refs.batchTable.toggleRowSelection(row, status);
        }
      }, 100);
    },
    // 产品销售开单员列表
    getProductStaffData() {
      const data = {
        itemId: this.choosePMId,
        pageNo: 1,
        keyWord: this.searchPMVal,
        pageSize: 999999,
        mainId: window.sessionStorage.mainId,
        cardId: this.brandInfo.cardOpen == 1 ? this.activeName : '', // 5.7新加  轮牌主键id
        type: 3, // 5.7新加 1：项目（选择统称） 2：项目（选择销售） 3：产品（选择销售） 4：套餐（选择销售）
      };
      this.loading = true;
      getStaffBrandList(data).then((res) => {
        this.searchPMList = res.data;
        if (this.choosePMList.length > 0) {
          this.choosePMList.forEach((a) => {
            this.searchPMList.lookTechnicians.forEach((b) => {
              if (a.technicianId == b.technicianId) {
                a.isExit = b.isExit;
                // percentageType = 1是固定提成 2是比例提成
                a.percentageType = this.searchSaleList.percentageType;
                a.name = b.name;
                a.guest = this.searchSaleList.guest;
                a.noGuest = this.searchSaleList.noGuest;
                a.number = b.number;
                a.levelType = b.levelType;
                a.noVipGuest = this.searchSaleList.noVipGuest;
                a.vipGuest = this.searchSaleList.vipGuest;
                a.result = this.resultType == 1 ? 100 : (100 / (this.chooseSaleList.length + 1)).toFixed(0);
                a.resultIsEdit = 0;
                // 如果是会员
                if (this.MemberInfo.cardNo) {
                  a.percentage = this.searchSaleList.vipGuest;
                } else {
                  a.percentage = this.searchSaleList.guest;
                }
                a.technicianName = b.technicianName;
                a.isBatchAdd = 0;
                this.chooseSelection(b, 2, true);
              }
            });
          });
          this.getProductTCPrice();
        }
        this.loading = false;
      });
    },
    // 选择销售员工--勾选事件
    selectChoosePMEvent(selection, row) {
      const vm = this;
      const obj = {};
      obj.isExit = row.isExit;
      obj.isGuest = 0;
      // percentageType = 1是固定提成 2是比例提成
      obj.percentageType = this.searchPMList.percentageType;
      obj.technicianId = row.technicianId;
      obj.name = row.name;
      obj.technicianName = row.technicianName;
      obj.guest = this.searchPMList.guest;
      obj.noGuest = this.searchPMList.noGuest;
      obj.number = row.number;
      obj.levelType = row.levelType;
      obj.noVipGuest = this.searchPMList.noVipGuest;
      obj.vipGuest = this.searchPMList.vipGuest;
      obj.result = this.resultType == 1 ? 100 : (100 / (this.choosePMList.length + 1)).toFixed(0);
      obj.resultIsEdit = 0;
      // 如果是会员
      if (this.MemberInfo.cardNo) {
        obj.percentage = this.searchPMList.vipGuest;
      } else {
        obj.percentage = this.searchPMList.guest;
      }
      let chooseNum = 0;
      let index;
      for (let j = 0; vm.choosePMList.length > j; j++) {
        if (vm.choosePMList[j].technicianId == obj.technicianId) {
          index = j;
        } else {
          chooseNum++;
        }
      }
      if (chooseNum == vm.choosePMList.length) {
        vm.choosePMList.push(obj);
        vm.chooseSelection(obj, 2, true);
      } else {
        vm.choosePMList.splice(index, 1);
        vm.chooseSelection(obj, 2, false);
      }
      setTimeout(() => {
        vm.getProductTCPrice();
      }, 100);
    },
    // 选择销售员工--勾选事件
    choosePMEvent(row) {
      if (row.state == 4 || row.state == 5 || row.state == 6) return;
      const vm = this;
      const obj = {};
      obj.isExit = row.isExit;
      obj.isGuest = 0;
      // percentageType = 1是固定提成 2是比例提成
      obj.percentageType = this.searchPMList.percentageType;
      obj.technicianId = row.technicianId;
      obj.name = row.name;
      obj.guest = this.searchPMList.guest;
      obj.noGuest = this.searchPMList.noGuest;
      obj.number = row.number;
      obj.levelType = row.levelType;
      obj.noVipGuest = this.searchPMList.noVipGuest;
      obj.vipGuest = this.searchPMList.vipGuest;
      obj.result = this.resultType == 1 ? 100 : (100 / (this.choosePMList.length + 1)).toFixed(0);
      obj.resultIsEdit = 0;
      // 如果是会员
      if (this.MemberInfo.cardNo) {
        obj.percentage = this.searchPMList.vipGuest;
      } else {
        obj.percentage = this.searchPMList.guest;
      }
      obj.technicianName = row.technicianName;
      vm.$refs.productTCTable.toggleRowSelection(row);
      let chooseNum = 0;
      let index;
      for (let j = 0; vm.choosePMList.length > j; j++) {
        if (vm.choosePMList[j].technicianId == obj.technicianId) {
          index = j;
        } else {
          chooseNum++;
        }
      }
      if (chooseNum == vm.choosePMList.length) {
        vm.choosePMList.push(obj);
        setTimeout(() => {
          vm.getProductTCPrice();
        }, 100);
      } else {
        vm.choosePMList.splice(index, 1);
        setTimeout(() => {
          vm.getProductTCPrice();
        }, 100);
      }
    },
    // 修改业绩占比
    resultChange(index, num) {
      if (num == 1) {
        this.chooseSaleList[index].resultIsEdit = 1;
        if (this.chooseSaleList[index].result * 1 > 100) {
          this.chooseSaleList[index].result = 100;
        } else if (!this.chooseSaleList[index].result) {
          this.chooseSaleList[index].result = 0;
        }
        this.getSalePrice();
      } else if (num == 11) {
        if (!this.chooseSaleList[index].percentage) {
          this.chooseSaleList[index].percentage = 0;
        } else if (this.chooseSaleList[index].percentage * 1 > 999999) {
          this.chooseSaleList[index].percentage = 999999;
        }
        this.getSalePrice();
      } else if (num == 2) {
        this.choosePMList[index].resultIsEdit = 1;
        if (this.choosePMList[index].result * 1 > 100) {
          this.choosePMList[index].result = 100;
        } else if (!this.choosePMList[index].result) {
          this.choosePMList[index].result = 0;
        }
        this.getProductTCPrice();
      } else if (num == 22) {
        if (!this.choosePMList[index].percentage) {
          this.choosePMList[index].percentage = 0;
        } else if (this.choosePMList[index].percentage * 1 > 999999) {
          this.choosePMList[index].percentage = 999999;
        }
        this.getProductTCPrice();
      } else if (num == 3) {
        this.choosePackageList[index].resultIsEdit = 1;
        if (this.choosePackageList[index].result * 1 > 100) {
          this.choosePackageList[index].result = 100;
        } else if (!this.choosePackageList[index].result) {
          this.choosePackageList[index].result = 0;
        }
        this.getPackageTCPrice();
      } else {
        if (!this.choosePackageList[index].percentage) {
          this.choosePackageList[index].percentage = 0;
        } else if (this.choosePackageList[index].percentage * 1 > 999999) {
          this.choosePackageList[index].percentage = 999999;
        }
        this.getPackageTCPrice();
      }
    },
    // 计算提成总价
    getProductTCPrice() {
      const vm = this;
      let percentagePrice = 0;
      vm.choosePMList.forEach((a) => {
        if (a.resultIsEdit == 0) {
          a.result = this.resultType == 1 ? 100 : (100 / (vm.choosePMList.length * 1)).toFixed(0);
        }
      });
      if (vm.choosePMList) {
        if (vm.choosePMList.length > 0) {
          vm.choosePMList.forEach((v) => {
            const newVal = v.percentageType == 1 ? (v.percentage * v.result * vm.form.tableData[vm.choosePMIndex].count * 0.01).toFixed(2) : vm.scaleStan == 1 ? (v.percentage * v.result * vm.dialogTotal * 0.0001) : (v.percentage * v.result * vm.dialogPreTotal * 0.0001);
            percentagePrice += newVal * 1;
          });
          vm.productPercentageTotal = (percentagePrice * 1).toFixed(2);
        } else {
          vm.productPercentageTotal = 0;
        }
      } else {
        vm.productPercentageTotal = 0;
      }
    },
    choosePMEventCheckBox(val) {
      // 如果是会员
      if (this.MemberInfo.cardNo) {
        if (val === 0) {
          this.choosePMList[0].percentage = this.searchPMList.vipGuest;
        } else {
          this.choosePMList[0].percentage = this.searchPMList.noVipGuest;
        }
      } else if (val === 0) {
        this.choosePMList[0].percentage = this.searchPMList.guest;
      } else {
        this.choosePMList[0].percentage = this.searchPMList.noGuest;
      }
    },
    // 确定添加提成统称
    comfirmAddPM() {
      const files = this.choosePMList;
      const arr = [];
      if (this.choosePMList.length > 0) {
        for (let i = 0, len = files.length; i < len; i++) {
          const item = files[i];
          item.result = item.result == '' ? 0 : item.result;
          item.percentage = item.percentage == '' ? 0 : item.percentage;
          arr.push(item);
        }
      }
      this.form.tableData[this.choosePMIndex].percentage4ProductList = arr;
      this.productMDialog = false;
    },
    // 选择产品销售提成员工--弹出窗口
    chooseProductStaff(index, id) {
      this.searchPMVal = '';
      getPercentageSkin({ mainId: window.sessionStorage.mainId }).then((res) => {
        this.scaleStan = res.data.scaleStan;
        this.resultType = res.data.resultType;
      });
      this.productMDialog = true;
      this.choosePMIndex = index;
      this.choosePMId = id;
      this.dialogProductName = this.form.tableData[index].productName;
      this.dialogTotal = (Number(this.form.tableData[index].discountMoney) * this.form.tableData[index].count).toFixed(2);
      this.dialogPreTotal = (Number(this.form.tableData[index].price) * this.form.tableData[index].count).toFixed(2);
      const files = this.form.tableData[index].percentage4ProductList;
      const arr = [];
      if (files.length > 0) {
        for (let i = 0, len = files.length; i < len; i++) {
          const item = files[i];
          arr.push(item);
        }
      }
      this.choosePMList = arr;
      this.getProductTCPrice();
      if (this.Lib.checkPower('beauty-1-lp', 2)) {
        this.newGetBrandList(2, 3);
      } else {
        this.getProductStaffData();
      }
    },
    // 选择开单员
    choosePackage(index, id) {
      this.searchPackageVal = '';
      getPercentageSkin({ mainId: window.sessionStorage.mainId }).then((res) => {
        this.scaleStan = res.data.scaleStan;
        this.resultType = res.data.resultType;
      });
      this.pageNum = 1;
      this.packageDialog = true;
      this.packageIndex = index;
      this.searchChoosePackageId = id;
      this.pageNum = 1;
      this.dialogPackageName = this.form.tableData[index].vipCardName;
      this.dialogPackageTotal = (Number(this.form.tableData[index].discountMoney) * this.form.tableData[index].count).toFixed(2);
      this.dialogPackagePreTotal = (Number(this.form.tableData[index].price) * this.form.tableData[index].count).toFixed(2);
      const files = this.form.tableData[index].percentage4PackageList;
      const arr = [];
      if (files.length > 0) {
        for (let i = 0, len = files.length; i < len; i++) {
          const item = files[i];
          arr.push(item);
        }
      }
      this.choosePackageList = arr;
      this.getPackageTCPrice();
      if (this.Lib.checkPower('beauty-1-lp', 2)) {
        this.newGetBrandList(2, 4);
      } else {
        this.getStaffIdListData();
      }
    },
    // 获取开单员列表数据
    getStaffIdListData() {
      const data = {
        itemId: this.searchChoosePackageId,
        pageNo: this.pageNum,
        keyWord: this.searchPackageVal,
        pageSize: 999999,
        mainId: window.sessionStorage.mainId,
        cardId: this.brandInfo.cardOpen == 1 ? this.activeName : '', // 5.7新加  轮牌主键id
        type: 4, // 5.7新加 1：项目（选择统称） 2：项目（选择销售） 3：产品（选择销售） 4：套餐（选择销售）
      };
      this.loading = true;
      getStaffBrandList(data).then((res) => {
        this.searchPackageList = res.data;
        if (this.choosePackageList.length > 0) {
          this.choosePackageList.forEach((a) => {
            this.searchPackageList.lookTechnicians.forEach((b) => {
              if (a.technicianId == b.technicianId) {
                a.isExit = b.isExit;
                // percentageType = 1是固定提成 2是比例提成
                a.percentageType = this.searchSaleList.percentageType;
                a.name = b.name;
                a.guest = this.searchSaleList.guest;
                a.noGuest = this.searchSaleList.noGuest;
                a.number = b.number;
                a.levelType = b.levelType;
                a.noVipGuest = this.searchSaleList.noVipGuest;
                a.vipGuest = this.searchSaleList.vipGuest;
                a.result = this.resultType == 1 ? 100 : (100 / (this.chooseSaleList.length + 1)).toFixed(0);
                a.resultIsEdit = 0;
                // 如果是会员
                if (this.MemberInfo.cardNo) {
                  a.percentage = this.searchSaleList.vipGuest;
                } else {
                  a.percentage = this.searchSaleList.guest;
                }
                a.technicianName = b.technicianName;
                a.isBatchAdd = 0;
                this.chooseSelection(b, 3, true);
              }
            });
          });
          this.getPackageTCPrice();
        }
        this.loading = false;
      });
    },
    // 选择开单员--勾选事件
    selectChoosePackageEvent(selection, row) {
      const vm = this;
      const obj = {};
      obj.isExit = row.isExit;
      obj.isGuest = 0;
      // percentageType = 1是固定提成 2是比例提成
      obj.percentageType = this.searchPackageList.percentageType;
      obj.technicianId = row.technicianId;
      obj.name = row.name;
      obj.guest = this.searchPackageList.guest;
      obj.noGuest = this.searchPackageList.noGuest;
      obj.number = row.number;
      obj.levelType = row.levelType;
      obj.noVipGuest = this.searchPackageList.noVipGuest;
      obj.vipGuest = this.searchPackageList.vipGuest;
      obj.percentage = this.MemberInfo.cardNo ? this.searchPackageList.vipGuest : this.searchPackageList.guest;
      obj.points = this.MemberInfo.cardNo ? this.searchPackageList.vipGuest : this.searchPackageList.guest;
      obj.technicianName = row.technicianName;
      obj.result = this.resultType == 1 ? 100 : (100 / (this.choosePackageList.length + 1)).toFixed(0);
      obj.resultIsEdit = 0;
      let chooseNum = 0;
      let index;
      for (let j = 0; vm.choosePackageList.length > j; j++) {
        if (vm.choosePackageList[j].technicianId == obj.technicianId) {
          index = j;
        } else {
          chooseNum++;
        }
      }
      if (chooseNum == vm.choosePackageList.length) {
        vm.choosePackageList.push(obj);
        vm.chooseSelection(obj, 3, true);
      } else {
        vm.choosePackageList.splice(index, 1);
        vm.chooseSelection(obj, 3, false);
      }
      setTimeout(() => {
        vm.getPackageTCPrice();
      }, 100);
    },
    // 选择销售员工--勾选事件
    choosePackageEvent(row) {
      if (row.state == 4 || row.state == 5 || row.state == 6) return;
      const vm = this;
      const obj = {};
      obj.isExit = row.isExit;
      obj.isGuest = 0;
      // percentageType = 1是固定提成 2是比例提成
      obj.percentageType = this.searchPackageList.percentageType;
      obj.technicianId = row.technicianId;
      obj.name = row.name;
      obj.guest = this.searchPackageList.guest;
      obj.noGuest = this.searchPackageList.noGuest;
      obj.number = row.number;
      obj.levelType = row.levelType;
      obj.noVipGuest = this.searchPackageList.noVipGuest;
      obj.vipGuest = this.searchPackageList.vipGuest;
      obj.percentage = this.MemberInfo.cardNo ? this.searchPackageList.vipGuest : this.searchPackageList.guest;
      obj.points = this.MemberInfo.cardNo ? this.searchPackageList.vipGuest : this.searchPackageList.guest;
      obj.result = this.resultType == 1 ? 100 : (100 / (this.choosePackageList.length + 1)).toFixed(0);
      obj.resultIsEdit = 0;
      obj.technicianName = row.technicianName;
      vm.$refs.packageTCTable.toggleRowSelection(row);
      let chooseNum = 0;
      let index;
      for (let j = 0; vm.choosePackageList.length > j; j++) {
        if (vm.choosePackageList[j].technicianId == obj.technicianId) {
          index = j;
        } else {
          chooseNum++;
        }
      }
      if (chooseNum == vm.choosePackageList.length) {
        vm.choosePackageList.push(obj);
        setTimeout(() => {
          vm.getPackageTCPrice();
        }, 100);
      } else {
        vm.choosePackageList.splice(index, 1);
        setTimeout(() => {
          vm.getPackageTCPrice();
        }, 100);
      }
    },
    // 计算套餐总业绩
    getPackageTCPrice() {
      const vm = this;
      let percentagePrice = 0;
      vm.choosePackageList.forEach((a) => {
        if (a.resultIsEdit == 0) {
          a.result = this.resultType == 1 ? 100 : (100 / (vm.choosePackageList.length * 1)).toFixed(0);
        }
      });
      if (vm.choosePackageList) {
        if (vm.choosePackageList.length > 0) {
          vm.choosePackageList.forEach((v) => {
            const newVal = v.percentageType == 1 ? (v.percentage * v.result * vm.form.tableData[vm.packageIndex].count * 0.01).toFixed(2) : (v.percentage * v.result * vm.dialogPackageTotal * 0.0001);
            percentagePrice += newVal * 1;
          });
          vm.packagePercentageTotal = (percentagePrice * 1).toFixed(2);
        } else {
          vm.packagePercentageTotal = 0;
        }
      } else {
        vm.packagePercentageTotal = 0;
      }
    },
    choosePackageCheckBox(val) {
      // 如果是会员
      if (this.MemberInfo.cardNo) {
        if (val === 0) {
          this.choosePackageList[0].percentage = this.searchPackageList.vipGuest;
        } else {
          this.choosePackageList[0].percentage = this.searchPackageList.noVipGuest;
        }
      } else if (val === 0) {
        this.choosePackageList[0].percentage = this.searchPackageList.guest;
      } else {
        this.choosePackageList[0].percentage = this.searchPackageList.noGuest;
      }
    },
    // 确定添加开单员
    comfirmAddPackage() {
      const files = this.choosePackageList;
      const arr = [];
      if (this.choosePackageList.length > 0) {
        for (let i = 0, len = files.length; i < len; i++) {
          const item = files[i];
          item.result = item.result == '' ? 0 : item.result;
          item.percentage = item.percentage == '' ? 0 : item.percentage;
          arr.push(item);
        }
      }
      this.form.tableData[this.packageIndex].percentage4PackageList = arr;
      this.packageDialog = false;
    },
    // 服务开单--提交事件
    submitOrder(status) {
      this.formChange();
      // this.submitBtnStatus = true;
      setTimeout(() => {
        if (this.form.tableData.length == 0 && this.giftSvList.length == 0 && this.giftPdList.length == 0 && this.giftPkList.length == 0) {
          this.$message('请添加项目/产品/套餐/赠品');
          this.submitBtnStatus = false;
          return;
        }
        const files = this.form.tableData;
        let pNum = 0;
        if (!this.MemberInfo.phone && (this.searchStatus == 1)) {
          files.forEach((p) => {
            if (p.listStatus == 3) {
              pNum++;
            }
          });
        }
        if (pNum !== 0) {
          this.$message('订单列表包含套餐，购买套餐需输入顾客手机号码');
          this.submitBtnStatus = false;
          return;
        }
        let timeStatus = 0;
        this.giftSvList.forEach((x) => {
          if (!x.expireTime) {
            timeStatus++;
          }
        });
        this.giftPdList.forEach((y) => {
          if (!y.expireTime) {
            timeStatus++;
          }
        });
        this.giftPkList.forEach((z) => {
          if (!z.expireTime) {
            timeStatus++;
          }
        });
        if (timeStatus > 0) {
          this.$message('请填写赠品到期时间');
          this.submitBtnStatus = false;
          return;
        }
        // 6.5
        if ((this.buyGiftList.length > 0 || this.fullGiftList.length > 0 || this.giftSvList.length > 0 && this.giftPdList.length > 0 && this.giftPkList.length > 0) && this.searchStatus == 1) {
          this.$message('赠品需输入手机号码');
          this.submitBtnStatus = false;
          return;
        }
        const arr = [];
        const arr2 = [];
        const arr3 = [];
        files.forEach((a) => {
          // listStatus == 1 项目 2产品  3套餐
          if (a.percentage4PackageList) {
            a.percentage4PackageList.forEach((x) => {
              x.isUpdate = Number(x.percentage) === (this.MemberInfo.cardNo ? this.searchPackageList.vipGuest : this.searchPackageList.guest) ? 0 : 1;
            });
          }
          if (a.listStatus == 1) {
            const obj = {};
            obj.activityId = a.hasActivity == 1 ? a.activityInfo.activityId : '';
            obj.activityType = a.hasActivity == 1 ? a.activityInfo.activityType : '';
            obj.bookAmount = a.bookAmount;
            obj.discountMoney = a.discountMoney;
            obj.discountType = a.discountType;
            obj.memberPrice = a.memberPrice;
            obj.id = a.id ? a.id : '';
            obj.itemId = a.itemId;
            obj.isWholesale = a.isWholesale;
            // 6.5
            a.detailList = a.detailList || [];
            a.detailList.forEach((x) => {
              x.count = x.qyCount;
              x.changePrice = x.type == 5 ? x.rightsPrice : '';
            });
            obj.detailList = a.detailList;
            obj.itemDeductList = [];
            a.package.forEach((b) => {
              if (b.ischeck) {
                const bobj = {};
                bobj.clientItemId = b.eitemId;
                bobj.clientVipCardId = b.clientVipCardId;
                b.canDeductItemDetailList.forEach((c) => {
                  if (c.dictItemId == a.dictItemId) {
                    bobj.clientVipCardItemId = c.clientVipCardItemId;
                  }
                });
                bobj.count = b.qyCount;
                bobj.deductType = b.deductType;
                bobj.giftId = b.giftId;
                b.canDeductItemDetailList.forEach((c) => {
                  if (c.dictItemId == a.dictItemId) {
                    bobj.deductGiftId = c.giftId;
                  }
                });
                bobj.isBookDeduct = b.isBookDeduct;
                bobj.isElectronicTicketDeduct = b.isElectronicTicket;
                bobj.packageGiftId = b.packageGiftId;
                bobj.type = b.type;
                obj.itemDeductList.push(bobj);
              }
            });
            const itemFiles = a.percentage4ServeList;
            const itemArr = [];
            itemFiles.forEach((d) => {
              const objLi = {};
              objLi.isGuest = d.isGuest;
              objLi.isMember = this.MemberInfo.cardNo ? 1 : 0;
              objLi.setType = d.endNum ? 1 : d.item4ServeList ? d.item4ServeList[0].setType ? 1 : 0 : 0;
              const newStatus = (this.MemberInfo.cardNo && d.isGuest == 0) ? d.isMemberNotGuest : (this.MemberInfo.cardNo && d.isGuest == 1) ? d.isMemberGuest : (!this.MemberInfo.cardNo && d.isGuest == 0) ? d.isVisitorNotGuest : d.isVisitorGuest;
              const isUpdate = d.item4ServeList ? d.item4ServeList[0].isUpdate == 0 ? d.percentage : newStatus : newStatus;
              objLi.item4ServeList = [
                {
                  isUpdate: isUpdate == d.percentage ? 0 : 1,
                  percentageId: d.percentageId,
                  percentageType: d.percentageType,
                  price: d.percentage
                }
              ];
              objLi.technicianId = d.technicianId;
              itemArr.push(objLi);
            });
            obj.percentage4ServeList = itemArr;

            const saleFiles = a.percentageSellServeList;
            const saleArr = [];
            saleFiles.forEach((e) => {
              const objLi = {};
              objLi.isGuest = e.isGuest;
              objLi.isMember = this.MemberInfo.cardNo ? 1 : 0;
              objLi.isUpdate = ((e.isUpdate != 0) && (e.isUpdate != 1)) ? this.MemberInfo.cardNo
                ? (((e.vipGuest * 1).toFixed(2)) == ((e.percentage * 1).toFixed(2))) ? 0 : 1
                : (((e.guest * 1).toFixed(2)) == ((e.percentage * 1).toFixed(2))) ? 0 : 1 : e.isUpdate;
              objLi.percentageNum = e.result;
              objLi.percentageNumber = e.percentage || 0;
              objLi.percentageType = e.percentageType || 0;
              objLi.resultDiscountPrice = (a.discountMoney * e.result * 0.01).toFixed(2);
              objLi.resultPrice = (a.price * e.result * 0.01).toFixed(2);
              objLi.setType = e.levelType;
              objLi.technicianId = e.technicianId;
              objLi.isBatchAdd = e.isBatchAdd;
              saleArr.push(objLi);
            });
            obj.percentageSellServeList = saleArr;
            obj.price = a.price;
            obj.oldPrice = a.oldPrice;
            obj.resultPrice = (a.discountMoney * a.count).toFixed(2);
            obj.count = a.count;
            // 6.4
            obj.itemName = a.itemName;
            // 6.8
            obj.serviceTime = a.serviceTime;
            arr.push(obj);
          } else if (a.listStatus == 2) {
            // listStatus == 2 产品
            const obj = {};
            obj.activityId = a.hasActivity == 1 ? a.activityInfo.activityId : '';
            obj.activityType = a.hasActivity == 1 ? a.activityInfo.activityType : '';
            obj.barCode = a.barCode;
            obj.count = a.count;
            obj.discountMoney = a.discountMoney;
            obj.discountType = a.discountType;
            obj.memberPrice = a.memberPrice ? a.memberPrice : a.price;
            obj.isWholesale = a.isWholesale;

            obj.id = a.id ? a.id : '';
            obj.isPercentage = a.isPercentage;
            obj.productName = a.productName;
            const itemFiles = a.percentage4ProductList;
            const itemArr = [];
            itemFiles.forEach((b) => {
              const objLi = {};
              objLi.isGuest = b.isGuest;
              objLi.isMember = this.MemberInfo.cardNo ? 1 : 0;
              objLi.isUpdate = ((b.isUpdate != 0) && (b.isUpdate != 1)) ? this.MemberInfo.cardNo
                ? (((b.vipGuest * 1).toFixed(2)) == ((b.percentage * 1).toFixed(2))) ? 0 : 1
                : (((b.guest * 1).toFixed(2)) == ((b.percentage * 1).toFixed(2))) ? 0 : 1 : b.isUpdate;
              objLi.percentageNum = b.result;
              objLi.percentageNumber = b.percentage || 0;
              objLi.percentageType = b.percentageType || 0;
              objLi.resultDiscountPrice = (a.discountMoney * b.result * 0.01).toFixed(2);
              objLi.resultPrice = (a.price * b.result * 0.01).toFixed(2);
              objLi.setType = b.levelType;
              objLi.technicianId = b.technicianId;
              objLi.isBatchAdd = b.isBatchAdd;
              itemArr.push(objLi);
            });
            obj.percentage4ProductList = itemArr;
            // 6.5
            a.detailList = a.detailList || [];
            a.detailList.forEach((x) => {
              x.count = x.qyCount;
              x.changePrice = x.type == 5 ? x.rightsPrice : '';
            });
            obj.detailList = a.detailList;
            obj.price = a.price;
            obj.oldPrice = a.oldPrice;
            obj.productCode = a.productCode;
            obj.productId = a.productId;
            obj.specification = a.specification;
            obj.total = (a.count * a.discountMoney).toFixed(2);
            obj.typeName = a.typeName;
            obj.productDeductList = [];
            a.package.forEach((b) => {
              if (b.ischeck) {
                const bobj = {};
                bobj.clientVipCardId = b.clientVipCardId;
                b.canDeductProductDetailList.forEach((c) => {
                  if (c.productId == a.productId) {
                    bobj.clientVipCardProductId = c.clientVipCardProductId;
                  }
                });
                bobj.count = b.qyCount;
                b.canDeductProductDetailList.forEach((c) => {
                  if (c.productId == a.productId) {
                    bobj.deductGiftId = c.giftId;
                  }
                });
                bobj.giftId = b.giftId;
                bobj.isElectronicTicketDeduct = b.isElectronicTicket;
                bobj.packageGiftId = b.packageGiftId;
                bobj.vipCardId = b.vipCardId;
                obj.productDeductList.push(bobj);
              }
            });
            arr2.push(obj);
          } else if (a.listStatus == 3) {
            const obj = {};
            obj.activityId = a.hasActivity == 1 ? a.activityInfo.activityId : '';
            obj.activityType = a.hasActivity == 1 ? a.activityInfo.activityType : '';
            obj.count = a.count;
            obj.discountMoney = a.discountMoney;
            obj.discountType = a.discountType;
            obj.memberPrice = a.memberPrice;
            obj.id = a.id;
            obj.isWholesale = a.isWholesale;
            a.detailList = a.detailList || [];
            a.detailList.forEach((x) => {
              x.count = x.qyCount;
              x.changePrice = x.type == 5 ? x.rightsPrice : '';
            });
            obj.detailList = a.detailList;
            const itemFiles = a.percentage4PackageList ? a.percentage4PackageList : [];
            const itemArr = [];
            itemFiles.forEach((b) => {
              const objLi = {};
              objLi.isGuest = b.isGuest;
              objLi.isMember = this.MemberInfo.cardNo ? 1 : 0;
              objLi.isUpdate = ((b.isUpdate == 0) || (b.isUpdate == 1)) ? b.isUpdate
                : (((b.points * 1).toFixed(2)) == ((b.percentage * 1).toFixed(2))) ? 0 : 1;
              objLi.percentageNum = b.result;
              objLi.percentageNumber = b.percentage || 0;
              objLi.percentageType = b.percentageType || 0;
              objLi.resultDiscountPrice = (a.discountMoney * b.result * 0.01).toFixed(2);
              objLi.resultPrice = (a.price * b.result * 0.01).toFixed(2);
              objLi.setType = b.levelType;
              objLi.technicianId = b.technicianId;
              objLi.isBatchAdd = b.isBatchAdd;
              itemArr.push(objLi);
            });
            obj.percentage4PackageList = itemArr;
            obj.price = a.price;
            obj.oldPrice = a.oldPrice;
            obj.resultPrice = a.discountMoney * a.count;
            obj.technicianId = itemFiles.length > 0 ? itemFiles[0].technicianId : '';
            obj.vipCardId = a.vipCardId;
            // 6.4
            obj.vipCardName = a.vipCardName;
            arr3.push(obj);
          }
        });
        const handArr = [];
        this.handList.forEach((h) => {
          if (h.handCardNumber) {
            handArr.push(h);
          }
        });
        const checkInDtos = {
          checkInList: this.check_in_data.roomInfosList,
          mainId: window.sessionStorage.mainId
        };
        const newDtos = {
          checkInList: [],
          mainId: window.sessionStorage.mainId
        };
        const arr4 = [];
        const arr5 = [];
        const arr6 = [];
        this.giftSvList.forEach((x) => {
          const obj = {};
          obj.expireTime = x.expireTime;
          obj.giftId = x.giftId;
          obj.giftName = x.itemName;
          obj.givingQuantity = x.givingQuantity;
          obj.dictItemId = x.dictItemId;
          obj.itemId = x.itemId;
          obj.orderId = x.orderId;
          obj.price = x.price;
          obj.memberPrice = x.memberPrice;
          obj.totalPrice = (x.givingQuantity * x.price).toFixed(2);
          arr4.push(obj);
        });
        this.giftPdList.forEach((y) => {
          const obj = {};
          obj.expireTime = y.expireTime;
          obj.giftId = y.giftId;
          obj.giftName = y.productName;
          obj.givingQuantity = y.givingQuantity;
          obj.productId = y.productId;
          obj.orderId = y.orderId;
          obj.price = y.price;
          obj.memberPrice = y.memberPrice;
          obj.totalPrice = (y.givingQuantity * y.price).toFixed(2);
          arr5.push(obj);
        });
        this.giftPkList.forEach((z) => {
          const obj = {};
          obj.expireTime = z.expireTime;
          obj.giftId = z.giftId;
          obj.giftName = z.vipCardName;
          obj.givingQuantity = z.givingQuantity;
          obj.vipCardId = z.id;
          obj.orderId = z.orderId;
          obj.price = z.price;
          obj.memberPrice = z.memberPrice;
          obj.totalPrice = (z.givingQuantity * z.price).toFixed(2);
          arr6.push(obj);
        });
        const buyGiftArr = [];
        this.buyGiftList.forEach((a) => {
          const obj = {};
          obj.activityGiftId = a.activityGiftId;
          obj.activityGiftPrice = a.activityGiftPrice;
          obj.activityId = a.activityId;
          obj.giftCount = a.buyGiftCount;
          obj.giftId = a.giftId;
          obj.giftType = a.giftType;
          buyGiftArr.push(obj);
        });
        this.fullGiftList.forEach((a) => {
          const obj = {};
          obj.activityGiftId = a.activityGiftId;
          obj.activityGiftPrice = a.activityGiftPrice;
          obj.activityId = a.activityId;
          obj.giftCount = a.buyGiftCount;
          obj.giftId = a.giftId;
          obj.giftType = a.giftType;
          buyGiftArr.push(obj);
        });
        const data = {
          activityGiftList: buyGiftArr,
          cardNo: this.MemberInfo.cardNo || '',
          cards: handArr,
          checkInDTO: checkInDtos.checkInList[0].roomName ? checkInDtos : newDtos,
          id: this.id ? this.id : '',
          memberId: this.MemberInfo.memberId || '',
          memberName: this.MemberInfo.nickName ? this.MemberInfo.nickName : this.form.name,
          memberType: this.MemberInfo.cardNo ? 1 : 0,
          orderCustomer: this.handCustomer,
          bookOrderId: this.form.bookOrderId ? this.form.bookOrderId : '',
          phone: this.MemberInfo.phone ? this.MemberInfo.phone : this.searchStatus == 1 ? '' : this.form.phone,
          remark: this.textareaVal ? this.textareaVal : '',
          total: this.listTotal,
          serveItemList: arr,
          productSaleList: arr2,
          vipCardList: arr3,
          giftItemList: arr4,
          giftProductList: arr5,
          giftPackageList: arr6
        };
        saveOrUpdate(data).then((res) => {
          if (res.code == 0) {
            const vm = this;
            window.sessionStorage.bookOrderId = '';
            if (status == 99) {
              vm.clearOrderData('2');
              this.$router.replace({
                name: 'stage-orderSettlement',
              });
              vm.$store.commit('deleteTabs', 'stage-serviceBilling');
              window.sessionStorage.settlementOrderId = res.data;
            } else {
              this.$message({ message: '订单提交成功', type: 'success' });
              setTimeout(() => {
                vm.clearOrderData('2');
                vm.$store.commit('deleteTabs', 'stage-serviceBilling');
                window.history.go(-1);
              }, 100);
            }
          } else if (res.code == 2) {
            const newArr = res.msg.split('：')[1].split(',');
            this.handList.forEach((a) => {
              newArr.forEach((b) => {
                if (a.handCardNumber == b) {
                  a.inputStatus = 2;
                }
              });
            });
            this.$message({
              type: 'error',
              message: res.msg
            });
          } else {
            this.$message({
              type: 'error',
              message: res.msg
            });
          }
          setTimeout(() => {
            this.submitBtnStatus = false;
          }, 300);
        });
      }, 100);
    },
    // 输入建议
    querySearchAsync(queryString, cb) {
      // 获取电话输入建议总列表
      // queryString 输入框的值
      // cb 回调函数 返回查询后过滤好的列表
      const results = queryString ? this.getCustomerList(queryString) : '';
      queryString ? cb(results) : '';
    },
    // 顾客列表
    getCustomerList(val) {
      const data = {
        mainId: window.sessionStorage.mainId,
        sex: '',
        memberType: '',
        grade: '',
        rate: '',
        birthdayStart: '',
        birthdayEnd: '',
        source: '',
        pageNum: 1,
        pageSize: 9999,
        phone: val
      };
      const phones = [
        {
          list: []
        }
      ];
      getCustomerMsgList(data).then((res) => {
        if (res.code == 0) {
          for (const i in res.data.records) {
            phones[0].list.push({
              value: res.data.records[i].phone,
              cardNo: res.data.records[i].cardNo,
              customerName: res.data.records[i].customerName
            });
          }
        }
      });
      console.log(phones);
      return phones;
    },
    // 查询顾客列表
    onCheckPhoneBook() {
      this.bookVisible = true;
    },
    checkMember(phone) {
      setTimeout(() => {
        this.inputShow = 2;
        if (typeof (phone) === 'object') {
          this.form.phone = phone.value;
        } else {
          this.form.phone = phone;
        }
        setTimeout(() => {
          this.inputShow = 1;
        }, 1000);
        this.memberSearch();
      }, 10);
    },
    // 5.3.0获得开房数据
    updateCheckInData(val) {
      this.check_in_data = val;
      this.form.phone = val.customerPhone;
      this.memberSearch();
    },
    // 获取支付方式列表
    getPayList() {
      const data = {
        mainId: window.sessionStorage.mainId
      };
      getPayCodeList(data).then((res) => {
        if (res.code == 0 && res.data) {
          res.data.forEach((a) => {
            if (a.payType == 30) {
              this.editOldPriceStatus = a.isOpen;
            } else if (a.payType == 31) {
              this.editDiscountPriceStatus = a.isOpen;
            } else if (a.payType == 50) {
              this.handSwitch = a.isOpen;
            } else if (a.payType == 51) {
              this.customerSwitch = a.isOpen;
            }
          });
        } else {
          console.log(res);
        }
      });
    },
    // 5.6需求
    // 监听滚动--项目
    listenScrollOne(e) {
      const ele = e.srcElement ? e.srcElement : e.target;
      if ((ele.scrollTop + ele.offsetHeight > ele.scrollHeight - 100) && this.loadS1 == false && (this.pageNum1 > (this.pages1 > 3 ? 3 : this.pages1))) { // 监听滚动到div底部
        this.loadS1 = true;
        this.getServiceList();
      }
    },
    // 监听滚动--产品
    listenScrollTwo(e) {
      const ele = e.srcElement ? e.srcElement : e.target;
      if ((ele.scrollTop + ele.offsetHeight > ele.scrollHeight - 100) && this.loadS2 == false && (this.pageNum2 > (this.pages2 > 3 ? 3 : this.pages2))) { // 监听滚动到div底部
        this.loadS2 = true;
        this.getProductData();
      }
    },
    // 监听滚动--套餐
    listenScrollThree(e) {
      console.log('afsdsdg');
      const ele = e.srcElement ? e.srcElement : e.target;
      if ((ele.scrollTop + ele.offsetHeight > ele.scrollHeight - 100) && this.loadS3 == false && (this.pageNum3 > (this.pages3 > 3 ? 3 : this.pages3))) { // 监听滚动到div底部
        this.loadS3 = true;
        this.phoneSearch();
      }
    },
  }
};
</script>

<style lang="less" scoped>
.noCustomer {
  padding: 0 20px;
  text-align: center;
}
.billTop {
  background-color: #F5F7FA;
  margin-bottom: 10px;
  margin-right: 160px;
  .search {
    height: 80px;
    line-height: 80px;
    overflow: hidden;
    margin-left: 10px;
    .srcoll {
      width: max-content;
      span {
        font-size: 14px;
        color: #333;
        samp {
          cursor: pointer;
        }
      }
      .ml_20 {
        margin-left: 20px;
      }
      .ml_80 {
        margin-left: 80px;
      }
    }
  }
  .torder {
    position: absolute;
    right: 0;
    top: 20px;
  }
  .writeOff {
    position: absolute;
    right: 80px;
    top: 20px;
  }
}
.takeOrderList {
  display: table;
  clear: both;
  .tolLi {
    float: left;
    width: 271px;
    height: auto;
    background: #F8F8F8;
    border: 1px solid #EBEEF5;
    border-radius: 5px;
    padding: 10px 20px;
    margin-right: 10px;
    margin-bottom: 10px;
    position: relative;
    h1 {
      font-size: 14px;
      color: #333;
      height: 18px;
      line-height: 18px;
    }
    h2 {
      font-size: 14px;
      color: #333;
      height: 18px;
      line-height: 18px;
      padding-top: 5px;
      padding-bottom: 10px;
      border-bottom: 1px solid #EBEEF5;
      span {
        float: right;
      }
    }
    h3 {
      padding-top: 10px;
      font-size: 14px;
      color: #333;
      height: 18px;
      line-height: 18px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      span {
        color: #999;
      }
    }
    h4 {
      padding: 10px 0;
      font-size: 14px;
      color: #333;
      height: 18px;
      line-height: 18px;
      border-bottom: 1px solid #EBEEF5;
      span {
        color: #999;
      }
    }
    h5 {
      padding: 10px 0 0 0;
      text-align: right;
    }
    h6 {
      position: absolute;
      width: 44px;
      height: 23px;
      line-height: 23px;
      text-align: center;
      font-size: 14px;
      border-radius: 0px 5px 0px 5px;
      color: #fff;
      margin: -12px 0 0 -21px;
    }
  }
  .tolLi:nth-child(3n) {
    margin-right: 0;
  }
}
.billBottom {
  display: flex;
  .billBottomLeft {
    width: 404px;
    border: 1px solid #E6EBF5;
    .elRg {
      margin: 10px;
    }
    .sInput {
      position: absolute;
      width: 220px;
      margin-top: 60px;
      margin-left: -230px;
      z-index: 3;
    }
    samp {
      display: block;
      width: 86px;
      font-size: 14px;
    }
    .tabContent {
      display: flex;
      .tabLeft {
        width: 86px;
        padding: 0;
        background-color: #f8f8f8;
        overflow-x: hidden;
        overflow-y: visible;
        .tlType {
          padding: 4px 5px;
          text-align: center;
          cursor: pointer;
          min-height: 40px;
          line-height: 20px;
          color: #333;
          font-size: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          overflow: hidden;
          word-break: break-all;
        }
        .ttChoose {
          padding: 4px 5px;
          text-align: center;
          cursor: pointer;
          min-height: 40px;
          line-height: 20px;
          background-color: #fff;
          font-size: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          overflow: hidden;
        }
      }
      .tabRight {
        flex: 1;
        margin: 0 0 10px 0;
        overflow-x: hidden;
        overflow-y: visible;
        .acssType {
          padding: 0 10px;
          button {
            margin-top: 10px;
          }
          button:nth-child(4) {
            margin-left: 0;
          }
        }
        .trProject {
          width: 143px;
          height: auto;
          background-color: #f8f8f8;
          margin: 10px 0 0 10px;
          border-radius: 5px;
          float: left;
          cursor: pointer;
          h4 {
            padding: 10px;
            height: 15px;
            line-height: 15px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-size: 14px;
            color: #333;
          }
          h5 {
            padding: 0 10px 10px 10px;
            height: 15px;
            line-height: 15px;
            font-size: 14px;
            position: relative;
            i {
              padding-left: 5px;
              font-size: 14px;
              color: #d2d2d2;
            }
            .tipCss {
              position: absolute;
              margin: 1px 0 0 85px;
              width: 64px;
              height: 32px;
              line-height: 32px;
              text-align: center;
              font-size: 20px;
              color: #fff;
              border-radius: 8px 0px 8px 0px;
              transform: scale(0.5);
            }
            .tip1 {
              background-color: #FF4040;
            }
            .tip2 {
              background-color: #F7B900;
            }
            .tip3 {
              background-color: #4086FF;
            }
            .tip4 {
              background-color: #FF6740;
            }
          }
          h6 {
            padding: 0 10px 10px 10px;
            height: 12px;
            line-height: 12px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-size: 12px;
            color: #999;
          }
        }
        .trProduct {
          padding: 10px;
          border-bottom: 1px solid #eee;
          display: flex;
          .tpLeft {
            width: 60px;
            height: 60px;
            margin-right: 10px;
          }
          .tpRight {
            flex: 1;
            h5 {
              height: 14px;
              line-height: 14px;
              font-size: 14px;
              color: #333;
              padding-bottom: 10px;
              .trrLeft {
                float: left;
                width: 60%;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
              .trrRight {
                float: right;
                width: 40%;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                text-align: right;
              }
            }
            p {
              line-height: 14px;
              font-size: 12px;
              color: #999;
              word-break: break-all;
            }
          }
        }
        .noData {
          display: block;
          font-size: 25px;
          padding-bottom: 5px;
          text-align: center;
          color: #c0c4cc;
        }
      }
      .flexMiddle {
        display: flex;
        justify-content: center;
        align-items: center;
        color: #999;
        font-size: 14px;
      }
    }
    .tabCttwo {
      overflow-x: hidden;
      overflow-y: visible;
      .tcLi {
        clear: both;
        h1 {
          display: flex;
          font-size: 14px;
          line-height: 16px;
          padding: 10px;
          b {
            flex: 1;
            font-weight: bold;
            padding-right: 10px;
            color: #333;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          }
          span {
            flex: 1;
            color: #999;
            padding-right: 10px;
            font-size: 12px;
          }
          samp {
            width: 130px;
            float: right;
            color: #666;
            font-size: 12px;
          }
        }
        p {
          height: 16px;
          line-height: 16px;
          color: #333;
          padding: 0 10px 10px 10px;
          clear: both;
        }
        .tiPackage {
          width: 187px;
          height: auto;
          background-color: #f8f8f8;
          margin: 0 0 10px 10px;
          border-radius: 5px;
          float: left;
          cursor: pointer;
          h4 {
            padding: 10px;
            height: 15px;
            line-height: 15px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-size: 14px;
            color: #333;
          }
          h5 {
            padding: 0 10px 10px 10px;
            height: 15px;
            line-height: 15px;
            font-size: 14px;
            label {
              font-size: 14px;
              float: right;
              cursor: pointer;
              span {
                color: #333;
                cursor: pointer;
              }
            }
          }
          h6 {
            padding: 0 10px 10px 10px;
            height: 12px;
            line-height: 12px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-size: 12px;
            color: #999;
          }
        }
      }
      .tcOl {
        clear: both;
        p {
          height: 16px;
          line-height: 16px;
          color: #333;
          padding: 10px;
          clear: both;
        }
        .tcPi {
          width: 384px;
          height: auto;
          background-color: #f8f8f8;
          margin: 0 0 10px 10px;
          border-radius: 5px;
          float: left;
          cursor: pointer;
          h4 {
            padding: 10px;
            height: 15px;
            line-height: 15px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-size: 14px;
            color: #333;
          }
          h5 {
            padding: 0 10px 10px 10px;
            height: 15px;
            line-height: 15px;
            font-size: 14px;
            color: #333;
            label {
              font-size: 14px;
              float: right;
              span {
                color: #333;
              }
            }
          }
          h6 {
            padding: 0 10px 10px 10px;
            height: 12px;
            line-height: 12px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-size: 12px;
            color: #999;
          }
        }
      }
      .noData {
        display: block;
        font-size: 25px;
        padding-bottom: 5px;
        text-align: center;
        color: #c0c4cc;
      }
    }
    .flexMiddleTwo {
      display: flex;
      justify-content: center;
      align-items: center;
      color: #999;
      font-size: 14px;
    }
    .tabCtthree {
      overflow-x: hidden;
      overflow-y: visible;
      .acssType {
        padding: 0 10px 10px 10px;
        button {
          margin-top: 10px;
        }
        button:nth-child(3n+1) {
          margin-left: 0;
        }
      }
      .tcInfo {
        height: 16px;
        font-size: 14px;
        line-height: 16px;
        color: #999;
        padding: 0 10px 10px 10px;
      }
      .tiPackage {
        width: 187px;
        height: auto;
        background-color: #f8f8f8;
        margin: 0 0 10px 10px;
        border-radius: 5px;
        float: left;
        cursor: pointer;
        h4 {
          padding: 10px;
          height: 15px;
          line-height: 15px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          font-size: 14px;
          color: #333;
        }
        h5 {
          padding: 0 10px 10px 10px;
          height: 15px;
          line-height: 15px;
          font-size: 14px;
          position: relative;
          i {
            padding-left: 5px;
            font-size: 14px;
            color: #d2d2d2;
          }
          .tipCss {
            position: absolute;
            margin: 1px 0 0 129px;
            width: 64px;
            height: 32px;
            line-height: 32px;
            text-align: center;
            font-size: 20px;
            color: #fff;
            border-radius: 8px 0px 8px 0px;
            transform: scale(0.5);
          }
          .tip1 {
            background-color: #FF4040;
          }
          .tip2 {
            background-color: #F7B900;
          }
          .tip3 {
            background-color: #4086FF;
          }
          .tip4 {
            background-color: #FF6740;
          }
        }
        h6 {
          padding: 0 10px 10px 10px;
          height: 12px;
          line-height: 12px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          font-size: 12px;
          color: #999;
        }
      }
      .ttNo {
        display: flex;
        justify-content: center;
        align-items: center;
        color: #999;
        font-size: 14px;
        .noData {
          display: block;
          font-size: 25px;
          padding-bottom: 5px;
          text-align: center;
          color: #c0c4cc;
        }
      }
    }
  }
  .billBottomRight {
    flex: 1;
    width: auto;
    overflow: hidden;
    border: 1px solid #E6EBF5;
    margin-left: 10px;
    h3 {
      font-size: 14px;
      height: 16px;
      line-height: 16px;
      padding: 10px;
      samp{
        float: right;
        cursor: pointer;
      }
    }
    .btrUl {
      overflow-x: scroll;
      overflow-y: visible;
      padding-bottom: 10px;
      .btrLi {
        background-color: #f8f8f8;
        margin: 0 10px 10px 10px;
        padding: 10px;
        border-radius: 5px;
        margin-bottom: 10px;
        min-width: 690px;
        color: #333;
        .delList {
          font-size: 14px;
          cursor: pointer;
          color: #999;
          float: right;
          position: relative;
          z-index: 3;
        }
        .bltop {
          display: flex;
          height: 80px;
          border-bottom: 1px solid #EBEEF5;
          padding: 0 10px;
          p {
            flex: 1;
            display: flex;
            min-width: 130px;
            height: 80px;
            line-height: 20px;
            font-size: 14px;
            text-align: left;
            justify-content: center;
            flex-direction: column;
            overflow: hidden;
          }
          h2 {
            flex: 1;
            text-align: center;
            min-width: 130px;
            height: 80px;
            line-height: 80px;
            font-size: 14px;
          }
          h4 {
            flex: 1;
            min-width: 260px;
            b {
              font-weight: 500;
              display: block;
              height: 40px;
              line-height: 40px;
              font-size: 14px;
            }
            samp {
              line-height: 40px;
              font-size: 14px;
              color: #666;
            }
            label {
              line-height: 40px;
              padding-left: 20px;
              font-size: 14px;
              color: #666;
            }
            .ticket {
              width: 28px;
              height: 28px;
              margin: 6px 0 0 5px;
            }
          }
          h5 {
            flex: 1;
            text-align: right;
            min-width: 180px;
            b {
              font-weight: 500;
              display: block;
              height: 40px;
              line-height: 40px;
              font-size: 14px;
            }
            samp {
              line-height: 40px;
              font-size: 14px;
              color: #666;
            }
          }
        }
        .blBottom {
          padding-top: 10px;
          height: 28px;
          line-height: 28px;
          .qychoose {
            float: right;
            font-size: 14px;
            padding: 0;
            margin: 0;
            height: 28px;
            line-height: 28px;
          }
          div {
            float: left;
          }
        }
      }
      .bgTitle {
        padding: 5px 10px 10px 10px;
        height: 16px;
        line-height: 16px;
        color: #333;
        font-size: 14px;
      }
      .buGift {
        background-color: #f8f8f8;
        margin: 0 10px 10px 10px;
        padding: 10px;
        border-radius: 5px;
        margin-bottom: 10px;
        min-width: 810px;
        color: #333;
        .btLi {
          display: flex;
          height: 60px;
          padding: 0 10px;
          .cg {
            margin: 20px 5px 20px 0;
          }
          p {
            display: flex;
            width: 160px;
            height: 60px;
            line-height: 20px;
            font-size: 14px;
            text-align: left;
            justify-content: center;
            flex-direction: column;
            overflow: hidden;
          }
          h2 {
            text-align: center;
            width: 160px;
            height: 60px;
            line-height: 60px;
            font-size: 14px;
          }
          h4 {
            width: 320px;
            height: 60px;
            line-height: 60px;
            font-size: 14px;
          }
          h5 {
            flex: 1;
            text-align: right;
            min-width: 40px;
            height: 60px;
            line-height: 60px;
            font-size: 14px;
            span {
              color: #409EFF;
              float: right;
              cursor: pointer;
            }
          }
        }
      }
    }
    .addGift {
      border-top: 1px solid #E6EBF5;
      height: 39px;
      line-height: 39px;
      font-size: 14px;
      padding: 0 10px;
      samp {
        color: #D2D2D2;
        cursor: pointer;
        margin-right: 10px;
      }
      b {
        font-weight: 500;
        float: right;
        cursor: pointer;
      }
      .noDrop
      {
        cursor: no-drop;
      }
    }
    .btrFoot {
      height: 172px;
      .rfTop {
        padding: 10px;
        background-color: #F5F7FA;
        display: flex;
        white-space: nowrap;
        overflow-x: auto;
        overflow-y: hidden;
        height: 32px;
        .f_cusomer {
          flex: 1;
          height: 28px;
          line-height: 28px;
          padding: 4px 20px 10px 0;
          font-size: 14px;
          color: #333;
          white-space: nowrap;
          samp {
            padding: 0 5px 0 20px;
          }
          .f_input {
            width: 100px;
          }
          i {
            margin-left: 5px;
          }
        }
        .f_hand {
          display: flex;
          height: 28px;
          line-height: 28px;
          padding: 4px 0 10px 0;
          font-size: 14px;
          color: #333;
          white-space: nowrap;
          label {
            float: left;
          }
          i {
            font-size: 28px;
            color: #D8DCE5;
            cursor: pointer;
            padding-right: 0;
          }
          .f_input {
            float: left;
            line-height: 18px;
            font-size: 14px;
            width: 80px;
            margin-right: 10px;
            i {
              font-size: 16px;
              width: 16px;
              padding-right: 0;
            }
          }
        }
      }
      .f_remark {
        padding: 0 10px 10px 10px;
        background-color: #F5F7FA;
        height: 54px;
        display: flex;
        .span {
          width: 54px;
          font-size: 14px;
          line-height: 54px;
          color: #333;
        }
      }
      .f_total {
        height: 36px;
        line-height: 36px;
        padding: 10px;
        font-size: 14px;
        color: #333;
        .ft_left {
          float: left;
          b {
            font-size: 18px;
          }
        }
        .ft_right {
          float: right;
        }
      }
    }
  }
}
.billLeft {
  width: 302px;
  height: auto;
  overflow-x: hidden;
  margin-right: 30px;
  .keywordSearch {
    width: 302px;
    margin-bottom: 20px;
  }
  .fixed {
    border: solid 1px #e6ebf5;
    border-bottom: 0;
    height: 131px;
    width: 300px;
    background-color: #fff;
    position: fixed;
    z-index: 1;
    overflow: hidden;
    .nav {
      height: 50px;
      line-height: 50px;
      display: flex;
      p {
        font-size: 14px;
        color: #333;
        text-align: center;
        cursor: pointer;
        flex: 1;
        border-bottom: 2px solid #dfe4ed;
      }
    }
    .search {
      padding: 20px;
      border-bottom: 1px solid #e6ebf5;
      p {
        display: flex;
        height: 40px;
        line-height: 40px;
        span {
          font-size: 14px;
          color: #333;
        }
        samp {
          font-size: 14px;
          height: 40px;
          line-height: 40px;
          width: 230px;
        }
        .lone {
          display: block;
          float: left;
          width: 38px;
          height: 38px;
          line-height: 38px;
          background: #f8f8f8;
          border-radius: 50%;
          text-align: center;
          margin-right: 10px;
          i {
            color: #b4bccc;
          }
        }
        .ltwo {
          display: block;
          float: left;
          width: 38px;
          height: 38px;
          line-height: 38px;
          background: #fce9ff;
          border-radius: 50%;
          text-align: center;
          margin-right: 10px;
          i {
            color: #e270f5;
          }
        }
        .el-select {
          flex: 1;
        }
        i {
          width: 20px;
          height: 40px;
          line-height: 40px;
          font-size: 20px;
          cursor: pointer;
          color: #b4bccc;
        }
        .itwo {
          margin: 0 0 0 10px;
        }
      }
    }
  }
  .list {
    border: solid 1px #e6ebf5;
    border-top: 0;
    margin-top: 131px;
    padding: 0;
    .noneData {
      padding: 10px 20px;
      i {
        display: block;
        font-size: 30px;
        text-align: center;
        margin: 20px 0 18px 0;
        color: #cecece;
      }
      p {
        height: 32px;
        line-height: 16px;
        text-align: center;
        color: #999;
        font-size: 14px;
      }
    }
    .ul {
      padding: 20px 0 0 0;
      list-style-type: none;
      overflow-x: hidden;
      overflow-y: visible;
      p {
        padding: 0 20px;
        height: 32px;
        line-height: 32px;
        color: #333;
        font-size: 14px;
        cursor: pointer;
        samp {
          float: left;
          max-width: 50%;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        label {
          float: right;
          text-align: right;
          width: 60px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .ione {
          float: none;
          width: 20px;
          height: 20px;
          margin: 6px 0 6px 10px;
        }
        i {
          float: right;
          font-size: 14px;
          color: #d2d2d2;
          margin-left: 6px;
          cursor: pointer;
        }
      }
      li {
        width: 120px;
        height: 109px;
        float: left;
        padding: 0 0 10px 20px;
        cursor: pointer;
        .img {
          width: 120px;
          height: 64px;
          background-position: center center;
          background-size: cover;
          background-repeat: no-repeat;
          border-radius: 6px;
        }
        h5 {
          height: 25px;
          line-height: 25px;
          font-size: 14px;
          color: #333;
          text-align: center;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          label {
            width: 100px;
            float: left;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          i {
            float: right;
            width: 20px;
            text-align: right;
            font-size: 12px;
            color: #d2d2d2;
            cursor: pointer;
          }
        }
        h6 {
          height: 20px;
          line-height: 20px;
          font-size: 14px;
          text-align: center;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }
    .dialog-footer {
      position: absolute;
      left: 0;
      bottom: 1px;
      float: left;
      height: 55px;
      line-height: 55px;
      width: 265px;
      overflow-x: scroll;
      overflow-y: hidden;
      margin-left: 15px;
      margin-right: 20px;
      padding-right: 0 !important;
    }
  }
  .meal {
    overflow-x: hidden;
    overflow-y: visible;
    margin-top: 51px;
    .ul {
      width: 100%;
      list-style-type: none;
      padding-bottom: 20px;
      li {
        height: 75px;
        margin: 0 20px;
        padding: 20px 0;
        border-bottom: 1px solid #e6ebf5;
        cursor: pointer;
        .li_left {
          float: left;
          width: 116px;
          height: 75px;
          border-radius: 6px;
        }
        .li_right {
          height: 75px;
          h5 {
            padding-left: 10px;
            height: 40px;
            line-height: 20px;
            font-size: 14px;
            color: #333;
            word-wrap: break-word;
            overflow: hidden;
            white-space: pre-line;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }
          p {
            padding: 10px 0 0 10px;
            height: 20px;
            line-height: 20px;
            font-size: 14px;
            color: #333;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
      }
    }
  }
}
.billRight {
  height: auto;
  overflow-x: hidden;
  border: solid 1px #e6ebf5;
  padding: 0 20px;
  flex: 1;
  .clearBtn {
    float: right;
    width: 80px;
    height: 32px;
    line-height: 32px;
    font-size: 14px;
    text-align: center;
    border-radius: 4px;
    margin: 0 0 0 20px;
    cursor: pointer;
    i {
      padding-right: 5px;
    }
  }
  .totalNum {
    float: right;
    width: 80px;
    height: 22px;
    line-height: 33px;
    font-size: 12px;
    color: #666;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .openInterest {
    height: 48px;
    line-height: 48px;
    background-color: #f5f7fa;
    padding: 0 30px;
    margin-bottom: 20px;
    font-size: 14px;
    span {
      color: #333;
    }
  }
  .closeBtn {
    color: #bbc0c8;
    font-size: 18px;
    float: left;
    position: absolute;
    right: 20px;
    top: 30px;
  }
  .closeBtn2 {
    color: #bbc0c8;
    font-size: 18px;
    float: left;
    position: absolute;
    right: 20px;
    top: 23px;
  }
}
.right_footer {
  height: 159px;
  position: absolute;
  bottom: 0;
  .rfTop {
    display: flex;
    white-space: nowrap;
    overflow-x: auto;
    overflow-y: hidden;
    padding-bottom: 10px;
    height: 32px;
    .f_cusomer {
      flex: 1;
      height: 28px;
      line-height: 28px;
      padding: 4px 0 10px 0;
      font-size: 14px;
      color: #333;
      white-space: nowrap;
      samp {
        padding: 0 5px 0 20px;
      }
      .f_input {
        width: 100px;
      }
      i {
        margin-left: 5px;
      }
    }
    .f_hand {
      display: flex;
      height: 28px;
      line-height: 28px;
      padding: 4px 10px 10px 0;
      font-size: 14px;
      color: #333;
      white-space: nowrap;
      padding-left: 40px;
      label {
        float: left;
      }
      i {
        font-size: 28px;
        color: #D8DCE5;
        cursor: pointer;
        padding-right: 10px;
      }
      .f_input {
        float: left;
        line-height: 18px;
        font-size: 14px;
        width: 80px;
        margin-right: 10px;
        i {
          font-size: 16px;
          width: 16px;
          padding-right: 0;
        }
      }
    }
  }
  .f_remark {
    height: 50px;
    padding-right: 20px;
    .span {
      float: left;
      font-size: 14px;
      line-height: 50px;
      color: #333;
    }
    .el-textarea {
      float: left;
    }
  }
  .f_total {
    height: 36px;
    line-height: 36px;
    padding: 20px 20px 0 0;
    font-size: 14px;
    color: #333;
    .ft_left {
      float: left;
      b {
        font-size: 18px;
      }
    }
    .ft_right {
      float: right;
    }
  }
}
.newFootCss {
  padding: 15px 0 20px 0;
  .newFootCode {
    float: right;
    margin-top: 10px;
    .newPrice {
      color: #666;
      font-size: 14px;
      padding: 10px 0 10px 35px;
      small {
        color: #ff2233;
        font-size: 16px;
      }
    }
  }
  .newFootBtn {
    float: right;
    display: block;
    width: 100%;
    text-align: right;
    padding-top: 7px;
  }
}
.dialog_header {
  height: 48px;
  clear: both;
  p {
    line-height: 40px;
    height: 40px;
    margin-left: 27px;
    color: #666;
    font-size: 14px;
    width: 310px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    float: left;
    span {
      max-width: 290px;
      float: left;
      padding-right: 5px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
  h6 {
    line-height: 40px;
    height: 40px;
    color: #666;
    font-size: 14px;
    width: 310px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    float: right;
    text-align: right;
    label {
      color: #f56c6c;
      font-size: 18px;
    }
    samp {
      margin-left: 9px;
      text-decoration: line-through;
      font-size: 13px;
    }
  }
}
.giftChoose {
  width: 100%;
  display:flex;
  height: 528px;
  margin-top: 20px;
  .alreadyChoose_div {
    border: 1px solid rgba(223, 230, 236, 1);
    width: 275px;
    overflow-y: auto;
    samp {
      height: 47px;
      background: rgba(238, 241, 246, 1);
      font-size: 14px;
      line-height: 40px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      text-align: left;
      padding: 0 20px;
      display: flex;
      justify-content: space-between;
      position: fixed;
      width: 235px;
    }
    ul {
      padding: 47px 21px 0;
      display: flex;
      flex-direction: column;
      p {
        height: 460px;
        line-height: 460px;
        color: #999;
        font-size: 14px;
        margin: auto;
      }
      > li {
        display: flex;
        justify-content: space-between;
        align-items: center;
        line-height: 48px;
        .single_row {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
}
.haveHad {
  color: white;
  width: 50px;
  height: 24px;
  font-size: 12px;
  border-radius: 4px;
  text-align: center;
  line-height: 24px;
  position: relative;
  display: block;
  margin-bottom: -24px;
}
.editOldPrice {
  padding: 10px;
}
.gender {
  width: 32px;
  height: 32px;
  line-height: 30px;
  text-align: center;
  color: #fff;
  font-size: 20px;
  border-radius: 4px;
  transform: scale(0.5);
  display: block;
  float: left;
  position: relative;
  top: 8px;
  margin-top: -16px;
}
.gender_b {
  background-color: #409eff;
}
.gender_g {
  background-color: #fd5c8c;
}
.gender_w {
  background-color: #e6a23c;
}
</style>

<style>
.takeOrderList .el-loading-spinner {
  background-position-y: 50%;
  top: 0;
  padding-top: 0;
}
.takeOrderCss .el-dialog__header {
  padding: 15px 20px;
}
.takeOrderCss .el-dialog__body {
  padding: 20px;
}
.takeOrderCss .el-dialog {
  overflow: hidden;
}
.takeOrderCss .writeOffDia img {
  display: block;
  margin: 20px auto;
}
.takeOrderCss .writeOffDia h5 {
  text-align: center;
  margin-bottom: 20px;
  font-size: 14px;
  color: #666;
}
.giftPop {
  padding: 5px 0;
}
.giftPop p {
  padding: 0 15px;
  height: 36px;
  line-height: 36px;
  cursor: pointer;
}
.billTab .el-tabs__header {
  margin-bottom: 0;
}
.billTab .el-tabs__nav-wrap {
  padding-left: 10px;
}
.billBottom .billBottomRight .btrUl {
  width: calc(100vw - 583px) !important;
}
.billBottom .billBottomLeft .tabContent {
  height: calc(100vh - 266px) !important;
}
.billBottom .billBottomLeft .tabCttwo {
  height: calc(100vh - 266px) !important;
}
.billBottom .billBottomLeft .tabCtthree {
  height: calc(100vh - 227px) !important;
}
.billBottom .billBottomLeft .tabCtthree .ttNo {
  height: calc(100vh - 380px) !important;
}
.billBottom .billBottomLeft .tabContent .tabLeft::-webkit-scrollbar {
  width: 0;
  height: 0;
  background-color: #fff;
}
.billBottom .billBottomRight .btrUl::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  background-color: #f5f5f5;
}
.billBottom .billBottomRight .btrUl::-webkit-scrollbar-track-piece {
  background-color: #fff;
}
.billBottom .billBottomRight .btrUl::-webkit-scrollbar-track {
  box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}
.billBottom .billBottomRight .btrUl::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.3);
  background-color: #999;
}
.billBottom .billBottomRight .btrFoot .rfTop::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  background-color: #f5f5f5;
}
.billBottom .billBottomRight .btrFoot .rfTop::-webkit-scrollbar-track-piece {
  background-color: #F5F7FA;
}
.billBottom .billBottomRight .btrFoot .rfTop::-webkit-scrollbar-track {
  box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}
.billBottom .billBottomRight .btrFoot .rfTop::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.3);
  background-color: #999;
}
.billBottom .billBottomLeft .tabContent .tabRight::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  background-color: #f5f5f5;
}
.billBottom .billBottomLeft .tabContent .tabRight::-webkit-scrollbar-track-piece {
  background-color: #fff;
}
.billBottom .billBottomLeft .tabContent .tabRight::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}
.billBottom .billBottomLeft .tabContent .tabRight::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #999;
}
.billBottom .billBottomLeft .tabCttwo::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  background-color: #f5f5f5;
}
.billBottom .billBottomLeft .tabCttwo::-webkit-scrollbar-track-piece {
  background-color: #fff;
}
.billBottom .billBottomLeft .tabCttwo::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}
.billBottom .billBottomLeft .tabCttwo::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #999;
}
.billBottom .billBottomLeft .tabCtthree::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  background-color: #f5f5f5;
}
.billBottom .billBottomLeft .tabCtthree::-webkit-scrollbar-track-piece {
  background-color: #fff;
}
.billBottom .billBottomLeft .tabCtthree::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}
.billBottom .billBottomLeft .tabCtthree::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #999;
}
.giftChoose .alreadyChoose_div::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  background-color: #f5f5f5;
}
.giftChoose .alreadyChoose_div::-webkit-scrollbar-track-piece {
  background-color: #fff;
}
.giftChoose .alreadyChoose_div::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}
.giftChoose .alreadyChoose_div::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #999;
}
.resizeNone .el-textarea__inner{
  resize: none;
}
.merchandiserDialog
  .el-table__header-wrapper
  .el-table__header
  .el-checkbox
  .el-checkbox__input
  .el-checkbox__inner {
  display: none !important;
}
.merchandiserTable .el-table__body-wrapper .el-table__body td {
  padding: 10px 0 6px 0 !important;
}
.merchandiserTable .el-table__fixed-right .el-table__body td {
  padding: 10px 0 6px 0 !important;
}
.newMiniInput {
  width: 60px !important;
  margin: 0 5px;
}
.newMiniInput input {
  width: 60px !important;
  padding: 0 !important;
  text-align: center;
}
.newSelect .el-radio__label {
  padding-left: 20px !important;
}

.blockThree .is-loading {
  display: inline-block !important;
}
.checkBoxList span {
  font-size: 14px;
}
.checkBoxList .el-checkbox .el-checkbox__label {
  width: 56px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  position: relative;
  top: 4px;
}
.chooseServiceCss .el-dialog__body {
  overflow-x: hidden;
  padding-bottom: 10px;
}
.tablePointer .el-table tr {
  cursor: pointer;
}
.tablePointer .brandList {
  position: absolute;
  background-color: #f5f7fa;
  height: 48px;
  line-height: 48px;
  font-size: 14px;
  width: 280px;
  color: #999;
  font-weight: bold;
  z-index: 1;
  overflow: hidden;
}
.tablePointer .brandList .el-tabs__item {
  width: 106px;
  padding: 0 5px;
  height: 48px;
  line-height: 48px;
  text-align: center;
}
.tablePointer .brandList .el-tabs__nav-wrap::after {
  height: 1px;
}
.df_input .el-input__inner {
  padding: 0 5px !important;
}
.billLeft .list .ul::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  background-color: #f5f5f5;
}
.billLeft .list .ul::-webkit-scrollbar-track-piece {
  background-color: #fff;
}
.billLeft .list .ul::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}
.billLeft .list .ul::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #999;
}
.billLeft .dialog-footer::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  background-color: #f5f5f5;
}
.billLeft .dialog-footer::-webkit-scrollbar-track-piece {
  background-color: #fff;
}
.billLeft .dialog-footer::-webkit-scrollbar-track {
  box-shadow: inset 0 0 10px rgba(100, 100, 100, 0.3);
  -webkit-box-shadow: inset 0 0 10px rgba(100, 100, 100, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}
.billLeft .dialog-footer::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 10px rgba(100, 100, 100, 0.3);
  -webkit-box-shadow: inset 0 0 10px rgba(100, 100, 100, 0.3);
  background-color: #eee;
}
.billTop .search::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  background-color: #f5f5f5;
}
.billTop .search::-webkit-scrollbar-track-piece {
  background-color: #fff;
}
.billTop .search::-webkit-scrollbar-track {
  box-shadow: inset 0 0 10px rgba(100, 100, 100, 0.3);
  -webkit-box-shadow: inset 0 0 10px rgba(100, 100, 100, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}
.billTop .search::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 10px rgba(100, 100, 100, 0.3);
  -webkit-box-shadow: inset 0 0 10px rgba(100, 100, 100, 0.3);
  background-color: #eee;
}
.right_footer .rfTop::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  background-color: #f5f5f5;
}
.right_footer .rfTop::-webkit-scrollbar-track-piece {
  background-color: #fff;
}
.right_footer .rfTop::-webkit-scrollbar-track {
  box-shadow: inset 0 0 10px rgba(100, 100, 100, 0.3);
  -webkit-box-shadow: inset 0 0 10px rgba(100, 100, 100, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}
.right_footer .rfTop::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 10px rgba(100, 100, 100, 0.3);
  -webkit-box-shadow: inset 0 0 10px rgba(100, 100, 100, 0.3);
  background-color: #eee;
}
.right_footer .rfTop {
  width: calc(100vw - 519px) !important;
}
.billRight .newTable .el-table__body-wrapper {
  height: calc(100vh - 517px) !important;
  overflow: scroll;
}
.billRight .newTableTwo .el-table__body-wrapper {
  height: calc(100vh - 585px) !important;
  overflow: scroll;
}
.billRight .newTableThree .el-table__body-wrapper {
  height: calc(100vh - 563px) !important;
  overflow: scroll;
}
.billRight .newTableFour .el-table__body-wrapper {
  height: calc(100vh - 593px) !important;
  overflow: scroll;
}
.billRight .newTableFive .el-table__body-wrapper {
  height: calc(100vh - 661px) !important;
  overflow: scroll;
}
.billRight .el-table .el-table__body-wrapper {
  height: calc(100vh - 488px);
  overflow: scroll;
}
.billRight .newTableThreeDesk .el-table__body-wrapper {
  height: calc(100vh - 419px) !important;
  overflow: scroll;
}
.billRight .newTableSixDesk .el-table__body-wrapper {
  height: calc(100vh - 377px) !important;
  overflow: scroll;
}
.billRight .newTableFourDesk .el-table__body-wrapper {
  height: calc(100vh - 449px) !important;
  overflow: scroll;
}
.billRight .newTableSevenDesk .el-table__body-wrapper {
  height: calc(100vh - 407px) !important;
  overflow: scroll;
}
.billRight .newTableFiveDesk .el-table__body-wrapper {
  height: calc(100vh - 517px) !important;
  overflow: scroll;
}
.billRight .newTableEightDesk .el-table__body-wrapper {
  height: calc(100vh - 475px) !important;
  overflow: scroll;
}
.billRight .el-table .el-table__body-wrapper::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  background-color: #f5f5f5;
}
.billRight .el-table .el-table__body-wrapper::-webkit-scrollbar-track-piece {
  background-color: #fff;
}
.billRight .el-table .el-table__body-wrapper::-webkit-scrollbar-track {
  box-shadow: inset 0 0 10px rgba(100, 100, 100, 0.3);
  -webkit-box-shadow: inset 0 0 10px rgba(100, 100, 100, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}
.billRight .el-table .el-table__body-wrapper::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 10px rgba(100, 100, 100, 0.3);
  -webkit-box-shadow: inset 0 0 10px rgba(100, 100, 100, 0.3);
  background-color: #eee;
}
.billRight .el-table td.gutter,
.el-table th.gutter {
  display: block !important;
  width: 10px !important;
  height: 48px;
  border-right-width: 0;
  border-bottom-width: 0;
  padding: 0;
}
.billLeft .list {
  height: calc(100vh - 380px);
}
.billLeft .listThree {
  height: calc(100vh - 392px) !important;
}
.billLeft .listFour {
  height: calc(100vh - 316px) !important;
}
.billLeft .list .ul {
  height: calc(100vh - 460px);
}
.billLeft .listThree .ul {
  height: calc(100vh - 472px) !important;
}
.billLeft .listFour .ul {
  height: calc(100vh - 336px) !important;
}
.billLeft .meal {
  height: calc(100vh - 260px);
}
.billLeft .mealTwo {
  height: calc(100vh - 336px) !important;
}
.right_footer .f_remark .el-textarea {
  width: calc(100vw - 715px);
}
.el-autocomplete-suggestion {
  width: 302px !important;
}
.el-autocomplete-suggestion li {
  padding: 0 !important;
}
.allListClass {
  width: 100%;
}
.allListClass .alcInfo {
  padding-bottom: 10px;
  background-color: #ffffff;
  color: #333;
}
.allListClass h1 {
  height: 35px;
  background-color: #f5f7fa;
  color: #999;
  font-size: 14px;
  padding: 0 20px;
}
.allListClass h6 {
  height: 14px;
  line-height: 14px;
  font-size: 12px;
  color: #999;
  padding: 0 20px;
}
.allListClass h5 {
  height: 16px;
  line-height: 16px;
  font-size: 14px;
  padding: 10px 20px 5px 20px;
}
.allListClass h5 span {
  float: left;
  width: 160px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.allListClass h5 samp {
  float: right;
  width: 100px;
  text-align: right;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.allListClass p {
  height: 35px;
  background-color: #ffffff;
  color: #333;
  font-size: 14px;
  padding: 0 20px;
}
.allListClass p span {
  float: left;
  width: 160px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.allListClass p samp {
  float: right;
  width: 100px;
  text-align: right;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.df_input {
  width: 80px !important;
  float: left;
  margin-right: 5px;
}
.check_in_list {
  margin: 0 21px;
}
.check_in_list:first-of-type {
  margin-top: 21px;
}
.check_in_list:last-of-type {
  margin-bottom: 21px;
}
.errorInput .el-input__inner {
  border: 1px solid #F56C6C;
  border-radius: 4px;
}
.el-badge__content.is-fixed {
  right: 20px;
}
</style>
